var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRalewayLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20170731 at Sat Feb  6 03:09:45 2016\n By Aleksey,,,\nCopyright (c) 2010 - 2013, Matt McInerney (matt@pixelspread.com), Pablo Impallari (impallari@gmail.com), Rodrigo Fuenzalida (hello@rfuenzalida.com) with Reserved Font Name \"Raleway\"\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Raleway-Light",
    horizAdvX: 612
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Raleway Light",
    fontWeight: 300,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 11 4 3 3 1 1 6 0 3",
    ascent: 800,
    descent: -200,
    xHeight: 520,
    capHeight: 710,
    bbox: "-220 -223 1308 936",
    underlineThickness: 50,
    underlinePosition: -150,
    unicodeRange: "U+0020-FB06"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f",
    unicode: "ff",
    horizAdvX: 565,
    d: "M501 695q-36 0 -60.5 -14.5t-39.5 -37t-21.5 -50.5t-6.5 -55v-18h172v-41h-172v-479h-50v479h-172v-479h-50v479h-73v41h73v8q0 32 9 63t28 55.5t48 39.5t69 15q35 0 63 -8.5t44 -18.5q21 30 52 48t78 18q24 0 41 -4.5t28.5 -10t18.5 -11t10 -7.5l-18 -36 q-8 7 -23.5 15.5t-47.5 8.5zM323 520q0 33 5 62.5t17 52.5q-17 13 -41 17t-41 4q-33 0 -54.5 -12t-34 -30.5t-18 -41t-5.5 -43.5v-9h172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_i",
    unicode: "fi",
    horizAdvX: 484,
    d: "M101 479h-73v41h73v17q0 34 10 70.5t31 65.5t54.5 48t80.5 19q27 0 50.5 -5t41.5 -11.5t30 -14t17 -11.5l-25 -35q-14 13 -44 22.5t-68 9.5q-34 0 -58.5 -14.5t-40 -37t-22.5 -50.5t-7 -55v-18h255v-520h-50v479h-205v-479h-50v479z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_l",
    unicode: "fl",
    horizAdvX: 562,
    d: "M564 8q0 -1 -8 -3t-20 -4.5t-27 -4.5t-30 -2q-45 0 -69 27t-24 63v503q0 19 -6 38.5t-19.5 35t-35.5 25t-54 9.5t-54.5 -13.5t-37 -35.5t-21.5 -50.5t-7 -59.5v-16h116v-41h-116v-479h-50v479h-73v41h73v20q0 43 10 79.5t31 63.5t53 42t76 15q40 0 71 -11t52 -30.5 t31.5 -46t10.5 -57.5v-493q0 -21 14 -41.5t43 -20.5q20 0 39.5 5t20.5 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_i",
    unicode: "ffi",
    horizAdvX: 706,
    d: "M101 479h-73v41h73v8q0 31 9 61.5t28 55.5t48 40.5t70 15.5q35 0 62.5 -8.5t43.5 -18.5q22 30 55.5 48t81.5 18q26 0 48.5 -5t40.5 -11.5t31 -14t19 -11.5l-26 -35q-13 12 -43.5 22t-64.5 10q-36 0 -61 -14.5t-40.5 -37t-22.5 -50.5t-7 -55v-18h255v-520h-50v479h-205 v-479h-50v479h-172v-479h-50v479zM323 520q0 32 5 62t17 53q-17 13 -41 17t-41 4q-33 0 -54.5 -12.5t-34 -31t-18 -41t-5.5 -43.5v-8h172z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f_f_l",
    unicode: "ffl",
    horizAdvX: 788,
    d: "M708 -6q-48 0 -72.5 27t-24.5 63v503q0 20 -6.5 39.5t-20 34.5t-34.5 24.5t-50 9.5q-34 0 -57.5 -14t-38 -36.5t-21 -51.5t-6.5 -59v-14h115v-41h-115v-479h-50v479h-176v-479h-50v479h-73v41h73v7q0 36 10.5 67.5t30.5 55t50.5 37.5t69.5 14q36 0 59.5 -8.5t39.5 -17.5 q21 31 54.5 48t81.5 17q40 0 70.5 -11t51.5 -30.5t31.5 -46t10.5 -57.5v-493q0 -21 14 -41.5t44 -20.5q9 0 19 1.5t18.5 3.5t14.5 3.5t7 1.5l12 -42q0 -1 -8 -3t-20 -4.5t-26.5 -4.5t-27.5 -2zM327 520q0 36 4 66t13 50q-17 13 -37 16.5t-37 3.5q-32 0 -54.5 -11.5 t-37 -29.5t-21 -41t-6.5 -46v-8h176z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 257
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 243,
    d: "M96 218v499h51v-499h-51zM96 0v102h51v-102h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 264,
    d: "M70 540v174h45v-174h-45zM149 540v174h44v-174h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 669,
    d: "M631 466h-125l-51 -213h134v-41h-144l-52 -212h-44l53 212h-208l-52 -212h-44l53 212h-113v41h122l52 213h-133v39h143l49 205h44l-50 -205h208l49 205h44l-50 -205h115v-39zM412 253l51 213h-208l-52 -213h209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 617,
    d: "M513 592q-68 76 -189 77v-291h3q57 -12 103.5 -26.5t79 -36.5t50 -54t17.5 -79t-18 -82t-51 -58.5t-79 -35.5t-102 -12v-93h-31v94q-149 8 -254 105l27 41q41 -43 99 -70t130 -32v295q-56 12 -99.5 25.5t-72.5 34t-44 49.5t-15 73q0 45 16.5 81t46.5 61t72.5 39.5 t93.5 16.5v101h31v-100q66 -2 118 -22.5t94 -60.5zM523 176q0 33 -12.5 57t-37 41.5t-62 30t-87.5 24.5v-290h1q93 0 145.5 34t52.5 103zM119 523q0 -32 10 -53.5t32 -37t56 -27t81 -21.5v284q-94 -4 -136.5 -43t-42.5 -102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 698,
    d: "M188 437q-30 0 -56.5 11t-46 30t-31 45t-11.5 55q0 30 11.5 55.5t31 45t46 30.5t56.5 11t56.5 -11t46 -30.5t31 -45t11.5 -55.5q0 -29 -11.5 -55t-31 -45t-46 -30t-56.5 -11zM188 469q22 0 41.5 9t33.5 24t22.5 35t8.5 41q0 23 -8.5 43t-23.5 35t-34 23.5t-40 8.5 q-22 0 -41 -9t-33.5 -24t-22.5 -35t-8 -42q0 -23 8.5 -42.5t22.5 -34.5t33.5 -23.5t40.5 -8.5zM510 -10q-30 0 -56.5 11t-46 30.5t-31 45t-11.5 55.5q0 29 11.5 55t31 45t46 30t56.5 11t56.5 -11t46 -30t31 -45t11.5 -55q0 -30 -11.5 -55.5t-31 -45t-46 -30.5t-56.5 -11z M510 22q22 0 41.5 9t33.5 24t22.5 35t8.5 42t-8.5 42t-23.5 35t-34 23.5t-40 8.5q-22 0 -41 -9t-33.5 -24t-22.5 -35t-8 -41q0 -23 8 -43t22.5 -35t33.5 -23.5t41 -8.5zM59 21l279 344l274 348l28 -23l-279 -345l-275 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 655,
    d: "M581 0l-91 95q-41 -48 -96 -76.5t-122 -28.5q-44 0 -84.5 13t-71.5 37.5t-49 59t-18 78.5q0 36 12.5 66.5t34 56t50 48.5t60.5 44q-28 30 -47.5 54.5t-31.5 44.5t-17.5 38.5t-5.5 36.5q0 31 13.5 58.5t36.5 48.5t55 33t69 12q34 0 63 -10.5t50.5 -28.5t33.5 -43t12 -54 q0 -30 -13 -56.5t-35.5 -50t-52 -45t-61.5 -43.5l214 -222q22 39 34 85.5t12 96.5h44q-2 -120 -60 -214l129 -134h-67zM278 31q57 0 103 25.5t80 68.5l-226 237q-29 -20 -53.5 -40t-43.5 -42.5t-29.5 -48t-10.5 -55.5q0 -36 16 -63t41.5 -45.5t58 -27.5t64.5 -9zM151 568 q0 -13 3.5 -26t14 -30t29 -39.5t47.5 -53.5q66 43 106 79.5t40 82.5q0 42 -32 69.5t-82 27.5q-27 0 -50 -9t-40 -24t-26.5 -35t-9.5 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 185,
    d: "M70 539v175h45v-175h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 256,
    d: "M46 345q0 51 11 100.5t29.5 97.5t43.5 95.5t53 95.5l39 -20q-22 -32 -45 -76.5t-41.5 -94.5t-30.5 -102t-12 -99q0 -78 34 -170.5t95 -182.5l-38 -22q-64 94 -101 189t-37 189z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 255,
    d: "M209 345q0 -94 -36.5 -189t-100.5 -189l-38 22q60 90 94 182.5t34 170.5q0 47 -12 99t-31 102t-41.5 94.5t-44.5 76.5l39 20q28 -48 53 -95.5t44 -95.5t29.5 -97.5t10.5 -100.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 314,
    d: "M90 553l42 60l-68 22l9 29l68 -24v72h31v-72l69 24l9 -29l-68 -22l43 -60l-26 -18l-42 61l-42 -61z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 414,
    d: "M360 376v-42h-130v-141h-46v141h-131v42h131v141h46v-141h130z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 238,
    d: "M97 -81l15 79h-18v87h51v-87l-21 -79h-27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 422,
    d: "M67 249v46h288v-46h-288z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 177,
    d: "M67 0v85h44v-85h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 579,
    d: "M551 710l-467 -710h-57l466 710h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 611,
    d: "M554 293q0 -66 -18.5 -121.5t-52 -96t-79 -63t-99.5 -22.5t-99.5 22.5t-78.5 63t-51.5 96t-18.5 121.5t18.5 121.5t51.5 96t78.5 63.5t99.5 23t99.5 -23t79 -63.5t52 -96t18.5 -121.5zM503 293q0 57 -14.5 104.5t-40.5 81t-62.5 52.5t-80.5 19t-80.5 -19t-62.5 -52.5 t-40.5 -81t-14.5 -104.5t14.5 -104t40.5 -81t62.5 -52.5t80.5 -18.5t80.5 18.5t62.5 52.5t40.5 81t14.5 104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 408,
    d: "M387 46v-46h-319v46h142v462q-9 -12 -28 -26t-43 -26.5t-49 -21t-45 -8.5v50q25 0 53 13.5t52.5 30.5t41 32.5t18.5 18.5h50v-525h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 508,
    d: "M45 0q0 28 5 62.5t22.5 70t51 69t89.5 60.5q28 14 60 28t59 32.5t45 42.5t18 58q0 20 -9 40t-26.5 36t-44.5 26t-63 10q-35 0 -62.5 -10t-48 -24t-34 -28t-19.5 -22l-34 35l19.5 19.5t41.5 32t62.5 30t81.5 13.5t80.5 -12.5t60 -34t37 -50t12.5 -59.5q0 -41 -20 -71 t-49 -52.5t-60.5 -37.5t-54.5 -25q-78 -33 -119.5 -78.5t-43.5 -114.5h358v-46h-415z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 529,
    d: "M330 236q68 -11 109 -61t41 -123q0 -45 -16.5 -81.5t-46 -62.5t-70.5 -40.5t-91 -14.5q-75 0 -132 32t-83 88l37 30q20 -48 66 -76t113 -28q79 0 125 41t46 114t-47.5 116t-134.5 43h-24v44h26q81 0 124 36.5t43 97.5q0 33 -12 58.5t-33 43.5t-50 27.5t-63 9.5 q-60 0 -105 -27.5t-66 -74.5l-34 28q12 27 32.5 49t48 38t60 24.5t68.5 8.5q45 0 82.5 -13t65 -37t43 -57t15.5 -73q0 -31 -9.5 -58t-27.5 -48t-43.5 -35.5t-56.5 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    horizAdvX: 536,
    d: "M367 -127v186h-346v44l361 468h35v-466h88v-46h-88v-186h-50zM77 105h294v385z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 542,
    d: "M274 310q48 0 90 -16.5t73.5 -46.5t49.5 -71.5t18 -91.5q0 -53 -19.5 -95.5t-52.5 -73.5t-77 -47.5t-93 -16.5q-76 0 -136.5 38.5t-90.5 101.5l37 21q27 -52 78 -83.5t112 -31.5q40 0 75 13.5t60.5 38.5t40.5 59t15 76q0 40 -14.5 73t-39.5 57t-58.5 37t-72.5 13 q-51 0 -96 -22.5t-74 -64.5h-48q1 7 5.5 28t10 50t12.5 64l14 70q17 82 37 182h340v-47h-302l-56 -281q30 32 72 49.5t90 17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 600,
    d: "M556 233q0 -51 -19 -95t-53 -77t-79.5 -52t-97.5 -19q-55 0 -101.5 20t-80 57t-52.5 90.5t-19 121.5q0 112 19 194t53 136t81.5 80t104.5 26q72 0 127.5 -37t82.5 -101l-35 -27q-20 54 -68 87t-107 33q-47 0 -85.5 -22.5t-65.5 -66t-42.5 -106.5t-15.5 -144 q11 32 32 58.5t48.5 45.5t60.5 29.5t69 10.5q51 0 95 -19t77 -52t52 -77t19 -94zM308 35q41 0 77.5 15.5t63.5 42.5t43 63t16 77t-16 77t-43 63t-63.5 43t-77.5 16t-77.5 -16t-63.5 -43t-43 -63t-16 -77t16 -77t43 -63t63.5 -42.5t77.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 535,
    d: "M439 536h-399v47h479l-361 -710h-57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    horizAdvX: 589,
    d: "M537 194q0 -46 -20 -83t-53.5 -63.5t-78.5 -40.5t-94 -14q-53 0 -97.5 16.5t-76 44t-49 64.5t-17.5 79q0 35 13 65t34.5 53.5t48.5 40t55 25.5q-26 9 -48.5 24t-40 34t-27.5 43t-10 51q0 43 19.5 76t50.5 55.5t70.5 34t78.5 11.5t78 -11.5t70 -34t50.5 -55t19.5 -75.5 q0 -28 -10.5 -51.5t-27.5 -43t-40.5 -34.5t-48.5 -24q31 -11 59 -28.5t48 -41.5t32 -53.5t12 -63.5zM487 198q0 38 -17.5 68t-45.5 50.5t-62.5 31.5t-68.5 11q-35 0 -69 -11.5t-61 -32.5t-44 -51t-17 -67q0 -38 17.5 -67.5t45.5 -50t62.5 -31.5t68.5 -11t68.5 11.5 t61.5 32.5t44 50.5t17 66.5zM127 531q0 -32 15.5 -56t39.5 -41t53.5 -25.5t58.5 -8.5t59 9t54 26t39.5 41.5t15.5 56.5q0 31 -14.5 55.5t-38 41t-54 25.5t-62.5 9t-62 -9t-53 -26.5t-37 -42t-14 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 583,
    d: "M37 328q0 51 19 95t53 77t79 52t98 19q55 0 101 -20t80 -57t53 -91t19 -121q0 -112 -19 -194t-53 -136t-81.5 -80t-104.5 -26q-72 0 -127.5 37t-82.5 101l35 27q20 -54 68 -87t107 -33q47 0 85.5 22.5t65.5 66t42.5 106.5t15.5 144q-11 -32 -32 -58.5t-48.5 -45.5 t-60.5 -29.5t-69 -10.5q-51 0 -95 19t-77 52t-52 77t-19 94zM285 526q-41 0 -77.5 -15.5t-63.5 -42.5t-43 -63t-16 -77t16 -77t43 -63t63.5 -43t77.5 -16t77.5 16t63.5 43t43 63t16 77q0 40 -16 76t-43 63t-63.5 43t-77.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 177,
    d: "M67 432v85h43v-85h-43zM67 0v85h43v-85h-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 191,
    d: "M71 432v85h44v-85h-44zM74 -81l14 79h-18v87h51v-87l-20 -79h-27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 506,
    d: "M34 273l418 251v-54l-346 -211l346 -211v-55l-418 250v30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 437,
    d: "M69 208v38h299v-38h-299zM69 306v38h299v-38h-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 506,
    d: "M472 243l-418 -250v55l345 211l-345 211v54l418 -251v-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 473,
    d: "M163 193q0 39 5.5 67t16.5 48.5t27 35t36 26.5q21 12 46 24.5t46.5 30t35.5 43.5t14 65q0 36 -12.5 63t-33 45t-47 26.5t-54.5 8.5q-57 0 -103 -30t-69 -78l-36 22q13 31 35.5 55t50 40.5t59 25t63.5 8.5q37 0 71.5 -12t61.5 -35.5t43 -59t16 -82.5q0 -42 -12.5 -71 t-33 -49t-46.5 -34.5t-52 -26.5q-21 -10 -36.5 -20.5t-26 -27.5t-16 -43t-5.5 -65h-44zM164 0v98h44v-98h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 834,
    d: "M416 603q74 0 139.5 -28.5t115 -79t78 -120.5t28.5 -153q0 -14 -1.5 -37.5t-6.5 -50t-14.5 -53.5t-25.5 -48.5t-39.5 -35t-56.5 -13.5q-25 0 -40 7.5t-23.5 20.5t-12 30.5t-5.5 36.5q-27 -29 -71.5 -50t-96.5 -21q-69 0 -109 37t-40 94q0 37 16.5 62.5t43 40.5t59 21.5 t65.5 6.5q45 0 79 -8.5t51 -14.5q0 38 -6 69.5t-20 54t-39 35t-62 12.5q-38 0 -74.5 -12.5t-66.5 -35.5l-16 31q35 23 75.5 37.5t85.5 14.5q53 0 84.5 -18t48 -47.5t21.5 -66t5 -72.5v-138q0 -22 1.5 -40t7 -30.5t16 -19t27.5 -6.5q32 0 53.5 22t34 53.5t17.5 67.5t5 65 q0 73 -25.5 137.5t-70.5 111.5t-105.5 74.5t-130.5 27.5q-68 0 -129 -25.5t-107.5 -71.5t-73.5 -109t-27 -138q0 -72 25.5 -135.5t70.5 -110.5t106 -74t131 -27q80 0 153 38l12 -27q-79 -40 -165 -40q-75 0 -141 28.5t-115.5 79t-78 119t-28.5 149.5q0 84 30.5 152.5 t81.5 117.5t117.5 76t138.5 27zM480 64q22 10 35.5 23t21 27.5t9.5 29t2 29.5v42q-6 1 -18 4.5t-28.5 7.5t-38.5 7.5t-47 3.5q-27 0 -53 -5t-46.5 -16t-32.5 -29.5t-12 -46.5q0 -46 33 -72.5t81 -26.5q25 0 50 6.5t44 15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 675,
    d: "M316 710h44l300 -710h-54l-99 234h-339l-99 -234h-55zM493 276l-155 372l-158 -372h313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 662,
    d: "M616 184q0 -39 -15 -72.5t-41 -58.5t-61 -39t-74 -14h-332v710h331q37 0 67 -16t51 -41.5t32.5 -58t11.5 -65.5q0 -54 -27 -99t-75 -66q61 -18 96.5 -67.5t35.5 -112.5zM565 191q0 28 -10 54.5t-28 47t-42.5 32.5t-52.5 12h-288v-291h281q30 0 55.5 12t44 32.5t29.5 46.5 t11 54zM144 664v-284h260q29 0 53 12t41.5 31.5t27.5 45.5t10 53q0 29 -9.5 54.5t-26 45t-39.5 31t-51 11.5h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 690,
    d: "M44 360q0 64 22.5 127.5t65.5 113.5t105.5 81.5t142.5 31.5q95 0 162 -43.5t100 -111.5l-42 -24q-19 37 -44.5 62t-55 40.5t-61.5 22.5t-63 7q-68 0 -120 -27.5t-88 -71.5t-54.5 -99.5t-18.5 -111.5q0 -63 22 -120t60 -100.5t90 -69.5t112 -26q32 0 66 8t65 25t58 43.5 t45 62.5l44 -21q-18 -40 -49 -71t-69 -52t-80.5 -31.5t-83.5 -10.5q-73 0 -133.5 32t-104.5 83.5t-68.5 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 713,
    d: "M93 0v710h236q84 0 147.5 -28t105.5 -76t63 -112.5t21 -137.5q0 -81 -23.5 -146.5t-67.5 -112t-106.5 -72t-139.5 -25.5h-236zM615 356q0 67 -19 123.5t-55.5 97.5t-89.5 64t-122 23h-185v-618h185q70 0 123.5 23.5t89.5 65.5t54.5 98.5t18.5 122.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    d: "M566 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 594,
    d: "M93 0v710h462v-46h-411v-282h349v-44h-349v-338h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 717,
    d: "M616 111q-103 -116 -239 -116q-72 0 -133.5 31t-105.5 82t-69 116t-25 132q0 70 24.5 135t68 115t103.5 79.5t131 29.5q53 0 95.5 -11.5t76 -32t58 -49t41.5 -62.5l-42 -25q-36 70 -95.5 101.5t-134.5 31.5q-63 0 -114 -27t-87 -71t-55 -100t-19 -115q0 -63 22 -119.5 t60.5 -99.5t90.5 -68.5t112 -25.5q65 0 123.5 30t112.5 95v137h-161v41h205v-345h-44v111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 735,
    d: "M643 710v-710h-51v340h-448v-340h-51v710h51v-324h448v324h51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 237,
    d: "M93 0v710h51v-710h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 478,
    d: "M32 74q25 -17 60 -27.5t78 -10.5q58 0 92 21t52 61t23.5 98.5t5.5 132.5v361h51v-361q0 -81 -7 -147.5t-30.5 -113.5t-67.5 -73t-119 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 635,
    d: "M93 0v710h51v-431l414 431h59l-295 -311l310 -399h-58l-285 368l-145 -149v-219h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 581,
    d: "M93 0v710h51v-664h424v-46h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 880,
    d: "M736 0v614l-280 -479h-32l-280 479v-614h-51v710h51l296 -508l296 508h51v-710h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 773,
    d: "M144 614v-614h-51v710h39l498 -625v625h51v-710h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 753,
    d: "M376 -5q-74 0 -135 31t-105 81t-68 115t-24 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -130.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5zM95 355q0 -61 20.5 -117.5t58 -100t89.5 -69.5t114 -26 q64 0 115.5 27t88 71.5t56.5 100.5t20 114q0 61 -21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 621,
    d: "M93 0v710h292q45 0 83 -19t65.5 -50.5t43 -71t15.5 -79.5q0 -43 -14.5 -83t-41 -71t-63.5 -49.5t-82 -18.5h-247v-268h-51zM144 315h245q35 0 63 14.5t47.5 39t30 56t10.5 65.5q0 35 -12.5 66.5t-34 55.5t-50 38t-60.5 14h-239v-349z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 752,
    d: "M576 67q-42 -34 -92.5 -53t-107.5 -19q-74 0 -135 31t-105 81t-68 115t-24 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -130.5q0 -75 -27.5 -142t-75.5 -118l79 -95h-53zM377 42q50 0 92 16.5t76 45.5l-84 102h53l60 -73 q40 45 61.5 103t21.5 119t-21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114q0 -61 20.5 -117.5t58 -100t89.5 -69.5t114 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 649,
    d: "M93 0v710h295q45 0 83 -19t65.5 -50.5t43 -71t15.5 -79.5q0 -39 -12 -75.5t-34 -65.5t-53 -48t-68 -25l177 -276h-59l-172 268h-230v-268h-51zM144 315h249q34 0 62 15t48 39.5t30.5 56t10.5 64.5q0 34 -12.5 65.5t-34 55.5t-50 38.5t-61.5 14.5h-242v-349z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 605,
    d: "M506 592q-69 77 -195 77q-104 0 -151.5 -39.5t-47.5 -106.5q0 -34 12 -56.5t37.5 -38.5t64.5 -27t94 -23q57 -12 103.5 -26.5t79 -36.5t50 -54t17.5 -79t-18.5 -82t-52 -58.5t-80 -35.5t-103.5 -12q-166 0 -281 106l27 41q45 -47 110 -74.5t146 -27.5q93 0 145.5 34 t52.5 103q0 35 -14 59.5t-41.5 42.5t-69.5 31t-98 25q-57 12 -100.5 25.5t-73 34t-44.5 49.5t-15 73q0 48 18.5 85t51.5 62.5t79 38.5t102 13q69 0 123 -20.5t98 -62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 606,
    d: "M589 664h-260v-664h-51v664h-260v46h571v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 756,
    d: "M378 42q72 0 119.5 27t75 71t39 100t11.5 113v357h51v-357q0 -71 -15.5 -136t-50.5 -114.5t-91 -78.5t-138 -29q-85 0 -142 30.5t-91.5 81t-49 114.5t-14.5 132v357h51v-357q0 -59 11.5 -115t40 -99.5t75.5 -70t118 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 679,
    d: "M69 710l270 -646l270 646h54l-300 -710h-47l-301 710h54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1043,
    d: "M365 705h50l106 -258l106 258h50l-125 -299l149 -346l272 650h56l-304 -710h-47l-156 365l-157 -365h-47l-303 710h55l273 -650l147 346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 628,
    d: "M66 710l249 -323l248 323h58l-279 -360l271 -350h-58l-240 313l-241 -313h-59l271 350l-279 360h59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 647,
    d: "M75 710l248 -393l249 393h57l-280 -442v-268h-51v270l-279 440h56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 627,
    d: "M30 42l505 622h-498v46h558v-42l-501 -622h499v-46h-563v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 247,
    d: "M91 -40v780h101v-43h-53v-694h53v-43h-101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 548,
    d: "M86 710l435 -710h-58l-436 710h59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 247,
    d: "M54 -40v43h54v694h-54v43h101v-780h-101z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 526,
    d: "M44 303l198 407h43l197 -407h-46l-172 356l-176 -356h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 519,
    d: "M66 -46v46h386v-46h-386z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 213,
    d: "M49 730h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 537,
    d: "M206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68.5 32t88 11.5q42 0 84.5 -7.5t76.5 -20.5v51q0 74 -42 117.5t-114 43.5q-38 0 -80.5 -16t-86.5 -46l-19 34q100 68 190 68q94 0 148 -54.5t54 -150.5v-254q0 -25 22 -25v-45q-5 -1 -10.5 -1.5 t-9.5 -0.5q-20 0 -32 13.5t-14 32.5v43q-36 -47 -92 -72t-121 -25zM216 30q58 0 106.5 22t74.5 58q16 21 16 40v92q-36 14 -75 21t-81 7q-39 0 -71 -8.5t-55 -23.5t-35.5 -36.5t-12.5 -47.5t10 -49t28 -39.5t42.5 -26t52.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    d: "M321 -10q-61 0 -114 32t-83 82v-104h-46v730h50v-323q37 54 87.5 88t116.5 34q55 0 99.5 -23.5t75 -62t47 -87t16.5 -98.5q0 -54 -19 -102.5t-52.5 -85t-79 -58.5t-98.5 -22zM311 35q46 0 84 19t65.5 50.5t43 71.5t15.5 82q0 44 -14.5 84.5t-41 72t-63 50.5t-80.5 19 q-33 0 -62 -11.5t-53.5 -30.5t-44 -44t-32.5 -52v-172q3 -29 22 -54.5t45.5 -44t57.5 -29.5t58 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 545,
    d: "M42 262q0 55 19 104t53 85t81 57t103 21q71 0 125 -32t81 -89l-49 -16q-23 43 -65.5 67.5t-93.5 24.5q-43 0 -80 -17t-64.5 -47t-43.5 -70.5t-16 -87.5t16.5 -88.5t44 -72t65 -48.5t79.5 -18q27 0 53.5 8t49 21t39 30.5t22.5 36.5l49 -14q-10 -27 -30.5 -50.5 t-48.5 -40.5t-62 -26.5t-70 -9.5q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 615,
    d: "M292 -10q-54 0 -100 22.5t-79.5 60t-52 86t-18.5 100.5q0 54 18 103t50 86t75.5 59t95.5 22q34 0 64 -10t56 -26.5t47 -38.5t36 -47v323h50v-660q0 -25 21 -25v-45q-6 -1 -10 -1.5t-8 -0.5q-20 0 -34 15.5t-14 32.5v58q-32 -52 -85.5 -83t-111.5 -31zM301 35q27 0 58 11 t57.5 30.5t45.5 44.5t22 54v171q-11 28 -31.5 53.5t-46.5 44t-56 29.5t-58 11q-45 0 -82 -19.5t-63 -51t-40 -72t-14 -83.5q0 -45 16 -85t44.5 -71t66 -49t81.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 583,
    d: "M299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12 q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 318,
    d: "M101 0v479h-73v41h73v17q0 96 39 149.5t108 53.5q30 0 58 -9t46 -24l-18 -36q-14 11 -34.5 18t-42.5 7q-51 0 -78.5 -40.5t-27.5 -117.5v-18h148v-41h-148v-479h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    d: "M288 -8q-54 0 -99 22.5t-77.5 60t-51 85.5t-18.5 99q0 53 17.5 102t49.5 86.5t76.5 59.5t98.5 22q68 0 118.5 -35.5t85.5 -86.5v113h46v-530q0 -53 -20 -93t-53.5 -66.5t-78 -40t-93.5 -13.5q-45 0 -81 8.5t-63.5 24t-49 38t-37.5 49.5l34 23q31 -53 84 -77.5t113 -24.5 q40 0 75.5 11t62 32.5t42 53.5t15.5 75v114q-32 -51 -85 -81.5t-111 -30.5zM300 35q33 0 64.5 12.5t57 32.5t42 45t20.5 50v171q-12 30 -32 55.5t-45.5 43.5t-55 28.5t-59.5 10.5q-47 0 -84 -20t-62.5 -52t-39 -72.5t-13.5 -81.5q0 -45 16 -85t44 -71t66 -49t81 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 576,
    d: "M503 0h-50v290q0 193 -129 193q-32 0 -62.5 -12t-57 -34t-46.5 -51.5t-30 -63.5v-322h-50v730h50v-334q32 61 88.5 97t121.5 36q43 0 74 -16t51.5 -46t30 -72.5t9.5 -95.5v-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 207,
    d: "M78 0v520h50v-520h-50zM78 638v92h50v-92h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 214,
    d: "M-10 -177q-32 0 -59.5 8.5t-49.5 28.5l27 33q17 -14 37 -19t40 -5q19 0 37 7.5t32 21t23 32t9 40.5v550h50v-548q0 -33 -12.5 -60t-33.5 -47t-47 -31t-53 -11zM86 638v92h50v-92h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 522,
    d: "M454 0l-203 278l-123 -113v-165h-50v730h50v-510l316 299h58l-217 -211l224 -308h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 259,
    d: "M82 730h51v-627q0 -29 16.5 -46t45.5 -17q11 0 26.5 2.5t28.5 7.5l10 -40q-17 -7 -42 -11.5t-43 -4.5q-42 0 -67.5 25.5t-25.5 68.5v642z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 915,
    d: "M842 0h-50v290q0 99 -30.5 146t-93.5 47q-32 0 -61 -12t-53 -33.5t-41.5 -51t-27.5 -65.5v-321h-50v290q0 100 -30 146.5t-93 46.5q-32 0 -60.5 -11.5t-52.5 -33t-42.5 -51t-28.5 -65.5v-322h-50v520h47v-124q32 63 84 98t115 35q66 0 107 -39t49 -102q74 141 204 141 q85 0 121.5 -60.5t36.5 -169.5v-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 576,
    d: "M503 0h-50v290q0 101 -28.5 147t-90.5 46q-33 0 -65.5 -12t-60.5 -34t-49 -51.5t-31 -63.5v-322h-50v520h47v-124q16 30 39.5 54.5t53 42t62.5 27t68 9.5q85 0 120 -59.5t35 -170.5v-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 592,
    d: "M296 -10q-55 0 -101.5 21.5t-80.5 58.5t-53 86t-19 103q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5t100 -21.5t80.5 -58.5t54 -86t19.5 -104q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5zM92 257q0 -46 16 -86.5t43.5 -70.5t64.5 -47.5t79 -17.5t79 17.5 t65 48.5t44 71.5t16 87.5q0 46 -16 86.5t-44 71t-64.5 48.5t-78.5 18t-79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    d: "M332 -10q-67 0 -119.5 35.5t-84.5 86.5v-325h-50v733h46v-104q32 50 84.5 81.5t112.5 31.5q54 0 100 -23t79 -60.5t51.5 -86.5t18.5 -100q0 -54 -17 -103t-48.5 -86t-75.5 -58.5t-97 -21.5zM320 35q45 0 82 19t63 50.5t40 72t14 82.5q0 45 -16 85.5t-44.5 71.5 t-66.5 49.5t-81 18.5q-27 0 -57.5 -11.5t-57.5 -31t-46 -44.5t-22 -53v-171q13 -29 33 -54t45 -44t54 -29.5t60 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    d: "M280 -10q-54 0 -97.5 22.5t-75 60t-48.5 86t-17 100.5q0 54 19.5 103t53 86t79 59t97.5 22q61 0 114 -32.5t83 -81.5v105h46v-661q0 -25 21 -26v-44q-5 -1 -9 -1h-8q-23 0 -38.5 14.5t-15.5 38.5v271q-82 -122 -204 -122zM293 35q33 0 61.5 11t52.5 29t43.5 42.5 t33.5 51.5v170q-4 29 -22 55t-44.5 46t-57.5 32t-61 12q-45 0 -83 -19.5t-65.5 -51t-42.5 -72.5t-15 -83q0 -45 15 -85t41.5 -71t63 -49t80.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 341,
    d: "M324 475q-70 -2 -122.5 -41.5t-73.5 -108.5v-325h-50v520h48v-128q27 55 71.5 89.5t95.5 39.5q10 1 18 1h13v-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 481,
    d: "M243 -10q-60 0 -115 20t-96 60l25 34q42 -38 87 -56t99 -18q68 0 109.5 28.5t41.5 79.5q0 24 -10.5 40.5t-31.5 28t-52 20.5t-72 19q-44 10 -76.5 20t-53.5 24t-31.5 34t-10.5 51q0 39 15 68t41.5 48t61 28.5t73.5 9.5q61 0 108 -20.5t73 -52.5l-28 -27q-26 30 -67.5 45 t-88.5 15q-29 0 -54.5 -6t-44.5 -19t-30 -33.5t-11 -48.5q0 -23 7.5 -37t24 -24t42.5 -17.5t62 -16.5q49 -12 87 -23t63.5 -27t39 -38t13.5 -56q0 -70 -54.5 -111.5t-145.5 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 320,
    d: "M310 25q-4 -2 -13.5 -7.5t-24 -10.5t-32.5 -9t-39 -4t-39.5 6t-32.5 18t-22 29t-8 40v392h-73v41h73v178h50v-178h121v-41h-121v-380q0 -29 20 -43.5t45 -14.5q31 0 53.5 10.5t27.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 587,
    d: "M239 -10q-166 0 -166 230v300h50v-293q0 -192 131 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-5 -1 -9 -1h-6q-20 0 -35.5 12.5t-15.5 33.5v78q-34 -63 -93.5 -98t-128.5 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 528,
    d: "M238 0l-217 520h52l192 -470l193 470h49l-217 -520h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 806,
    d: "M737 520h50l-225 -520h-42l-117 275l-117 -275h-42l-225 520h49l199 -465l109 256l-88 208h43l72 -172l71 172h44l-88 -208l109 -256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 496,
    d: "M72 520l168 -215l8 -14l8 14l167 215h56l-202 -261l201 -259h-55l-167 214l-8 13l-8 -13l-167 -214h-55l201 259l-202 261h55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 540,
    d: "M113 -176q5 -1 15 -1t18.5 1t16.5 5q6 3 11 8.5t14 22.5t23 50t38 90l-232 520h52l207 -471l193 471h49l-285 -684q-11 -28 -35.5 -43.5t-66.5 -15.5h-8.5t-9.5 1v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 490,
    d: "M32 36l368 445h-362v39h418v-36l-367 -445h365v-39h-422v36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 248,
    d: "M141 697v-277q0 -10 -4.5 -28t-20.5 -32q16 -14 20.5 -32.5t4.5 -27.5v-288h55v-43h-79q-8 0 -15.5 6.5t-7.5 23.5v290q0 18 -8.5 34t-26.5 18v40q10 0 17 6t11 14t5.5 16.5t1.5 13.5v279q0 20 9 25t14 5h79v-43h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 223,
    d: "M89 -130v905h45v-905h-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 248,
    d: "M52 697v43h79q4 0 13.5 -5t9.5 -25v-279q0 -5 1.5 -13.5t5.5 -16.5t10.5 -14t17.5 -6v-40q-19 -2 -27 -18t-8 -34v-290q0 -17 -7.5 -23.5t-15.5 -6.5h-79v43h55v288q0 9 4.5 27.5t20.5 32.5q-16 14 -20.5 32t-4.5 28v277h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 493,
    d: "M68 245q0 3 5 18.5t17 32.5t30.5 30.5t45.5 13.5q22 0 41.5 -9.5t38.5 -20.5t37.5 -20.5t38.5 -9.5q19 0 32 7.5t21.5 17t12.5 18t4 10.5h34q0 -2 -5 -15.5t-17 -30t-32 -29.5t-50 -13q-24 0 -45 9t-40 20.5t-36.5 20.5t-34.5 9t-29 -9t-20 -20t-11.5 -20t-3.5 -10h-34v0 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 257
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 242,
    d: "M146 498v-499h-50v499h50zM146 716v-102h-50v102h50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 554,
    d: "M276 -120v111q-51 4 -93.5 28.5t-73.5 61.5t-48 83t-17 94q0 51 16.5 98t47 83.5t73 60.5t95.5 28v117h31v-117q76 -2 124.5 -34t74.5 -86l-48 -16q-25 45 -64 67t-87 24v-447q21 0 46 7t47.5 19.5t40 30t23.5 38.5l49 -14q-11 -32 -34.5 -55.5t-52.5 -39.5t-60.5 -24 t-58.5 -8v-110h-31zM95 258q0 -41 13.5 -78.5t38 -67.5t57.5 -49.5t72 -24.5v443q-43 -3 -76.5 -23.5t-57 -52t-35.5 -70t-12 -77.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 487,
    d: "M50 370h100q-12 22 -24.5 43t-23 42t-17.5 43.5t-7 47.5q0 35 14 65.5t37.5 53.5t55.5 36.5t68 13.5q53 0 99 -28.5t75 -76.5l-32 -31q-24 43 -63 68t-81 25q-26 0 -48.5 -10t-39.5 -27.5t-27 -40.5t-10 -50q0 -23 7 -44.5t18 -42.5t24 -42.5t24 -44.5h176v-41h-159 q6 -18 9.5 -37t3.5 -40q0 -26 -5.5 -50t-18.5 -49t-34 -52t-51 -60q37 8 72 8q22 0 40.5 -3t35.5 -6.5t33.5 -6.5t35.5 -3q20 0 41.5 4.5t50.5 14.5l13 -40q-53 -24 -108 -24q-22 0 -41.5 3.5t-38.5 7.5t-38.5 7.5t-42.5 3.5t-51 -4t-52 -10l-15 37q37 37 61.5 67t39.5 55.5 t21 48.5t6 48q0 22 -4 42t-11 38h-118v41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 535,
    d: "M152 475q23 20 52 31.5t63 11.5t63.5 -12t52.5 -32l70 71l27 -26l-71 -71q17 -23 27 -51.5t10 -60.5q0 -63 -39 -113l73 -71l-24 -24l-73 70q-23 -20 -52.5 -31t-63.5 -11t-63 10.5t-52 30.5l-71 -69l-24 24l71 70q-39 50 -39 114q0 65 37 113l-69 70l26 26zM132 335 q0 -30 10.5 -55.5t29 -45t43 -30.5t52.5 -11t52.5 11.5t43 31t29 45.5t10.5 56t-10.5 56t-29 45.5t-43 30.5t-52.5 11t-52.5 -11.5t-43 -31t-29 -46t-10.5 -56.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 667,
    d: "M412 357h88v-38h-110l-32 -51v-26h142v-37h-142v-205h-51v205h-141v37h141v28l-30 49h-111v38h89l-227 353h57l248 -393l249 393h56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 226,
    d: "M136 280v-410h-45v410h45zM136 775v-410h-45v410h45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 497,
    d: "M405 190q49 -30 49 -106q0 -43 -18.5 -75.5t-47 -54t-63 -32t-67.5 -10.5q-34 0 -62.5 7.5t-52.5 20t-43.5 28.5t-35.5 32l33 31q38 -36 76.5 -53.5t83.5 -17.5q26 0 52 8.5t47 24t34 38.5t13 52q0 31 -12.5 50.5t-32.5 30t-45 14.5t-49 5q-41 2 -76 12t-60.5 29.5 t-40.5 48.5t-15 68q0 27 8.5 51t20.5 38q-24 16 -39.5 47t-15.5 72q0 38 17 68.5t44 52.5t61.5 33.5t69.5 11.5q71 0 111.5 -25.5t65.5 -62.5l-40 -18q-9 18 -24.5 29.5t-34 18t-38.5 9.5t-38 3q-26 0 -52 -8t-46 -23.5t-32.5 -38t-12.5 -50.5q0 -31 11 -52.5t30 -35 t45.5 -19.5t57.5 -6q36 0 71.5 -8t63 -26t45 -47t17.5 -71q0 -29 -9.5 -54t-23.5 -40zM121 336q0 -35 12.5 -56t32.5 -33t45.5 -17t52 -8t51 -6.5t42.5 -10.5q15 13 24 34.5t9 44.5q0 31 -14 52t-35.5 34t-47.5 18t-50 5q-55 0 -95 17q-12 -12 -19.5 -32.5t-7.5 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 294,
    d: "M57 640v88h44v-88h-44zM193 640v88h44v-88h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 829,
    d: "M414 -7q-78 0 -145 27.5t-116 76t-76.5 114.5t-27.5 144q0 77 27.5 143t76.5 114t116 75.5t145 27.5q79 0 146 -27.5t116 -75.5t76.5 -114t27.5 -143q0 -78 -27.5 -144t-76.5 -114.5t-116 -76t-146 -27.5zM414 21q71 0 132.5 24t106.5 68t71 104.5t26 134.5 q0 72 -25 133.5t-70 106.5t-106.5 70t-134.5 25q-72 0 -133.5 -25t-106 -69.5t-70 -105.5t-25.5 -133q0 -71 25 -132t70 -105.5t106.5 -70t133.5 -25.5zM421 124q-43 0 -84 16t-73 46t-51.5 73t-19.5 96q0 41 13.5 82.5t40.5 75t69 54.5t99 21q62 0 112 -27t71 -80l-48 -16 q-11 24 -27.5 39.5t-35.5 24t-38 11.5t-34 3q-44 0 -76 -17t-53 -44t-31.5 -60.5t-10.5 -66.5q0 -45 16.5 -79.5t42 -58t56 -36t59.5 -12.5q19 0 40.5 5.5t41 16t35 26t23.5 34.5l48 -14q-6 -17 -21.5 -36.5t-39.5 -36.5t-55.5 -28.5t-68.5 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 431,
    d: "M168 348q-25 0 -47 8.5t-38 23t-25 34.5t-9 43q0 47 41.5 76.5t107.5 29.5q29 0 57 -4.5t50 -13.5v31q0 45 -26.5 71.5t-74.5 26.5q-53 0 -115 -41l-17 31q70 46 135 46q69 0 108 -36.5t39 -103.5v-153q0 -19 17 -20v-43q-8 -1 -13.5 -1h-10.5q-32 3 -35 34l-1 26 q-25 -32 -62.5 -48.5t-80.5 -16.5zM180 386q35 0 66 12.5t47 33.5q12 13 12 27v55q-23 10 -48 13.5t-51 3.5q-50 0 -80 -19.5t-30 -51.5t24 -53t60 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 552,
    d: "M41 273l244 175v-45l-202 -144l202 -143v-45l-244 172v30zM243 273l244 175v-45l-202 -144l202 -143v-45l-244 172v30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 574,
    d: "M504 354v-223h-45v177h-381v46h426z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 559,
    d: "M67 249v46h425v-46h-425z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 829,
    d: "M414 -7q-78 0 -145 27.5t-116 76t-76.5 114.5t-27.5 144q0 77 27.5 143t76.5 114t116 75.5t145 27.5q79 0 146 -27.5t116 -75.5t76.5 -114t27.5 -143q0 -78 -27.5 -144t-76.5 -114.5t-116 -76t-146 -27.5zM414 21q71 0 132.5 24t106.5 68t71 105.5t26 136.5 q0 71 -25 131.5t-70 105t-106.5 70t-134.5 25.5q-72 0 -133.5 -25.5t-106 -70t-69.5 -105t-25 -131.5q0 -72 25 -133t69.5 -105.5t106 -70t133.5 -25.5zM265 581h190q29 0 53 -12.5t41.5 -32.5t27.5 -45.5t10 -51.5q0 -25 -8 -48t-22 -41.5t-34 -31t-44 -15.5l113 -178h-45 l-110 173h-132v-173h-40v456zM456 334q45 0 68.5 31t23.5 74q0 45 -27 74.5t-69 29.5h-147v-209h151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 390,
    d: "M53 672v37h285v-37h-285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 261,
    d: "M53 647q0 32 22.5 54.5t54.5 22.5q33 0 55.5 -22.5t22.5 -54.5q0 -34 -22.5 -56.5t-55.5 -22.5q-32 0 -54.5 23t-22.5 56zM98 679q-13 -15 -13 -33q0 -19 13 -32q6 -6 14 -10t18 -4t18.5 4t14.5 10q13 13 13 32q0 18 -13 33q-12 13 -33 13q-20 0 -32 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 468,
    d: "M77 70v43h314v-43h-314zM391 382v-43h-134v-144h-46v144h-134v43h134v144h46v-144h134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 381,
    d: "M37 413q0 38 8 66.5t24 49.5t39.5 36t53.5 27q23 9 47.5 17t44.5 19.5t33 28t13 40.5q0 32 -26 56t-80 24q-26 0 -46.5 -6t-36.5 -14.5t-27 -18.5t-18 -18l-24 24q3 4 14 15t30.5 22.5t47.5 20.5t65 9q35 0 61.5 -9t44 -25t26 -36.5t8.5 -44.5q0 -31 -14.5 -52.5t-36 -36 t-46 -24t-45.5 -15.5q-37 -12 -58 -27t-32 -31t-14 -32.5t-3 -30.5h247v-34h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 386,
    d: "M190 407q-63 0 -105 25t-48 67l23 21q1 -14 11.5 -28t27.5 -25t40.5 -17.5t50.5 -6.5q25 0 47 5.5t38 15.5t25.5 24t9.5 31q0 37 -40.5 58t-108.5 21h-23v32h23q64 0 99.5 17.5t35.5 52.5q0 18 -9 32t-24 24.5t-35.5 16t-43.5 5.5q-42 0 -72.5 -15.5t-44.5 -41.5l-25 26 q17 29 56 46.5t86 17.5q32 0 59.5 -8.5t47.5 -23t31.5 -34.5t11.5 -43q0 -69 -90 -87q47 -8 74.5 -35.5t27.5 -65.5q0 -24 -12.5 -44t-33.5 -34t-49.5 -21.5t-60.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 213,
    d: "M84 629l-35 16l61 85h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 613,
    d: "M85 520h50v-293q0 -192 132 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-5 -1 -8.5 -1h-6.5q-22 0 -36.5 13.5t-14.5 35.5v75q-15 -29 -37 -53.5t-49.5 -42t-58.5 -27.5t-64 -10q-51 0 -83.5 24.5t-48.5 67.5v-294h-48v732z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 588,
    d: "M33 473q0 112 74 174.5t208 62.5h226v-41h-70v-749h-45v317h-80v-317h-45v317q-62 1 -111.5 17.5t-84.5 47t-53.5 73.5t-18.5 98zM78 474q0 -50 18 -86t48.5 -59.5t71 -35.5t85.5 -14v390q-109 -1 -166 -52.5t-57 -142.5zM426 669h-80v-390h80v390z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 177,
    d: "M67 248v101h44v-101h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 271,
    d: "M37 -125q14 -7 37.5 -13t49.5 -6q58 0 58 37q0 20 -13.5 28t-35.5 8q-21 0 -44 -5t-37 -9l56 100l27 -12l-34 -56q9 4 20.5 5t19.5 1q34 0 53 -15t19 -44q0 -32 -24 -48.5t-69 -16.5q-29 0 -53.5 5.5t-43.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 264,
    d: "M243 447v-35h-194v35h82v322q-5 -6 -16.5 -14.5t-25 -16t-28 -12.5t-26.5 -5v35q16 0 32.5 8t30.5 18t23 19l10 10h36v-364h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 449,
    d: "M224 348q-39 0 -71.5 14.5t-56.5 39.5t-37 57.5t-13 68.5q0 37 13.5 70t37 58t56 39.5t71.5 14.5t71.5 -14.5t56.5 -39.5t37.5 -58t13.5 -70q0 -36 -13.5 -68.5t-37 -57.5t-56.5 -39.5t-72 -14.5zM90 527q0 -29 10.5 -55t28.5 -45.5t42.5 -30.5t52.5 -11t52.5 11.5t43 31 t29 45.5t10.5 56t-10.5 56t-29 45t-43 30t-52.5 11q-27 0 -51.5 -11t-43 -30.5t-29 -46t-10.5 -56.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 552,
    d: "M511 243l-244 -172v45l202 143l-202 144v45l244 -175v-30zM310 243l-245 -172v45l203 143l-203 144v45l245 -175v-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 795,
    d: "M668 0v106h-230v32l240 255h25v-253h57v-34h-57v-106h-35zM478 140h190v202zM120 21l279 344l274 348l28 -23l-279 -345l-275 -348zM254 367v-35h-194v35h82v322q-5 -6 -16.5 -14.5t-25 -16t-28 -12.5t-26.5 -5v35q16 0 32.5 8t30.5 18t23 19l10 10h36v-364h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 838,
    d: "M497 0q0 76 32 116.5t92 63.5q22 9 46 17t43.5 19t32 27.5t12.5 40.5q0 32 -24.5 54.5t-78.5 22.5q-26 0 -45.5 -6t-34.5 -14.5t-26 -18.5t-18 -19l-26 28q3 4 14 15t30 22.5t47 20.5t64 9q69 0 103.5 -33.5t34.5 -81.5q0 -31 -14 -52t-35 -35.5t-45 -24t-45 -15.5 q-36 -11 -57 -24.5t-32 -29.5t-14 -33t-3 -35h246v-34h-299zM89 21l279 344l274 348l28 -23l-279 -345l-275 -348zM256 367v-35h-194v35h82v322q-5 -6 -16.5 -14.5t-25 -16t-28 -12.5t-26.5 -5v35q16 0 32.5 8t30.5 18t23 19l10 10h36v-364h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 810,
    d: "M196 327q-63 0 -105 25t-48 67l23 21q1 -14 11.5 -28t27.5 -25t40.5 -17.5t50.5 -6.5q25 0 47 5.5t38 15.5t25.5 24t9.5 31q0 37 -40.5 58t-108.5 21h-23v32h23q64 0 99.5 17.5t35.5 52.5q0 18 -9 32t-24 24.5t-35.5 16t-43.5 5.5q-42 0 -72.5 -15.5t-44.5 -41.5l-25 26 q17 29 56 46.5t86 17.5q32 0 59.5 -8.5t47.5 -23t31.5 -34.5t11.5 -43q0 -69 -90 -87q47 -8 74.5 -35.5t27.5 -65.5q0 -24 -12.5 -44t-33.5 -34t-49.5 -21.5t-60.5 -7.5zM679 0v106h-230v32l240 255h25v-253h57v-34h-57v-106h-35zM489 140h190v202zM155 21l279 344l274 348 l28 -23l-279 -345l-275 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 466,
    d: "M306 313q0 -39 -5.5 -67t-16.5 -48.5t-27 -35t-36 -26.5q-21 -12 -46 -24.5t-46.5 -30t-35.5 -43.5t-14 -65q0 -36 12.5 -63t33 -45t47 -26.5t54.5 -8.5q57 0 103 30t69 78l36 -22q-14 -31 -36 -55t-49.5 -40.5t-59 -25t-63.5 -8.5q-37 0 -71.5 12t-61.5 35.5t-43 59 t-16 82.5q0 42 12.5 71t33 49t46.5 34.5t52 26.5q21 10 36.5 20.5t26 27.5t16 43t5.5 65h44zM305 506v-98h-44v98h44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 675,
    d: "M316 710h44l300 -710h-54l-99 234h-339l-99 -234h-55zM493 276l-155 372l-158 -372h313zM254 918h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 675,
    d: "M316 710h44l300 -710h-54l-99 234h-339l-99 -234h-55zM493 276l-155 372l-158 -372h313zM337 816l-35 16l61 85h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 675,
    d: "M316 710h44l300 -710h-54l-99 234h-339l-99 -234h-55zM493 276l-155 372l-158 -372h313zM223 836l96 81h37l97 -81l-30 -17l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 675,
    d: "M316 710h44l300 -710h-54l-99 234h-339l-99 -234h-55zM493 276l-155 372l-158 -372h313zM399 834q-22 0 -39 6t-31 13.5t-27.5 14t-28.5 6.5q-17 0 -27 -7t-15 -15.5t-7 -16t-2 -9.5h-34q0 4 3 17.5t12.5 28t26 26t43.5 11.5q20 0 35.5 -6.5t29.5 -14t28.5 -13.5t33.5 -6 q20 0 31.5 7t17 15.5t7 16t1.5 9.5h34q0 -5 -3.5 -18.5t-13 -27.5t-27.5 -25.5t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 675,
    d: "M316 710h44l300 -710h-54l-99 234h-339l-99 -234h-55zM493 276l-155 372l-158 -372h313zM248 828v88h44v-88h-44zM384 828v88h44v-88h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 675,
    d: "M316 710h44l300 -710h-54l-99 234h-339l-99 -234h-55zM493 276l-155 372l-158 -372h313zM269 855q0 27 19.5 44.5t48.5 17.5t48.5 -17.5t19.5 -44.5q0 -28 -19.5 -45.5t-48.5 -17.5t-48.5 17.5t-19.5 45.5zM337 894q-17 0 -28.5 -10.5t-11.5 -28.5q0 -17 11.5 -28.5 t28.5 -11.5q16 0 28.5 11.5t12.5 28.5q0 18 -12 28.5t-29 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 962,
    d: "M434 710h474v-46h-410v-278h356v-47h-356v-293h419v-46h-469v234h-267l-151 -234h-57zM445 280v366l-240 -366h240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 687,
    d: "M296 -125q14 -7 37.5 -13t49.5 -6q58 0 58 37q0 20 -13.5 28t-35.5 8q-21 0 -44 -5t-37 -9l44 80q-70 3 -128 36t-99.5 84t-64.5 115t-23 130q0 64 22.5 127.5t65.5 113.5t105.5 81.5t142.5 31.5q95 0 162 -43.5t100 -111.5l-42 -24q-19 37 -44.5 62t-55 40.5t-61.5 22.5 t-63 7q-68 0 -120 -27.5t-88 -71.5t-54.5 -99.5t-18.5 -111.5q0 -63 22 -120t60 -100.5t90 -69.5t112 -26q32 0 66 8t65 25t58 43.5t45 62.5l44 -21q-17 -38 -45.5 -67.5t-64 -50.5t-75.5 -32.5t-79 -13.5l-29 -48q9 4 20.5 5t19.5 1q34 0 53 -15t19 -44q0 -32 -24 -48.5 t-69 -16.5q-29 0 -53.5 5.5t-43.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    d: "M566 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422zM256 918h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    d: "M339 816l-35 16l61 85h58zM566 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    d: "M225 836l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM566 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    d: "M249 828v88h44v-88h-44zM385 828v88h44v-88h-44zM566 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 237,
    d: "M93 0v710h51v-710h-51zM34 918h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 237,
    d: "M93 0v710h51v-710h-51zM117 816l-35 16l61 85h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 237,
    d: "M93 0v710h51v-710h-51zM3 836l96 81h37l97 -81l-30 -17l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 237,
    d: "M93 0v710h51v-710h-51zM28 828v88h44v-88h-44zM164 828v88h44v-88h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 720,
    d: "M100 0v336h-65v42h65v332h236q84 0 147.5 -28t105.5 -76t63 -112.5t21 -137.5q0 -81 -23.5 -146.5t-67.5 -112t-106.5 -72t-139.5 -25.5h-236zM622 356q0 67 -19 123.5t-55.5 97.5t-89.5 64t-122 23h-185v-286h178v-42h-178v-290h185q70 0 123.5 23.5t89.5 65.5 t54.5 98.5t18.5 122.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 773,
    d: "M144 614v-614h-51v710h39l498 -625v625h51v-710h-47zM452 834q-22 0 -39 6t-31 13.5t-27.5 14t-28.5 6.5q-17 0 -27 -7t-15 -15.5t-7 -16t-2 -9.5h-34q0 4 3 17.5t12.5 28t26 26t43.5 11.5q20 0 35.5 -6.5t29.5 -14t28.5 -13.5t33.5 -6q20 0 31.5 7t17 15.5t7 16t1.5 9.5 h34q0 -5 -3.5 -18.5t-13 -27.5t-27.5 -25.5t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 753,
    d: "M376 -5q-74 0 -135 31t-105 81t-68 115t-24 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -130.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5zM95 355q0 -61 20.5 -117.5t58 -100t89.5 -69.5t114 -26 q64 0 115.5 27t88 71.5t56.5 100.5t20 114q0 61 -21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114zM293 918h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 753,
    d: "M376 816l-35 16l61 85h58zM376 -5q-74 0 -135 31t-105 81t-68 115t-24 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -130.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5zM95 355q0 -61 20.5 -117.5t58 -100 t89.5 -69.5t114 -26q64 0 115.5 27t88 71.5t56.5 100.5t20 114q0 61 -21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 753,
    d: "M262 836l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM376 -5q-74 0 -135 31t-105 81t-68 115t-24 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -130.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5zM95 355 q0 -61 20.5 -117.5t58 -100t89.5 -69.5t114 -26q64 0 115.5 27t88 71.5t56.5 100.5t20 114q0 61 -21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 753,
    d: "M376 -5q-74 0 -135 31t-105 81t-68 115t-24 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -130.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5zM95 355q0 -61 20.5 -117.5t58 -100t89.5 -69.5t114 -26 q64 0 115.5 27t88 71.5t56.5 100.5t20 114q0 61 -21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114zM438 834q-22 0 -39 6t-31 13.5t-27.5 14t-28.5 6.5q-17 0 -27 -7t-15 -15.5t-7 -16t-2 -9.5h-34q0 4 3 17.5t12.5 28t26 26 t43.5 11.5q20 0 35.5 -6.5t29.5 -14t28.5 -13.5t33.5 -6q20 0 31.5 7t17 15.5t7 16t1.5 9.5h34q0 -5 -3.5 -18.5t-13 -27.5t-27.5 -25.5t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 753,
    d: "M287 828v88h44v-88h-44zM423 828v88h44v-88h-44zM376 -5q-74 0 -135 31t-105 81t-68 115t-24 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -130.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5zM95 355 q0 -61 20.5 -117.5t58 -100t89.5 -69.5t114 -26q64 0 115.5 27t88 71.5t56.5 100.5t20 114q0 61 -21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 451,
    d: "M385 145l-33 -32l-127 126l-126 -126l-32 33l125 125l-125 127l33 32l125 -126l127 127l32 -33l-126 -127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 753,
    d: "M639 710l-52 -78q58 -53 90 -126.5t32 -150.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5q-49 0 -93 14t-80 39l-31 -48h-57l50 77q-57 52 -89 125t-32 153q0 71 25.5 136t70 115t105.5 79.5t132 29.5q49 0 92 -14t80 -39l32 48h58zM95 355q0 -69 25.5 -130.5 t71.5 -106.5l331 504q-32 22 -68.5 34t-77.5 12q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114zM657 355q0 68 -26 129.5t-71 106.5l-331 -504q32 -21 69 -33t79 -12q64 0 115.5 27t88 71.5t56.5 100.5t20 114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 756,
    d: "M378 42q72 0 119.5 27t75 71t39 100t11.5 113v357h51v-357q0 -71 -15.5 -136t-50.5 -114.5t-91 -78.5t-138 -29q-85 0 -142 30.5t-91.5 81t-49 114.5t-14.5 132v357h51v-357q0 -59 11.5 -115t40 -99.5t75.5 -70t118 -26.5zM295 918h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 756,
    d: "M378 816l-35 16l61 85h58zM378 42q72 0 119.5 27t75 71t39 100t11.5 113v357h51v-357q0 -71 -15.5 -136t-50.5 -114.5t-91 -78.5t-138 -29q-85 0 -142 30.5t-91.5 81t-49 114.5t-14.5 132v357h51v-357q0 -59 11.5 -115t40 -99.5t75.5 -70t118 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 756,
    d: "M264 836l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM378 42q72 0 119.5 27t75 71t39 100t11.5 113v357h51v-357q0 -71 -15.5 -136t-50.5 -114.5t-91 -78.5t-138 -29q-85 0 -142 30.5t-91.5 81t-49 114.5t-14.5 132v357h51v-357q0 -59 11.5 -115t40 -99.5t75.5 -70 t118 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 756,
    d: "M288 828v88h44v-88h-44zM424 828v88h44v-88h-44zM378 42q72 0 119.5 27t75 71t39 100t11.5 113v357h51v-357q0 -71 -15.5 -136t-50.5 -114.5t-91 -78.5t-138 -29q-85 0 -142 30.5t-91.5 81t-49 114.5t-14.5 132v357h51v-357q0 -59 11.5 -115t40 -99.5t75.5 -70t118 -26.5 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 647,
    d: "M75 710l248 -393l249 393h57l-280 -442v-268h-51v270l-279 440h56zM322 816l-35 16l61 85h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 601,
    d: "M366 566q45 0 83 -19t65 -50.5t42.5 -71t15.5 -80.5q0 -43 -14.5 -83t-40.5 -70.5t-63 -49t-82 -18.5h-228v-124h-51v710h51v-144h222zM371 171q35 0 63 15t47.5 39.5t30 55.5t10.5 64q0 34 -12.5 65.5t-34 55.5t-50 38.5t-61.5 14.5h-220v-348h227z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 549,
    d: "M235 40q103 2 162.5 44t59.5 124q0 38 -13.5 69t-37.5 53.5t-57.5 34.5t-73.5 12h-17v47h16q29 0 53.5 9t42.5 25.5t28 39t10 49.5q0 28 -10.5 50.5t-29.5 38.5t-44 24.5t-53 8.5q-35 0 -61.5 -12.5t-45 -34t-28 -51.5t-9.5 -65v-506h-49v513q0 45 14.5 82t40 63.5 t61.5 41t78 14.5q39 0 73 -12t58.5 -33t38.5 -50.5t14 -63.5q0 -27 -8.5 -52t-23.5 -45.5t-35.5 -35t-43.5 -19.5q78 -17 120.5 -69.5t42.5 -128.5q0 -99 -73 -153t-200 -58v46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 537,
    d: "M206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68.5 32t88 11.5q42 0 84.5 -7.5t76.5 -20.5v51q0 74 -42 117.5t-114 43.5q-38 0 -80.5 -16t-86.5 -46l-19 34q100 68 190 68q94 0 148 -54.5t54 -150.5v-254q0 -25 22 -25v-45q-5 -1 -10.5 -1.5 t-9.5 -0.5q-20 0 -32 13.5t-14 32.5v43q-36 -47 -92 -72t-121 -25zM216 30q58 0 106.5 22t74.5 58q16 21 16 40v92q-36 14 -75 21t-81 7q-39 0 -71 -8.5t-55 -23.5t-35.5 -36.5t-12.5 -47.5t10 -49t28 -39.5t42.5 -26t52.5 -9.5zM177 730h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 537,
    d: "M206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68.5 32t88 11.5q42 0 84.5 -7.5t76.5 -20.5v51q0 74 -42 117.5t-114 43.5q-38 0 -80.5 -16t-86.5 -46l-19 34q100 68 190 68q94 0 148 -54.5t54 -150.5v-254q0 -25 22 -25v-45q-5 -1 -10.5 -1.5 t-9.5 -0.5q-20 0 -32 13.5t-14 32.5v43q-36 -47 -92 -72t-121 -25zM216 30q58 0 106.5 22t74.5 58q16 21 16 40v92q-36 14 -75 21t-81 7q-39 0 -71 -8.5t-55 -23.5t-35.5 -36.5t-12.5 -47.5t10 -49t28 -39.5t42.5 -26t52.5 -9.5zM260 629l-35 16l61 85h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 537,
    d: "M206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68.5 32t88 11.5q42 0 84.5 -7.5t76.5 -20.5v51q0 74 -42 117.5t-114 43.5q-38 0 -80.5 -16t-86.5 -46l-19 34q100 68 190 68q94 0 148 -54.5t54 -150.5v-254q0 -25 22 -25v-45q-5 -1 -10.5 -1.5 t-9.5 -0.5q-20 0 -32 13.5t-14 32.5v43q-36 -47 -92 -72t-121 -25zM216 30q58 0 106.5 22t74.5 58q16 21 16 40v92q-36 14 -75 21t-81 7q-39 0 -71 -8.5t-55 -23.5t-35.5 -36.5t-12.5 -47.5t10 -49t28 -39.5t42.5 -26t52.5 -9.5zM146 649l96 81h37l97 -81l-30 -17l-85 63 l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 537,
    d: "M206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68.5 32t88 11.5q42 0 84.5 -7.5t76.5 -20.5v51q0 74 -42 117.5t-114 43.5q-38 0 -80.5 -16t-86.5 -46l-19 34q100 68 190 68q94 0 148 -54.5t54 -150.5v-254q0 -25 22 -25v-45q-5 -1 -10.5 -1.5 t-9.5 -0.5q-20 0 -32 13.5t-14 32.5v43q-36 -47 -92 -72t-121 -25zM216 30q58 0 106.5 22t74.5 58q16 21 16 40v92q-36 14 -75 21t-81 7q-39 0 -71 -8.5t-55 -23.5t-35.5 -36.5t-12.5 -47.5t10 -49t28 -39.5t42.5 -26t52.5 -9.5zM322 647q-22 0 -39 6t-31 13.5t-27.5 14 t-28.5 6.5q-17 0 -27 -7t-15 -15.5t-7 -16t-2 -9.5h-34q0 4 3 17.5t12.5 28t26 26t43.5 11.5q20 0 35.5 -6.5t29.5 -14t28.5 -13.5t33.5 -6q20 0 31.5 7t17 15.5t7 16t1.5 9.5h34q0 -5 -3.5 -18.5t-13 -27.5t-27.5 -25.5t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 537,
    d: "M206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68.5 32t88 11.5q42 0 84.5 -7.5t76.5 -20.5v51q0 74 -42 117.5t-114 43.5q-38 0 -80.5 -16t-86.5 -46l-19 34q100 68 190 68q94 0 148 -54.5t54 -150.5v-254q0 -25 22 -25v-45q-5 -1 -10.5 -1.5 t-9.5 -0.5q-20 0 -32 13.5t-14 32.5v43q-36 -47 -92 -72t-121 -25zM216 30q58 0 106.5 22t74.5 58q16 21 16 40v92q-36 14 -75 21t-81 7q-39 0 -71 -8.5t-55 -23.5t-35.5 -36.5t-12.5 -47.5t10 -49t28 -39.5t42.5 -26t52.5 -9.5zM171 640v88h44v-88h-44zM307 640v88h44v-88 h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 537,
    d: "M206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68.5 32t88 11.5q42 0 84.5 -7.5t76.5 -20.5v51q0 74 -42 117.5t-114 43.5q-38 0 -80.5 -16t-86.5 -46l-19 34q100 68 190 68q94 0 148 -54.5t54 -150.5v-254q0 -25 22 -25v-45q-5 -1 -10.5 -1.5 t-9.5 -0.5q-20 0 -32 13.5t-14 32.5v43q-36 -47 -92 -72t-121 -25zM216 30q58 0 106.5 22t74.5 58q16 21 16 40v92q-36 14 -75 21t-81 7q-39 0 -71 -8.5t-55 -23.5t-35.5 -36.5t-12.5 -47.5t10 -49t28 -39.5t42.5 -26t52.5 -9.5zM192 668q0 27 19.5 44.5t48.5 17.5 t48.5 -17.5t19.5 -44.5q0 -28 -19.5 -45.5t-48.5 -17.5t-48.5 17.5t-19.5 45.5zM260 707q-17 0 -28.5 -10.5t-11.5 -28.5q0 -17 11.5 -28.5t28.5 -11.5q16 0 28.5 11.5t12.5 28.5q0 18 -12 28.5t-29 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 930,
    d: "M206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68 32t87.5 11.5q35 0 71 -5.5t67 -14.5q2 21 6.5 42.5t12.5 41.5q-11 56 -50.5 88t-100.5 32q-38 0 -80.5 -16t-86.5 -46l-20 34q101 68 191 68q66 0 111.5 -29t67.5 -82q32 50 85 80.5t117 30.5 q55 0 102 -21t81.5 -58t54 -86t19.5 -104q0 -3 -0.5 -10.5t-0.5 -9.5h-461q3 -45 21 -83.5t46.5 -66.5t65.5 -44t78 -16q27 0 53.5 7.5t49 20.5t40 31.5t27.5 40.5l44 -12q-12 -28 -33.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5q-67 0 -122 32t-90 85q-16 -31 -42 -53 t-57 -36.5t-64.5 -21t-64.5 -6.5zM216 30q58 0 107 21.5t74 58.5q15 19 16 35q-11 23 -17 51t-7 54q-63 20 -132 20q-78 0 -126 -32t-48 -84q0 -26 10 -49t28 -39.5t42.5 -26t52.5 -9.5zM850 277q-3 46 -20 85t-45 67t-64.5 43.5t-78.5 15.5t-78.5 -16t-64 -44t-44 -66.5 t-18.5 -84.5h413z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 545,
    d: "M222 -125q14 -7 37.5 -13t49.5 -6q58 0 58 37q0 20 -13.5 28t-35.5 8q-21 0 -44 -5t-37 -9l42 76q-51 4 -94.5 26.5t-75 59.5t-49.5 84.5t-18 100.5q0 55 19 104t53 85t81 57t103 21q71 0 125 -32t81 -89l-49 -16q-23 43 -65.5 67.5t-93.5 24.5q-43 0 -80 -17t-64.5 -47 t-43.5 -70.5t-16 -87.5t16.5 -88.5t44 -72t65 -48.5t79.5 -18q27 0 53.5 8t49 21t39 30.5t22.5 36.5l49 -14q-10 -26 -29 -48.5t-45 -39t-58 -27t-66 -11.5l-26 -44q9 4 20.5 5t19.5 1q34 0 53 -15t19 -44q0 -32 -24 -48.5t-69 -16.5q-29 0 -53.5 5.5t-43.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 583,
    d: "M299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12 q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410zM211 730h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 583,
    d: "M294 629l-35 16l61 85h58zM299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16q27 0 53 7.5t48.5 20.5t40 31.5 t27.5 40.5l44 -12q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 583,
    d: "M180 649l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16 q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 583,
    d: "M205 640v88h44v-88h-44zM341 640v88h44v-88h-44zM299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16 q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 207,
    d: "M78 0v520h50v-520h-50zM19 730h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 207,
    d: "M102 629l-35 16l61 85h58zM78 0v520h50v-520h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 207,
    d: "M-12 649l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM78 0v520h50v-520h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 207,
    d: "M13 640v88h44v-88h-44zM149 640v88h44v-88h-44zM78 0v520h50v-520h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 599,
    d: "M486 689l-86 -54q46 -44 76 -90.5t47 -93t23.5 -93.5t6.5 -93q0 -60 -20.5 -110t-55.5 -87t-82 -57.5t-99 -20.5t-98 19t-80 52t-54 77t-20 94q0 49 19.5 93t53 77t78 52.5t95.5 19.5q71 0 128 -35t84 -92q-9 66 -39 133t-101 134l-116 -74l-18 25l112 69q-29 24 -63 48 t-76 48h71q30 -18 56.5 -36.5t49.5 -38.5l91 58zM95 231q0 -41 16 -76.5t43 -62t64 -42t79 -15.5t79.5 16.5t65.5 45t44 66.5t16 80q0 39 -16 73t-44 59.5t-64.5 40.5t-78.5 15t-79 -16t-65 -43t-44 -63.5t-16 -77.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 576,
    d: "M503 0h-50v290q0 101 -28.5 147t-90.5 46q-33 0 -65.5 -12t-60.5 -34t-49 -51.5t-31 -63.5v-322h-50v520h47v-124q16 30 39.5 54.5t53 42t62.5 27t68 9.5q85 0 120 -59.5t35 -170.5v-299zM351 647q-22 0 -39 6t-31 13.5t-27.5 14t-28.5 6.5q-17 0 -27 -7t-15 -15.5 t-7 -16t-2 -9.5h-34q0 4 3 17.5t12.5 28t26 26t43.5 11.5q20 0 35.5 -6.5t29.5 -14t28.5 -13.5t33.5 -6q20 0 31.5 7t17 15.5t7 16t1.5 9.5h34q0 -5 -3.5 -18.5t-13 -27.5t-27.5 -25.5t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 592,
    d: "M296 -10q-55 0 -101.5 21.5t-80.5 58.5t-53 86t-19 103q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5t100 -21.5t80.5 -58.5t54 -86t19.5 -104q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5zM92 257q0 -46 16 -86.5t43.5 -70.5t64.5 -47.5t79 -17.5t79 17.5 t65 48.5t44 71.5t16 87.5q0 46 -16 86.5t-44 71t-64.5 48.5t-78.5 18t-79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5zM212 730h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 592,
    d: "M295 629l-35 16l61 85h58zM296 -10q-55 0 -101.5 21.5t-80.5 58.5t-53 86t-19 103q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5t100 -21.5t80.5 -58.5t54 -86t19.5 -104q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5zM92 257q0 -46 16 -86.5t43.5 -70.5 t64.5 -47.5t79 -17.5t79 17.5t65 48.5t44 71.5t16 87.5q0 46 -16 86.5t-44 71t-64.5 48.5t-78.5 18t-79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 592,
    d: "M181 649l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM296 -10q-55 0 -101.5 21.5t-80.5 58.5t-53 86t-19 103q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5t100 -21.5t80.5 -58.5t54 -86t19.5 -104q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5zM92 257 q0 -46 16 -86.5t43.5 -70.5t64.5 -47.5t79 -17.5t79 17.5t65 48.5t44 71.5t16 87.5q0 46 -16 86.5t-44 71t-64.5 48.5t-78.5 18t-79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 592,
    d: "M296 -10q-55 0 -101.5 21.5t-80.5 58.5t-53 86t-19 103q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5t100 -21.5t80.5 -58.5t54 -86t19.5 -104q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5zM92 257q0 -46 16 -86.5t43.5 -70.5t64.5 -47.5t79 -17.5t79 17.5 t65 48.5t44 71.5t16 87.5q0 46 -16 86.5t-44 71t-64.5 48.5t-78.5 18t-79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5zM357 647q-22 0 -39 6t-31 13.5t-27.5 14t-28.5 6.5q-17 0 -27 -7t-15 -15.5t-7 -16t-2 -9.5h-34q0 4 3 17.5t12.5 28t26 26t43.5 11.5q20 0 35.5 -6.5 t29.5 -14t28.5 -13.5t33.5 -6q20 0 31.5 7t17 15.5t7 16t1.5 9.5h34q0 -5 -3.5 -18.5t-13 -27.5t-27.5 -25.5t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 592,
    d: "M206 640v88h44v-88h-44zM342 640v88h44v-88h-44zM296 -10q-55 0 -101.5 21.5t-80.5 58.5t-53 86t-19 103q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5t100 -21.5t80.5 -58.5t54 -86t19.5 -104q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5zM92 257 q0 -46 16 -86.5t43.5 -70.5t64.5 -47.5t79 -17.5t79 17.5t65 48.5t44 71.5t16 87.5q0 46 -16 86.5t-44 71t-64.5 48.5t-78.5 18t-79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 540,
    d: "M248 394v81h44v-81h-44zM248 81v80h44v-80h-44zM69 257v43h403v-43h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 592,
    d: "M104 -1l34 48q-45 38 -70.5 93t-25.5 119q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5q36 0 69 -10.5t62 -28.5l22 31h40l-36 -50q45 -38 71 -93t26 -119q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5q-38 0 -70.5 10t-61.5 28l-22 -29h-38zM92 257 q0 -53 20 -97t54 -75l235 366q-23 16 -49.5 24.5t-55.5 8.5q-42 0 -79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5zM295 35q42 0 79 17.5t65 48.5t44 71.5t16 87.5q0 51 -20 95.5t-54 75.5l-236 -364q47 -32 106 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 587,
    d: "M239 -10q-166 0 -166 230v300h50v-293q0 -192 131 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-5 -1 -9 -1h-6q-20 0 -35.5 12.5t-15.5 33.5v78q-34 -63 -93.5 -98t-128.5 -35zM204 730h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 587,
    d: "M286 629l-35 16l61 85h58zM239 -10q-166 0 -166 230v300h50v-293q0 -192 131 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-5 -1 -9 -1h-6q-20 0 -35.5 12.5t-15.5 33.5v78q-34 -63 -93.5 -98t-128.5 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 587,
    d: "M172 649l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM239 -10q-166 0 -166 230v300h50v-293q0 -192 131 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-5 -1 -9 -1h-6q-20 0 -35.5 12.5t-15.5 33.5v78q-34 -63 -93.5 -98t-128.5 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 587,
    d: "M197 640v88h44v-88h-44zM333 640v88h44v-88h-44zM239 -10q-166 0 -166 230v300h50v-293q0 -192 131 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-5 -1 -9 -1h-6q-20 0 -35.5 12.5t-15.5 33.5v78q-34 -63 -93.5 -98t-128.5 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 540,
    d: "M113 -176q5 -1 15 -1t18.5 1t16.5 5q6 3 11 8.5t14 22.5t23 50t38 90l-232 520h52l207 -471l193 471h49l-285 -684q-11 -28 -35.5 -43.5t-66.5 -15.5h-8.5t-9.5 1v46zM275 629l-35 16l61 85h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 603,
    d: "M562 258q-1 -54 -21 -103t-54 -86.5t-80 -60t-99 -22.5q-29 0 -55.5 8t-50 22t-42 32t-31.5 39v-300h-51v923h51v-289q33 46 78.5 77.5t109.5 31.5q57 0 102.5 -24.5t77 -63.5t48.5 -87.5t17 -96.5zM511 258q0 44 -14 84.5t-40 72t-62 50.5t-80 19q-33 0 -61 -11 t-51.5 -29.5t-42 -42.5t-31.5 -50v-180q0 -27 17.5 -52t44 -44t58 -30.5t58.5 -11.5q45 0 82.5 19t64.5 50.5t42 72t15 83.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 540,
    d: "M113 -176q5 -1 15 -1t18.5 1t16.5 5q6 3 11 8.5t14 22.5t23 50t38 90l-232 520h52l207 -471l193 471h49l-285 -684q-11 -28 -35.5 -43.5t-66.5 -15.5h-8.5t-9.5 1v46zM186 640v88h44v-88h-44zM322 640v88h44v-88h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 675,
    d: "M316 710h44l300 -710h-54l-99 234h-339l-99 -234h-55zM493 276l-155 372l-158 -372h313zM196 859v37h285v-37h-285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 537,
    d: "M206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68.5 32t88 11.5q42 0 84.5 -7.5t76.5 -20.5v51q0 74 -42 117.5t-114 43.5q-38 0 -80.5 -16t-86.5 -46l-19 34q100 68 190 68q94 0 148 -54.5t54 -150.5v-254q0 -25 22 -25v-45q-5 -1 -10.5 -1.5 t-9.5 -0.5q-20 0 -32 13.5t-14 32.5v43q-36 -47 -92 -72t-121 -25zM216 30q58 0 106.5 22t74.5 58q16 21 16 40v92q-36 14 -75 21t-81 7q-39 0 -71 -8.5t-55 -23.5t-35.5 -36.5t-12.5 -47.5t10 -49t28 -39.5t42.5 -26t52.5 -9.5zM119 672v37h285v-37h-285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 675,
    d: "M316 710h44l300 -710h-54l-99 234h-339l-99 -234h-55zM493 276l-155 372l-158 -372h313zM338 853q20 0 36.5 18.5t19.5 45.5h33q0 -19 -7 -36t-19.5 -29.5t-28.5 -19.5t-34 -7t-34.5 7t-28.5 19.5t-19 29.5t-7 36h33q0 -25 17 -44.5t39 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 537,
    d: "M206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68.5 32t88 11.5q42 0 84.5 -7.5t76.5 -20.5v51q0 74 -42 117.5t-114 43.5q-38 0 -80.5 -16t-86.5 -46l-19 34q100 68 190 68q94 0 148 -54.5t54 -150.5v-254q0 -25 22 -25v-45q-5 -1 -10.5 -1.5 t-9.5 -0.5q-20 0 -32 13.5t-14 32.5v43q-36 -47 -92 -72t-121 -25zM216 30q58 0 106.5 22t74.5 58q16 21 16 40v92q-36 14 -75 21t-81 7q-39 0 -71 -8.5t-55 -23.5t-35.5 -36.5t-12.5 -47.5t10 -49t28 -39.5t42.5 -26t52.5 -9.5zM261 666q20 0 36.5 18.5t19.5 45.5h33 q0 -19 -7 -36t-19.5 -29.5t-28.5 -19.5t-34 -7t-34.5 7t-28.5 19.5t-19 29.5t-7 36h33q0 -25 17 -44.5t39 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 674,
    d: "M610 -169q-32 7 -49.5 25t-17.5 43t17.5 49.5t55.5 51.5h-11l-99 234h-339l-99 -234h-55l302 710h44l300 -710q-45 -29 -63.5 -50t-18.5 -44q0 -38 49 -45zM492 276l-155 372l-158 -372h313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 537,
    d: "M436 -169q-32 7 -49.5 25t-17.5 43q0 26 18 50.5t58 52.5q-11 5 -18 16.5t-8 25.5v43q-36 -47 -92 -72t-121 -25q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68.5 32t88 11.5q42 0 84.5 -7.5t76.5 -20.5v51q0 74 -42 117.5t-114 43.5q-38 0 -80.5 -16 t-86.5 -46l-19 34q100 68 190 68q94 0 148 -54.5t54 -150.5v-254q0 -25 22 -25v-45q-45 -29 -63.5 -50t-18.5 -44q0 -38 49 -45zM216 30q58 0 106.5 22t74.5 58q16 21 16 40v92q-36 14 -75 21t-81 7q-39 0 -71 -8.5t-55 -23.5t-35.5 -36.5t-12.5 -47.5t10 -49t28 -39.5 t42.5 -26t52.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 690,
    d: "M378 816l-35 16l61 85h58zM44 360q0 64 22.5 127.5t65.5 113.5t105.5 81.5t142.5 31.5q95 0 162 -43.5t100 -111.5l-42 -24q-19 37 -44.5 62t-55 40.5t-61.5 22.5t-63 7q-68 0 -120 -27.5t-88 -71.5t-54.5 -99.5t-18.5 -111.5q0 -63 22 -120t60 -100.5t90 -69.5t112 -26 q32 0 66 8t65 25t58 43.5t45 62.5l44 -21q-18 -40 -49 -71t-69 -52t-80.5 -31.5t-83.5 -10.5q-73 0 -133.5 32t-104.5 83.5t-68.5 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 545,
    d: "M295 629l-35 16l61 85h58zM42 262q0 55 19 104t53 85t81 57t103 21q71 0 125 -32t81 -89l-49 -16q-23 43 -65.5 67.5t-93.5 24.5q-43 0 -80 -17t-64.5 -47t-43.5 -70.5t-16 -87.5t16.5 -88.5t44 -72t65 -48.5t79.5 -18q27 0 53.5 8t49 21t39 30.5t22.5 36.5l49 -14 q-10 -27 -30.5 -50.5t-48.5 -40.5t-62 -26.5t-70 -9.5q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 690,
    d: "M264 836l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM44 360q0 64 22.5 127.5t65.5 113.5t105.5 81.5t142.5 31.5q95 0 162 -43.5t100 -111.5l-42 -24q-19 37 -44.5 62t-55 40.5t-61.5 22.5t-63 7q-68 0 -120 -27.5t-88 -71.5t-54.5 -99.5t-18.5 -111.5q0 -63 22 -120 t60 -100.5t90 -69.5t112 -26q32 0 66 8t65 25t58 43.5t45 62.5l44 -21q-18 -40 -49 -71t-69 -52t-80.5 -31.5t-83.5 -10.5q-73 0 -133.5 32t-104.5 83.5t-68.5 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 545,
    d: "M181 649l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM42 262q0 55 19 104t53 85t81 57t103 21q71 0 125 -32t81 -89l-49 -16q-23 43 -65.5 67.5t-93.5 24.5q-43 0 -80 -17t-64.5 -47t-43.5 -70.5t-16 -87.5t16.5 -88.5t44 -72t65 -48.5t79.5 -18q27 0 53.5 8t49 21t39 30.5 t22.5 36.5l49 -14q-10 -27 -30.5 -50.5t-48.5 -40.5t-62 -26.5t-70 -9.5q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 690,
    d: "M44 360q0 64 22.5 127.5t65.5 113.5t105.5 81.5t142.5 31.5q95 0 162 -43.5t100 -111.5l-42 -24q-19 37 -44.5 62t-55 40.5t-61.5 22.5t-63 7q-68 0 -120 -27.5t-88 -71.5t-54.5 -99.5t-18.5 -111.5q0 -63 22 -120t60 -100.5t90 -69.5t112 -26q32 0 66 8t65 25t58 43.5 t45 62.5l44 -21q-18 -40 -49 -71t-69 -52t-80.5 -31.5t-83.5 -10.5q-73 0 -133.5 32t-104.5 83.5t-68.5 117t-24.5 133.5zM356 827v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 545,
    d: "M42 262q0 55 19 104t53 85t81 57t103 21q71 0 125 -32t81 -89l-49 -16q-23 43 -65.5 67.5t-93.5 24.5q-43 0 -80 -17t-64.5 -47t-43.5 -70.5t-16 -87.5t16.5 -88.5t44 -72t65 -48.5t79.5 -18q27 0 53.5 8t49 21t39 30.5t22.5 36.5l49 -14q-10 -27 -30.5 -50.5 t-48.5 -40.5t-62 -26.5t-70 -9.5q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105zM273 640v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 690,
    d: "M294 917l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM44 360q0 64 22.5 127.5t65.5 113.5t105.5 81.5t142.5 31.5q95 0 162 -43.5t100 -111.5l-42 -24q-19 37 -44.5 62t-55 40.5t-61.5 22.5t-63 7q-68 0 -120 -27.5t-88 -71.5t-54.5 -99.5t-18.5 -111.5q0 -63 22 -120 t60 -100.5t90 -69.5t112 -26q32 0 66 8t65 25t58 43.5t45 62.5l44 -21q-18 -40 -49 -71t-69 -52t-80.5 -31.5t-83.5 -10.5q-73 0 -133.5 32t-104.5 83.5t-68.5 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 545,
    d: "M211 730l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM42 262q0 55 19 104t53 85t81 57t103 21q71 0 125 -32t81 -89l-49 -16q-23 43 -65.5 67.5t-93.5 24.5q-43 0 -80 -17t-64.5 -47t-43.5 -70.5t-16 -87.5t16.5 -88.5t44 -72t65 -48.5t79.5 -18q27 0 53.5 8t49 21t39 30.5 t22.5 36.5l49 -14q-10 -27 -30.5 -50.5t-48.5 -40.5t-62 -26.5t-70 -9.5q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 713,
    d: "M262 917l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM93 0v710h236q84 0 147.5 -28t105.5 -76t63 -112.5t21 -137.5q0 -81 -23.5 -146.5t-67.5 -112t-106.5 -72t-139.5 -25.5h-236zM615 356q0 67 -19 123.5t-55.5 97.5t-89.5 64t-122 23h-185v-618h185q70 0 123.5 23.5 t89.5 65.5t54.5 98.5t18.5 122.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 615,
    d: "M607 629l-35 16l61 85h58zM292 -10q-54 0 -100 22.5t-79.5 60t-52 86t-18.5 100.5q0 54 18 103t50 86t75.5 59t95.5 22q34 0 64 -10t56 -26.5t47 -38.5t36 -47v323h50v-660q0 -25 21 -25v-45q-6 -1 -10 -1.5t-8 -0.5q-20 0 -34 15.5t-14 32.5v58q-32 -52 -85.5 -83 t-111.5 -31zM301 35q27 0 58 11t57.5 30.5t45.5 44.5t22 54v171q-11 28 -31.5 53.5t-46.5 44t-56 29.5t-58 11q-45 0 -82 -19.5t-63 -51t-40 -72t-14 -83.5q0 -45 16 -85t44.5 -71t66 -49t81.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 720,
    d: "M100 0v336h-65v42h65v332h236q84 0 147.5 -28t105.5 -76t63 -112.5t21 -137.5q0 -81 -23.5 -146.5t-67.5 -112t-106.5 -72t-139.5 -25.5h-236zM622 356q0 67 -19 123.5t-55.5 97.5t-89.5 64t-122 23h-185v-286h178v-42h-178v-290h185q70 0 123.5 23.5t89.5 65.5 t54.5 98.5t18.5 122.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 615,
    d: "M292 -10q-54 0 -100 22.5t-79.5 60t-52 86t-18.5 100.5q0 54 18 103t50 86t75.5 59t95.5 22q34 0 64 -10t56 -26.5t47 -38.5t36 -47v216h-118v36h118v71h50v-71h72v-36h-72v-553q0 -25 21 -25v-45q-6 -1 -10 -1.5t-8 -0.5q-20 0 -34 15.5t-14 32.5v58q-32 -52 -85.5 -83 t-111.5 -31zM301 35q27 0 58 11t57.5 30.5t45.5 44.5t22 54v171q-11 28 -31.5 53.5t-46.5 44t-56 29.5t-58 11q-45 0 -82 -19.5t-63 -51t-40 -72t-14 -83.5q0 -45 16 -85t44.5 -71t66 -49t81.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    d: "M566 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422zM198 859v37h285v-37h-285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 583,
    d: "M299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12 q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410zM153 672v37h285v-37h-285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    d: "M566 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422zM340 853q20 0 36.5 18.5t19.5 45.5h33q0 -19 -7 -36t-19.5 -29.5t-28.5 -19.5t-34 -7t-34.5 7t-28.5 19.5t-19 29.5t-7 36h33q0 -25 17 -44.5t39 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 583,
    d: "M299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12 q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410zM295 666q20 0 36.5 18.5t19.5 45.5h33q0 -19 -7 -36t-19.5 -29.5t-28.5 -19.5t-34 -7t-34.5 7t-28.5 19.5 t-19 29.5t-7 36h33q0 -25 17 -44.5t39 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    d: "M566 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422zM316 827v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 583,
    d: "M299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12 q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410zM272 640v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    d: "M566 46v-46q-45 -29 -63.5 -50t-18.5 -44q0 -38 49 -45l-16 -30q-32 7 -49.5 25t-17.5 43t17.5 49.5t55.5 51.5h-430v710h464v-46h-413v-279h361v-44h-361v-295h422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 583,
    d: "M282 -176q-32 7 -49.5 25t-17.5 43t16.5 48.5t52.5 50.5q-52 3 -96.5 25.5t-76.5 59.5t-50.5 84.5t-18.5 101.5q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16 q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12q-10 -25 -28.5 -46.5t-42.5 -38t-53.5 -27.5t-60.5 -14q-45 -29 -62.5 -49.5t-17.5 -43.5q0 -38 49 -45zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    d: "M255 917l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM566 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 583,
    d: "M210 730l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16 q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 717,
    d: "M255 836l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM616 111q-103 -116 -239 -116q-72 0 -133.5 31t-105.5 82t-69 116t-25 132q0 70 24.5 135t68 115t103.5 79.5t131 29.5q53 0 95.5 -11.5t76 -32t58 -49t41.5 -62.5l-42 -25q-36 70 -95.5 101.5t-134.5 31.5 q-63 0 -114 -27t-87 -71t-55 -100t-19 -115q0 -63 22 -119.5t60.5 -99.5t90.5 -68.5t112 -25.5q65 0 123.5 30t112.5 95v137h-161v41h205v-345h-44v111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    d: "M206 649l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM288 -8q-54 0 -99 22.5t-77.5 60t-51 85.5t-18.5 99q0 53 17.5 102t49.5 86.5t76.5 59.5t98.5 22q68 0 118.5 -35.5t85.5 -86.5v113h46v-530q0 -53 -20 -93t-53.5 -66.5t-78 -40t-93.5 -13.5q-45 0 -81 8.5t-63.5 24 t-49 38t-37.5 49.5l34 23q31 -53 84 -77.5t113 -24.5q40 0 75.5 11t62 32.5t42 53.5t15.5 75v114q-32 -51 -85 -81.5t-111 -30.5zM300 35q33 0 64.5 12.5t57 32.5t42 45t20.5 50v171q-12 30 -32 55.5t-45.5 43.5t-55 28.5t-59.5 10.5q-47 0 -84 -20t-62.5 -52t-39 -72.5 t-13.5 -81.5q0 -45 16 -85t44 -71t66 -49t81 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 717,
    d: "M616 111q-103 -116 -239 -116q-72 0 -133.5 31t-105.5 82t-69 116t-25 132q0 70 24.5 135t68 115t103.5 79.5t131 29.5q53 0 95.5 -11.5t76 -32t58 -49t41.5 -62.5l-42 -25q-36 70 -95.5 101.5t-134.5 31.5q-63 0 -114 -27t-87 -71t-55 -100t-19 -115q0 -63 22 -119.5 t60.5 -99.5t90.5 -68.5t112 -25.5q65 0 123.5 30t112.5 95v137h-161v41h205v-345h-44v111zM370 853q20 0 36.5 18.5t19.5 45.5h33q0 -19 -7 -36t-19.5 -29.5t-28.5 -19.5t-34 -7t-34.5 7t-28.5 19.5t-19 29.5t-7 36h33q0 -25 17 -44.5t39 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    d: "M288 -8q-54 0 -99 22.5t-77.5 60t-51 85.5t-18.5 99q0 53 17.5 102t49.5 86.5t76.5 59.5t98.5 22q68 0 118.5 -35.5t85.5 -86.5v113h46v-530q0 -53 -20 -93t-53.5 -66.5t-78 -40t-93.5 -13.5q-45 0 -81 8.5t-63.5 24t-49 38t-37.5 49.5l34 23q31 -53 84 -77.5t113 -24.5 q40 0 75.5 11t62 32.5t42 53.5t15.5 75v114q-32 -51 -85 -81.5t-111 -30.5zM300 35q33 0 64.5 12.5t57 32.5t42 45t20.5 50v171q-12 30 -32 55.5t-45.5 43.5t-55 28.5t-59.5 10.5q-47 0 -84 -20t-62.5 -52t-39 -72.5t-13.5 -81.5q0 -45 16 -85t44 -71t66 -49t81 -18z M321 666q20 0 36.5 18.5t19.5 45.5h33q0 -19 -7 -36t-19.5 -29.5t-28.5 -19.5t-34 -7t-34.5 7t-28.5 19.5t-19 29.5t-7 36h33q0 -25 17 -44.5t39 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 717,
    d: "M616 111q-103 -116 -239 -116q-72 0 -133.5 31t-105.5 82t-69 116t-25 132q0 70 24.5 135t68 115t103.5 79.5t131 29.5q53 0 95.5 -11.5t76 -32t58 -49t41.5 -62.5l-42 -25q-36 70 -95.5 101.5t-134.5 31.5q-63 0 -114 -27t-87 -71t-55 -100t-19 -115q0 -63 22 -119.5 t60.5 -99.5t90.5 -68.5t112 -25.5q65 0 123.5 30t112.5 95v137h-161v41h205v-345h-44v111zM346 827v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    d: "M288 -8q-54 0 -99 22.5t-77.5 60t-51 85.5t-18.5 99q0 53 17.5 102t49.5 86.5t76.5 59.5t98.5 22q68 0 118.5 -35.5t85.5 -86.5v113h46v-530q0 -53 -20 -93t-53.5 -66.5t-78 -40t-93.5 -13.5q-45 0 -81 8.5t-63.5 24t-49 38t-37.5 49.5l34 23q31 -53 84 -77.5t113 -24.5 q40 0 75.5 11t62 32.5t42 53.5t15.5 75v114q-32 -51 -85 -81.5t-111 -30.5zM300 35q33 0 64.5 12.5t57 32.5t42 45t20.5 50v171q-12 30 -32 55.5t-45.5 43.5t-55 28.5t-59.5 10.5q-47 0 -84 -20t-62.5 -52t-39 -72.5t-13.5 -81.5q0 -45 16 -85t44 -71t66 -49t81 -18z M298 640v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 717,
    d: "M352 -187l15 68h-16v70h49v-70l-21 -68h-27zM616 111q-103 -116 -239 -116q-72 0 -133.5 31t-105.5 82t-69 116t-25 132q0 70 24.5 135t68 115t103.5 79.5t131 29.5q53 0 95.5 -11.5t76 -32t58 -49t41.5 -62.5l-42 -25q-36 70 -95.5 101.5t-134.5 31.5q-63 0 -114 -27 t-87 -71t-55 -100t-19 -115q0 -63 22 -119.5t60.5 -99.5t90.5 -68.5t112 -25.5q65 0 123.5 30t112.5 95v137h-161v41h205v-345h-44v111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    d: "M323 736l-15 -68h16v-70h-49v70l21 68h27zM288 -8q-54 0 -99 22.5t-77.5 60t-51 85.5t-18.5 99q0 53 17.5 102t49.5 86.5t76.5 59.5t98.5 22q68 0 118.5 -35.5t85.5 -86.5v113h46v-530q0 -53 -20 -93t-53.5 -66.5t-78 -40t-93.5 -13.5q-45 0 -81 8.5t-63.5 24t-49 38 t-37.5 49.5l34 23q31 -53 84 -77.5t113 -24.5q40 0 75.5 11t62 32.5t42 53.5t15.5 75v114q-32 -51 -85 -81.5t-111 -30.5zM300 35q33 0 64.5 12.5t57 32.5t42 45t20.5 50v171q-12 30 -32 55.5t-45.5 43.5t-55 28.5t-59.5 10.5q-47 0 -84 -20t-62.5 -52t-39 -72.5 t-13.5 -81.5q0 -45 16 -85t44 -71t66 -49t81 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 735,
    d: "M255 836l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM643 710v-710h-51v340h-448v-340h-51v710h51v-324h448v324h51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 576,
    d: "M213 648l92 81h36l94 -81l-29 -17l-82 63l-82 -63zM503 0h-50v290q0 193 -129 193q-32 0 -62.5 -12t-57 -34t-46.5 -51.5t-30 -63.5v-322h-50v730h50v-334q32 61 88.5 97t121.5 36q43 0 74 -16t51.5 -46t30 -72.5t9.5 -95.5v-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 745,
    d: "M648 710v-127h50v-32h-50v-551h-51v340h-448v-340h-51v551h-50v32h50v127h51v-127h448v127h51zM597 386v165h-448v-165h448z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 576,
    d: "M503 0h-50v290q0 193 -129 193q-32 0 -62.5 -12t-57 -34t-46.5 -51.5t-30 -63.5v-322h-50v623h-66v36h66v71h50v-71h125v-36h-125v-227q32 61 88.5 97t121.5 36q43 0 74 -16t51.5 -46t30 -72.5t9.5 -95.5v-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 237,
    d: "M93 0v710h51v-710h-51zM179 834q-22 0 -39 6t-31 13.5t-27.5 14t-28.5 6.5q-17 0 -27 -7t-15 -15.5t-7 -16t-2 -9.5h-34q0 4 3 17.5t12.5 28t26 26t43.5 11.5q20 0 35.5 -6.5t29.5 -14t28.5 -13.5t33.5 -6q20 0 31.5 7t17 15.5t7 16t1.5 9.5h34q0 -5 -3.5 -18.5 t-13 -27.5t-27.5 -25.5t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 207,
    d: "M78 0v520h50v-520h-50zM164 647q-22 0 -39 6t-31 13.5t-27.5 14t-28.5 6.5q-17 0 -27 -7t-15 -15.5t-7 -16t-2 -9.5h-34q0 4 3 17.5t12.5 28t26 26t43.5 11.5q20 0 35.5 -6.5t29.5 -14t28.5 -13.5t33.5 -6q20 0 31.5 7t17 15.5t7 16t1.5 9.5h34q0 -5 -3.5 -18.5 t-13 -27.5t-27.5 -25.5t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 237,
    d: "M93 0v710h51v-710h-51zM-24 859v37h285v-37h-285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 207,
    d: "M78 0v520h50v-520h-50zM-39 672v37h285v-37h-285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 237,
    d: "M93 0v710h51v-710h-51zM119 853q20 0 36.5 18.5t19.5 45.5h33q0 -19 -7 -36t-19.5 -29.5t-28.5 -19.5t-34 -7t-34.5 7t-28.5 19.5t-19 29.5t-7 36h33q0 -25 17 -44.5t39 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 207,
    d: "M78 0v520h50v-520h-50zM104 666q20 0 36.5 18.5t19.5 45.5h33q0 -19 -7 -36t-19.5 -29.5t-28.5 -19.5t-34 -7t-34.5 7t-28.5 19.5t-19 29.5t-7 36h33q0 -25 17 -44.5t39 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 237,
    d: "M95 -169q-32 7 -49.5 25t-17.5 43t17.5 49.5t55.5 51.5h-8v710h51v-710q-45 -29 -63.5 -50t-18.5 -44q0 -38 49 -45l-16 -30v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 207,
    d: "M80 -169q-32 7 -49.5 25t-17.5 43t17.5 49.5t55.5 51.5h-7v520h50v-520q-45 -29 -63.5 -50t-18.5 -44q0 -38 49 -45zM79 638v92h50v-92h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 237,
    d: "M93 0v710h51v-710h-51zM95 827v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 207,
    d: "M78 0v520h50v-520h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "IJ",
    unicode: "\u0132",
    horizAdvX: 715,
    d: "M93 0v710h51v-710h-51zM269 74q25 -17 60 -27.5t78 -10.5q58 0 92 21t52 61t23.5 98.5t5.5 132.5v361h51v-361q0 -81 -7 -147.5t-30.5 -113.5t-67.5 -73t-119 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ij",
    unicode: "\u0133",
    horizAdvX: 421,
    d: "M78 0v520h50v-520h-50zM78 638v92h50v-92h-50zM197 -177q-32 0 -59.5 8.5t-49.5 28.5l27 33q17 -14 37 -19t40 -5q19 0 37 7.5t32 21t23 32t9 40.5v550h50v-548q0 -33 -12.5 -60t-33.5 -47t-47 -31t-53 -11zM293 638v92h50v-92h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 478,
    d: "M254 836l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM32 74q25 -17 60 -27.5t78 -10.5q58 0 92 21t52 61t23.5 98.5t5.5 132.5v361h51v-361q0 -81 -7 -147.5t-30.5 -113.5t-67.5 -73t-119 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 207,
    d: "M-18 -177q-32 0 -59.5 8.5t-48.5 28.5l27 33q16 -14 36.5 -19t40.5 -5q18 0 36 7.5t32.5 21t23 32t8.5 40.5v550h50v-548q0 -33 -12.5 -60t-33 -47t-47 -31t-53.5 -11zM-12 649l96 81h37l97 -81l-30 -17l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 635,
    d: "M298 -187l15 68h-16v70h49v-70l-21 -68h-27zM93 0v710h51v-431l414 431h59l-295 -311l310 -399h-58l-285 368l-145 -149v-219h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 522,
    d: "M245 -187l15 68h-16v70h49v-70l-21 -68h-27zM454 0l-203 278l-123 -113v-165h-50v730h50v-510l316 299h58l-217 -211l224 -308h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kgreenlandic",
    unicode: "\u0138",
    horizAdvX: 522,
    d: "M454 0l-203 278l-123 -113v-165h-50v520h50v-300l316 299h58l-217 -211l224 -308h-55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 581,
    d: "M338 816l-35 16l61 85h58zM93 0v710h51v-664h424v-46h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 259,
    d: "M98 775l-35 16l61 85h58zM82 730h51v-627q0 -29 16.5 -46t45.5 -17q11 0 26.5 2.5t28.5 7.5l10 -40q-17 -7 -42 -11.5t-43 -4.5q-42 0 -67.5 25.5t-25.5 68.5v642z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 581,
    d: "M306 -187l15 68h-16v70h49v-70l-21 -68h-27zM93 0v710h51v-664h424v-46h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 259,
    d: "M143 -187l15 68h-16v70h49v-70l-21 -68h-27zM82 730h51v-627q0 -29 16.5 -46t45.5 -17q11 0 26.5 2.5t28.5 7.5l10 -40q-17 -7 -42 -11.5t-43 -4.5q-42 0 -67.5 25.5t-25.5 68.5v642z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 581,
    d: "M372 629l-35 16l61 85h58zM93 0v710h51v-664h424v-46h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 259,
    d: "M215 629l-35 16l61 85h58zM82 730h51v-627q0 -29 16.5 -46t45.5 -17q11 0 26.5 2.5t28.5 7.5l10 -40q-17 -7 -42 -11.5t-43 -4.5q-42 0 -67.5 25.5t-25.5 68.5v642z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ldot",
    unicode: "\u013F",
    horizAdvX: 581,
    d: "M93 0v710h51v-664h424v-46h-475zM366 353v101h44v-101h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ldot",
    unicode: "\u0140",
    horizAdvX: 292,
    d: "M82 730h51v-627q0 -29 16.5 -46t45.5 -17q11 0 26.5 2.5t28.5 7.5l10 -40q-17 -7 -42 -11.5t-43 -4.5q-42 0 -67.5 25.5t-25.5 68.5v642zM231 259v101h44v-101h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 588,
    d: "M100 0v279l-60 -53l-19 31l79 70v383h51v-337l167 149l19 -30l-186 -167v-279h424v-46h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 277,
    d: "M99 352l-67 -57l-20 29l87 75v331h51v-287l90 77l20 -30l-110 -94v-293q0 -29 16.5 -46t45.5 -17q11 0 26.5 2.5t28.5 7.5l10 -40q-17 -7 -42 -11.5t-43 -4.5q-42 0 -67.5 25.5t-25.5 68.5v264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 773,
    d: "M389 816l-35 16l61 85h58zM144 614v-614h-51v710h39l498 -625v625h51v-710h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 576,
    d: "M289 629l-35 16l61 85h58zM503 0h-50v290q0 101 -28.5 147t-90.5 46q-33 0 -65.5 -12t-60.5 -34t-49 -51.5t-31 -63.5v-322h-50v520h47v-124q16 30 39.5 54.5t53 42t62.5 27t68 9.5q85 0 120 -59.5t35 -170.5v-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 773,
    d: "M365 -187l15 68h-16v70h49v-70l-21 -68h-27zM144 614v-614h-51v710h39l498 -625v625h51v-710h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 576,
    d: "M259 -187l15 68h-16v70h49v-70l-21 -68h-27zM503 0h-50v290q0 101 -28.5 147t-90.5 46q-33 0 -65.5 -12t-60.5 -34t-49 -51.5t-31 -63.5v-322h-50v520h47v-124q16 30 39.5 54.5t53 42t62.5 27t68 9.5q85 0 120 -59.5t35 -170.5v-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 773,
    d: "M306 917l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM144 614v-614h-51v710h39l498 -625v625h51v-710h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 576,
    d: "M205 730l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM503 0h-50v290q0 101 -28.5 147t-90.5 46q-33 0 -65.5 -12t-60.5 -34t-49 -51.5t-31 -63.5v-322h-50v520h47v-124q16 30 39.5 54.5t53 42t62.5 27t68 9.5q85 0 120 -59.5t35 -170.5v-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "napostrophe",
    unicode: "\u0149",
    horizAdvX: 576,
    d: "M36 629l-34 16l39 54v31h80zM503 0h-50v290q0 101 -28.5 147t-90.5 46q-33 0 -65.5 -12t-60.5 -34t-49 -51.5t-31 -63.5v-322h-50v520h47v-124q16 30 39.5 54.5t53 42t62.5 27t68 9.5q85 0 120 -59.5t35 -170.5v-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 770,
    d: "M144 613v-613h-51v710h39l494 -623v622h51v-738q0 -33 -13 -60t-33.5 -46.5t-46.5 -30.5t-53 -11q-32 0 -59.5 8.5t-49.5 28.5l27 33q17 -14 37 -19t40 -5q18 0 36.5 7.5t32.5 21t23 32t9 40.5v34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 576,
    d: "M358 -177q-32 0 -60 8.5t-49 28.5l27 33q17 -14 37 -19t40 -5q18 0 36 7.5t32.5 21t23 32t8.5 40.5v320q0 101 -28.5 147t-90.5 46q-33 0 -65.5 -12t-60.5 -34t-49 -51.5t-31 -63.5v-322h-50v520h47v-124q16 30 39.5 54.5t53 42t62.5 27t68 9.5q85 0 120 -59.5t35 -170.5 v-327q0 -33 -12.5 -60t-33 -47t-46.5 -31t-53 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 753,
    d: "M235 859v37h285v-37h-285zM376 -5q-74 0 -135 31t-105 81t-68 115t-24 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -130.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5zM95 355q0 -61 20.5 -117.5t58 -100 t89.5 -69.5t114 -26q64 0 115.5 27t88 71.5t56.5 100.5t20 114q0 61 -21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 592,
    d: "M154 672v37h285v-37h-285zM296 -10q-55 0 -101.5 21.5t-80.5 58.5t-53 86t-19 103q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5t100 -21.5t80.5 -58.5t54 -86t19.5 -104q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5zM92 257q0 -46 16 -86.5t43.5 -70.5 t64.5 -47.5t79 -17.5t79 17.5t65 48.5t44 71.5t16 87.5q0 46 -16 86.5t-44 71t-64.5 48.5t-78.5 18t-79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 753,
    d: "M376 -5q-74 0 -135 31t-105 81t-68 115t-24 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -130.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5zM95 355q0 -61 20.5 -117.5t58 -100t89.5 -69.5t114 -26 q64 0 115.5 27t88 71.5t56.5 100.5t20 114q0 61 -21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114zM378 853q20 0 36.5 18.5t19.5 45.5h33q0 -19 -7 -36t-19.5 -29.5t-28.5 -19.5t-34 -7t-34.5 7t-28.5 19.5t-19 29.5t-7 36h33 q0 -25 17 -44.5t39 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 592,
    d: "M296 -10q-55 0 -101.5 21.5t-80.5 58.5t-53 86t-19 103q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5t100 -21.5t80.5 -58.5t54 -86t19.5 -104q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5zM92 257q0 -46 16 -86.5t43.5 -70.5t64.5 -47.5t79 -17.5t79 17.5 t65 48.5t44 71.5t16 87.5q0 46 -16 86.5t-44 71t-64.5 48.5t-78.5 18t-79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5zM296 666q20 0 36.5 18.5t19.5 45.5h33q0 -19 -7 -36t-19.5 -29.5t-28.5 -19.5t-34 -7t-34.5 7t-28.5 19.5t-19 29.5t-7 36h33q0 -25 17 -44.5t39 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 753,
    d: "M314 817l-29 16l59 85h53zM430 817l-30 16l60 85h53zM376 -5q-74 0 -135 31t-105 81t-68 115t-24 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -130.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5zM95 355 q0 -61 20.5 -117.5t58 -100t89.5 -69.5t114 -26q64 0 115.5 27t88 71.5t56.5 100.5t20 114q0 61 -21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 592,
    d: "M232 629l-29 16l59 85h53zM348 629l-30 16l60 85h53zM296 -10q-55 0 -101.5 21.5t-80.5 58.5t-53 86t-19 103q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5t100 -21.5t80.5 -58.5t54 -86t19.5 -104q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5zM92 257 q0 -46 16 -86.5t43.5 -70.5t64.5 -47.5t79 -17.5t79 17.5t65 48.5t44 71.5t16 87.5q0 46 -16 86.5t-44 71t-64.5 48.5t-78.5 18t-79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1173,
    d: "M1128 46v-46h-469v200q-17 -43 -45 -80.5t-64.5 -65t-80 -43.5t-91.5 -16q-74 0 -135.5 30.5t-105.5 81t-68.5 115.5t-24.5 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q50 0 94.5 -16.5t80.5 -44.5t63 -65.5t44 -79.5v201h460v-46h-410v-278h356v-47h-356v-293h419z M377 42q64 0 115.5 27t88 71.5t56.5 100.5t20 115q0 61 -21 117t-58.5 99.5t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114q0 -61 20.5 -117.5t58 -100t89.5 -69.5t114 -26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1040,
    d: "M294 -10q-53 0 -99 21t-80 57t-53.5 85t-19.5 105q0 57 19.5 106t54 86t81 58t100.5 21q39 0 74.5 -12.5t65 -35.5t52 -55.5t34.5 -72.5q26 83 86.5 129.5t144.5 46.5q54 0 100.5 -20.5t80.5 -58.5t53.5 -91t19.5 -119h-457q4 -44 22 -82t47 -66.5t67 -45t80 -16.5 q28 0 55 7.5t49.5 20.5t39.5 31.5t26 40.5l43 -12q-12 -29 -34 -52.5t-50.5 -40t-62.5 -26t-69 -9.5q-39 0 -76 12.5t-68.5 36t-55.5 55.5t-39 71q-15 -40 -38.5 -72.5t-53 -55t-65 -35t-74.5 -12.5zM295 35q43 0 80 17.5t64.5 47.5t43.5 71t16 88t-16 88t-43 71.5t-64 48 t-79 17.5t-79.5 -18t-65.5 -49t-44 -72.5t-16 -88.5t16 -87t43.5 -70t64.5 -47t79 -17zM959 277q-3 46 -20 85t-44.5 67t-64 43.5t-77.5 15.5t-77 -16t-63 -44t-43.5 -66.5t-18.5 -84.5h408z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 649,
    d: "M316 819l-35 16l61 85h58zM93 0v710h295q45 0 83 -19t65.5 -50.5t43 -71t15.5 -79.5q0 -39 -12 -75.5t-34 -65.5t-53 -48t-68 -25l177 -276h-59l-172 268h-230v-268h-51zM144 315h249q34 0 62 15t48 39.5t30.5 56t10.5 64.5q0 34 -12.5 65.5t-34 55.5t-50 38.5 t-61.5 14.5h-242v-349z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 341,
    d: "M191 629l-35 16l61 85h58zM324 475q-70 -2 -122.5 -41.5t-73.5 -108.5v-325h-50v520h48v-128q27 55 71.5 89.5t95.5 39.5q10 1 18 1h13v-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 649,
    d: "M297 -187l15 68h-16v70h49v-70l-21 -68h-27zM93 0v710h295q45 0 83 -19t65.5 -50.5t43 -71t15.5 -79.5q0 -39 -12 -75.5t-34 -65.5t-53 -48t-68 -25l177 -276h-59l-172 268h-230v-268h-51zM144 315h249q34 0 62 15t48 39.5t30.5 56t10.5 64.5q0 34 -12.5 65.5t-34 55.5 t-50 38.5t-61.5 14.5h-242v-349z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 341,
    d: "M76 -187l15 68h-16v70h49v-70l-21 -68h-27zM324 475q-70 -2 -122.5 -41.5t-73.5 -108.5v-325h-50v520h48v-128q27 55 71.5 89.5t95.5 39.5q10 1 18 1h13v-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 649,
    d: "M232 920l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM93 0v710h295q45 0 83 -19t65.5 -50.5t43 -71t15.5 -79.5q0 -39 -12 -75.5t-34 -65.5t-53 -48t-68 -25l177 -276h-59l-172 268h-230v-268h-51zM144 315h249q34 0 62 15t48 39.5t30.5 56t10.5 64.5q0 34 -12.5 65.5 t-34 55.5t-50 38.5t-61.5 14.5h-242v-349z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 341,
    d: "M107 730l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM324 475q-70 -2 -122.5 -41.5t-73.5 -108.5v-325h-50v520h48v-128q27 55 71.5 89.5t95.5 39.5q10 1 18 1h13v-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 605,
    d: "M311 835l-35 16l61 85h58zM506 592q-69 77 -195 77q-104 0 -151.5 -39.5t-47.5 -106.5q0 -34 12 -56.5t37.5 -38.5t64.5 -27t94 -23q57 -12 103.5 -26.5t79 -36.5t50 -54t17.5 -79t-18.5 -82t-52 -58.5t-80 -35.5t-103.5 -12q-166 0 -281 106l27 41q45 -47 110 -74.5 t146 -27.5q93 0 145.5 34t52.5 103q0 35 -14 59.5t-41.5 42.5t-69.5 31t-98 25q-57 12 -100.5 25.5t-73 34t-44.5 49.5t-15 73q0 48 18.5 85t51.5 62.5t79 38.5t102 13q69 0 123 -20.5t98 -62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 481,
    d: "M243 629l-35 16l61 85h58zM243 -10q-60 0 -115 20t-96 60l25 34q42 -38 87 -56t99 -18q68 0 109.5 28.5t41.5 79.5q0 24 -10.5 40.5t-31.5 28t-52 20.5t-72 19q-44 10 -76.5 20t-53.5 24t-31.5 34t-10.5 51q0 39 15 68t41.5 48t61 28.5t73.5 9.5q61 0 108 -20.5t73 -52.5 l-28 -27q-26 30 -67.5 45t-88.5 15q-29 0 -54.5 -6t-44.5 -19t-30 -33.5t-11 -48.5q0 -23 7.5 -37t24 -24t42.5 -17.5t62 -16.5q49 -12 87 -23t63.5 -27t39 -38t13.5 -56q0 -70 -54.5 -111.5t-145.5 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 605,
    d: "M197 855l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM506 592q-69 77 -195 77q-104 0 -151.5 -39.5t-47.5 -106.5q0 -34 12 -56.5t37.5 -38.5t64.5 -27t94 -23q57 -12 103.5 -26.5t79 -36.5t50 -54t17.5 -79t-18.5 -82t-52 -58.5t-80 -35.5t-103.5 -12q-166 0 -281 106 l27 41q45 -47 110 -74.5t146 -27.5q93 0 145.5 34t52.5 103q0 35 -14 59.5t-41.5 42.5t-69.5 31t-98 25q-57 12 -100.5 25.5t-73 34t-44.5 49.5t-15 73q0 48 18.5 85t51.5 62.5t79 38.5t102 13q69 0 123 -20.5t98 -62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 481,
    d: "M129 649l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM243 -10q-60 0 -115 20t-96 60l25 34q42 -38 87 -56t99 -18q68 0 109.5 28.5t41.5 79.5q0 24 -10.5 40.5t-31.5 28t-52 20.5t-72 19q-44 10 -76.5 20t-53.5 24t-31.5 34t-10.5 51q0 39 15 68t41.5 48t61 28.5t73.5 9.5 q61 0 108 -20.5t73 -52.5l-28 -27q-26 30 -67.5 45t-88.5 15q-29 0 -54.5 -6t-44.5 -19t-30 -33.5t-11 -48.5q0 -23 7.5 -37t24 -24t42.5 -17.5t62 -16.5q49 -12 87 -23t63.5 -27t39 -38t13.5 -56q0 -70 -54.5 -111.5t-145.5 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015E",
    unicode: "\u015E",
    horizAdvX: 606,
    d: "M246 -125q14 -7 37.5 -13t49.5 -6q58 0 58 37q0 20 -13.5 28t-35.5 8q-21 0 -44 -5t-37 -9l44 79q-80 2 -146.5 28t-122.5 78l27 41q45 -47 110 -74.5t146 -27.5q93 0 145.5 34t52.5 103q0 35 -14 59.5t-41.5 42.5t-69.5 31t-98 25q-57 12 -100.5 25.5t-73 34t-44.5 49.5 t-15 73q0 48 18.5 85t51.5 62.5t79 38.5t102 13q69 0 123 -20.5t98 -62.5l-26 -40q-69 77 -195 77q-104 0 -151.5 -39.5t-47.5 -106.5q0 -34 12 -56.5t37.5 -38.5t64.5 -27t94 -23q57 -12 103.5 -26.5t79 -36.5t50 -54t17.5 -79q0 -45 -16.5 -79t-47 -57.5t-73.5 -36 t-95 -14.5l-29 -48q9 4 20.5 5t19.5 1q34 0 53 -15t19 -44q0 -32 -24 -48.5t-69 -16.5q-29 0 -53.5 5.5t-43.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni015F",
    unicode: "\u015F",
    horizAdvX: 482,
    d: "M167 -125q14 -7 37.5 -13t49.5 -6q58 0 58 37q0 20 -13.5 28t-35.5 8q-21 0 -44 -5t-37 -9l42 76q-55 3 -104.5 22.5t-87.5 56.5l25 34q42 -38 87 -56t99 -18q68 0 109.5 28.5t41.5 79.5q0 24 -10.5 40.5t-31.5 28t-52 20.5t-72 19q-44 10 -76.5 20t-53.5 24t-31.5 34 t-10.5 51q0 39 15 68t41.5 48t61 28.5t73.5 9.5q61 0 108 -20.5t73 -52.5l-28 -27q-26 30 -67.5 45t-88.5 15q-29 0 -54.5 -6t-44.5 -19t-30 -33.5t-11 -48.5q0 -23 7.5 -37t24 -24t42.5 -17.5t62 -16.5q49 -12 87 -23t63.5 -27t39 -38t13.5 -56q0 -68 -50.5 -108.5 t-135.5 -43.5l-26 -44q9 4 20.5 5t19.5 1q34 0 53 -15t19 -44q0 -32 -24 -48.5t-69 -16.5q-29 0 -53.5 5.5t-43.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 605,
    d: "M227 936l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM506 592q-69 77 -195 77q-104 0 -151.5 -39.5t-47.5 -106.5q0 -34 12 -56.5t37.5 -38.5t64.5 -27t94 -23q57 -12 103.5 -26.5t79 -36.5t50 -54t17.5 -79t-18.5 -82t-52 -58.5t-80 -35.5t-103.5 -12q-166 0 -281 106 l27 41q45 -47 110 -74.5t146 -27.5q93 0 145.5 34t52.5 103q0 35 -14 59.5t-41.5 42.5t-69.5 31t-98 25q-57 12 -100.5 25.5t-73 34t-44.5 49.5t-15 73q0 48 18.5 85t51.5 62.5t79 38.5t102 13q69 0 123 -20.5t98 -62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 481,
    d: "M159 730l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM243 -10q-60 0 -115 20t-96 60l25 34q42 -38 87 -56t99 -18q68 0 109.5 28.5t41.5 79.5q0 24 -10.5 40.5t-31.5 28t-52 20.5t-72 19q-44 10 -76.5 20t-53.5 24t-31.5 34t-10.5 51q0 39 15 68t41.5 48t61 28.5t73.5 9.5 q61 0 108 -20.5t73 -52.5l-28 -27q-26 30 -67.5 45t-88.5 15q-29 0 -54.5 -6t-44.5 -19t-30 -33.5t-11 -48.5q0 -23 7.5 -37t24 -24t42.5 -17.5t62 -16.5q49 -12 87 -23t63.5 -27t39 -38t13.5 -56q0 -70 -54.5 -111.5t-145.5 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0162",
    unicode: "\u0162",
    horizAdvX: 605,
    d: "M225 -125q14 -7 37.5 -13t49.5 -6q58 0 58 37q0 20 -13.5 28t-35.5 8q-21 0 -44 -5t-37 -9l47 85h-10v664h-260v46h571v-46h-260v-664h-7l-32 -53q9 4 20.5 5t19.5 1q34 0 53 -15t19 -44q0 -32 -24 -48.5t-69 -16.5q-29 0 -53.5 5.5t-43.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0163",
    unicode: "\u0163",
    horizAdvX: 320,
    d: "M124 -125q14 -7 37.5 -13t49.5 -6q58 0 58 37q0 20 -13.5 28t-35.5 8q-21 0 -44 -5t-37 -9l45 80q-36 5 -60.5 28t-24.5 64v392h-73v41h73v178h50v-178h121v-41h-121v-380q0 -29 20 -43.5t45 -14.5q31 0 53.5 10.5t27.5 13.5l15 -40q-7 -5 -32 -16t-61 -14l-29 -48 q9 4 20.5 5t19.5 1q34 0 53 -15t19 -44q0 -32 -24 -48.5t-69 -16.5q-29 0 -53.5 5.5t-43.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 606,
    d: "M220 917l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM589 664h-260v-664h-51v664h-260v46h571v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 320,
    d: "M254 629l-35 16l61 85h58zM310 25q-4 -2 -13.5 -7.5t-24 -10.5t-32.5 -9t-39 -4t-39.5 6t-32.5 18t-22 29t-8 40v392h-73v41h73v178h50v-178h121v-41h-121v-380q0 -29 20 -43.5t45 -14.5q31 0 53.5 10.5t27.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 641,
    d: "M606 664h-260v-252h228v-32h-228v-380h-51v380h-228v32h228v252h-260v46h571v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 322,
    d: "M311 25q-4 -2 -13.5 -7.5t-24 -10.5t-32.5 -9t-39 -4t-39.5 6t-32.5 18t-22 29t-8 40v232h-73v36h73v124h-73v41h73v178h50v-178h121v-41h-121v-124h121v-36h-121v-220q0 -29 20 -43.5t45 -14.5q31 0 53.5 10.5t27.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 756,
    d: "M378 42q72 0 119.5 27t75 71t39 100t11.5 113v357h51v-357q0 -71 -15.5 -136t-50.5 -114.5t-91 -78.5t-138 -29q-85 0 -142 30.5t-91.5 81t-49 114.5t-14.5 132v357h51v-357q0 -59 11.5 -115t40 -99.5t75.5 -70t118 -26.5zM440 834q-22 0 -39 6t-31 13.5t-27.5 14 t-28.5 6.5q-17 0 -27 -7t-15 -15.5t-7 -16t-2 -9.5h-34q0 4 3 17.5t12.5 28t26 26t43.5 11.5q20 0 35.5 -6.5t29.5 -14t28.5 -13.5t33.5 -6q20 0 31.5 7t17 15.5t7 16t1.5 9.5h34q0 -5 -3.5 -18.5t-13 -27.5t-27.5 -25.5t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 587,
    d: "M239 -10q-166 0 -166 230v300h50v-293q0 -192 131 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-5 -1 -9 -1h-6q-20 0 -35.5 12.5t-15.5 33.5v78q-34 -63 -93.5 -98t-128.5 -35zM349 647q-22 0 -39 6t-31 13.5t-27.5 14t-28.5 6.5 q-17 0 -27 -7t-15 -15.5t-7 -16t-2 -9.5h-34q0 4 3 17.5t12.5 28t26 26t43.5 11.5q20 0 35.5 -6.5t29.5 -14t28.5 -13.5t33.5 -6q20 0 31.5 7t17 15.5t7 16t1.5 9.5h34q0 -5 -3.5 -18.5t-13 -27.5t-27.5 -25.5t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 756,
    d: "M378 42q72 0 119.5 27t75 71t39 100t11.5 113v357h51v-357q0 -71 -15.5 -136t-50.5 -114.5t-91 -78.5t-138 -29q-85 0 -142 30.5t-91.5 81t-49 114.5t-14.5 132v357h51v-357q0 -59 11.5 -115t40 -99.5t75.5 -70t118 -26.5zM236 859v37h285v-37h-285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 587,
    d: "M239 -10q-166 0 -166 230v300h50v-293q0 -192 131 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-5 -1 -9 -1h-6q-20 0 -35.5 12.5t-15.5 33.5v78q-34 -63 -93.5 -98t-128.5 -35zM145 672v37h285v-37h-285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 756,
    d: "M378 42q72 0 119.5 27t75 71t39 100t11.5 113v357h51v-357q0 -71 -15.5 -136t-50.5 -114.5t-91 -78.5t-138 -29q-85 0 -142 30.5t-91.5 81t-49 114.5t-14.5 132v357h51v-357q0 -59 11.5 -115t40 -99.5t75.5 -70t118 -26.5zM379 853q20 0 36.5 18.5t19.5 45.5h33 q0 -19 -7 -36t-19.5 -29.5t-28.5 -19.5t-34 -7t-34.5 7t-28.5 19.5t-19 29.5t-7 36h33q0 -25 17 -44.5t39 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 587,
    d: "M239 -10q-166 0 -166 230v300h50v-293q0 -192 131 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-5 -1 -9 -1h-6q-20 0 -35.5 12.5t-15.5 33.5v78q-34 -63 -93.5 -98t-128.5 -35zM288 666q20 0 36.5 18.5t19.5 45.5h33q0 -19 -7 -36 t-19.5 -29.5t-28.5 -19.5t-34 -7t-34.5 7t-28.5 19.5t-19 29.5t-7 36h33q0 -25 17 -44.5t39 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 756,
    d: "M310 855q0 27 19.5 44.5t48.5 17.5t48.5 -17.5t19.5 -44.5q0 -28 -19.5 -45.5t-48.5 -17.5t-48.5 17.5t-19.5 45.5zM378 894q-17 0 -28.5 -10.5t-11.5 -28.5q0 -17 11.5 -28.5t28.5 -11.5q16 0 28.5 11.5t12.5 28.5q0 18 -12 28.5t-29 10.5zM378 42q72 0 119.5 27t75 71 t39 100t11.5 113v357h51v-357q0 -71 -15.5 -136t-50.5 -114.5t-91 -78.5t-138 -29q-85 0 -142 30.5t-91.5 81t-49 114.5t-14.5 132v357h51v-357q0 -59 11.5 -115t40 -99.5t75.5 -70t118 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 587,
    d: "M219 668q0 27 19.5 44.5t48.5 17.5t48.5 -17.5t19.5 -44.5q0 -28 -19.5 -45.5t-48.5 -17.5t-48.5 17.5t-19.5 45.5zM287 707q-17 0 -28.5 -10.5t-11.5 -28.5q0 -17 11.5 -28.5t28.5 -11.5q16 0 28.5 11.5t12.5 28.5q0 18 -12 28.5t-29 10.5zM239 -10q-166 0 -166 230v300 h50v-293q0 -192 131 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-5 -1 -9 -1h-6q-20 0 -35.5 12.5t-15.5 33.5v78q-34 -63 -93.5 -98t-128.5 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 756,
    d: "M378 42q72 0 119.5 27t75 71t39 100t11.5 113v357h51v-357q0 -71 -15.5 -136t-50.5 -114.5t-91 -78.5t-138 -29q-85 0 -142 30.5t-91.5 81t-49 114.5t-14.5 132v357h51v-357q0 -59 11.5 -115t40 -99.5t75.5 -70t118 -26.5zM315 817l-29 16l59 85h53zM431 817l-30 16 l60 85h53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 587,
    d: "M239 -10q-166 0 -166 230v300h50v-293q0 -192 131 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-5 -1 -9 -1h-6q-20 0 -35.5 12.5t-15.5 33.5v78q-34 -63 -93.5 -98t-128.5 -35zM224 629l-29 16l59 85h53zM340 629l-30 16l60 85h53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 756,
    d: "M378 42q72 0 119.5 27t75 71t39 100t11.5 113v357h51v-357q0 -70 -15 -133.5t-48 -112t-86.5 -78.5t-130.5 -33q-44 -29 -61.5 -49.5t-17.5 -43.5q0 -38 49 -45l-16 -30q-32 7 -49.5 25t-17.5 43t17 49t55 51q-77 5 -129 37t-83.5 81.5t-45 111.5t-13.5 127v357h51v-357 q0 -59 11.5 -115t40 -99.5t75.5 -70t118 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 587,
    d: "M239 -10q-166 0 -166 230v300h50v-293q0 -192 131 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-45 -29 -63.5 -50t-18.5 -44q0 -38 49 -45l-16 -30q-32 7 -49.5 25t-17.5 43q0 26 18.5 51t59.5 53q-12 5 -20 16t-8 26v78 q-34 -63 -93.5 -98t-128.5 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1043,
    d: "M406 836l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM365 705h50l106 -258l106 258h50l-125 -299l149 -346l272 650h56l-304 -710h-47l-156 365l-157 -365h-47l-303 710h55l273 -650l147 346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 806,
    d: "M288 649l96 81h37l97 -81l-30 -17l-85 63l-85 -63zM737 520h50l-225 -520h-42l-117 275l-117 -275h-42l-225 520h49l199 -465l109 256l-88 208h43l72 -172l71 172h44l-88 -208l109 -256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 647,
    d: "M75 710l248 -393l249 393h57l-280 -442v-268h-51v270l-279 440h56zM208 836l96 81h37l97 -81l-30 -17l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 540,
    d: "M113 -176q5 -1 15 -1t18.5 1t16.5 5q6 3 11 8.5t14 22.5t23 50t38 90l-232 520h52l207 -471l193 471h49l-285 -684q-11 -28 -35.5 -43.5t-66.5 -15.5h-8.5t-9.5 1v46zM161 649l96 81h37l97 -81l-30 -17l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 647,
    d: "M75 710l248 -393l249 393h57l-280 -442v-268h-51v270l-279 440h56zM233 828v88h44v-88h-44zM369 828v88h44v-88h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 627,
    d: "M330 816l-35 16l61 85h58zM30 42l505 622h-498v46h558v-42l-501 -622h499v-46h-563v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 490,
    d: "M256 629l-35 16l61 85h58zM32 36l368 445h-362v39h418v-36l-367 -445h365v-39h-422v36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 627,
    d: "M30 42l505 622h-498v46h558v-42l-501 -622h499v-46h-563v42zM307 827v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 490,
    d: "M32 36l368 445h-362v39h418v-36l-367 -445h365v-39h-422v36zM234 640v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 627,
    d: "M246 917l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM30 42l505 622h-498v46h558v-42l-501 -622h499v-46h-563v42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 490,
    d: "M172 730l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM32 36l368 445h-362v39h418v-36l-367 -445h365v-39h-422v36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Schwa",
    unicode: "\u018F",
    horizAdvX: 738,
    d: "M365 -8q-71 0 -132 28t-106 77t-71 114t-26 140q0 5 0.5 13.5t1.5 10.5h605q-5 63 -29 116.5t-61.5 92.5t-86 61t-102.5 22q-38 0 -73.5 -10.5t-66.5 -30t-54 -46t-35 -59.5l-49 23q16 37 45.5 68.5t67 54t81.5 35.5t89 13q68 0 128 -29t105 -78.5t71 -116t26 -142.5 q0 -75 -25.5 -140t-70 -113t-104 -76t-128.5 -28zM365 40q55 0 103.5 22t85 60.5t59 91.5t25.5 115h-552q4 -62 27 -115t60.5 -91.5t86.5 -60.5t105 -22z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    horizAdvX: 519,
    d: "M139 -177q-32 0 -59.5 8.5t-49.5 28.5l27 33q17 -14 37 -19t40 -5q19 0 37 7.5t32 21t23 32t9 40.5v448h-74v41h74v78q0 96 39 149.5t108 53.5q29 0 57 -9t47 -24l-19 -36q-13 11 -34 18t-43 7q-51 0 -78 -40.5t-27 -117.5v-79h148v-41h-148v-447q0 -33 -12.5 -60 t-33.5 -46.5t-47 -30.5t-53 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C4",
    unicode: "\u01C4",
    horizAdvX: 1340,
    d: "M959 917l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM743 42l505 622h-498v46h558v-42l-501 -622h499v-46h-563v42zM93 0v710h236q84 0 147.5 -28t105.5 -76t63 -112.5t21 -137.5q0 -81 -23.5 -146.5t-67.5 -112t-106.5 -72t-139.5 -25.5h-236zM615 356q0 67 -19 123.5 t-55.5 97.5t-89.5 64t-122 23h-185v-618h185q70 0 123.5 23.5t89.5 65.5t54.5 98.5t18.5 122.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C5",
    unicode: "\u01C5",
    horizAdvX: 1203,
    d: "M885 730l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM745 36l368 445h-362v39h418v-36l-367 -445h365v-39h-422v36zM93 0v710h236q84 0 147.5 -28t105.5 -76t63 -112.5t21 -137.5q0 -81 -23.5 -146.5t-67.5 -112t-106.5 -72t-139.5 -25.5h-236zM615 356q0 67 -19 123.5 t-55.5 97.5t-89.5 64t-122 23h-185v-618h185q70 0 123.5 23.5t89.5 65.5t54.5 98.5t18.5 122.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C6",
    unicode: "\u01C6",
    horizAdvX: 1105,
    d: "M787 730l85 -63l85 63l30 -17l-97 -81h-37l-96 81zM647 36l368 445h-362v39h418v-36l-367 -445h365v-39h-422v36zM292 -10q-54 0 -100 22.5t-79.5 60t-52 86t-18.5 100.5q0 54 18 103t50 86t75.5 59t95.5 22q34 0 64 -10t56 -26.5t47 -38.5t36 -47v323h50v-660 q0 -25 21 -25v-45q-6 -1 -10 -1.5t-8 -0.5q-20 0 -34 15.5t-14 32.5v58q-32 -52 -85.5 -83t-111.5 -31zM301 35q27 0 58 11t57.5 30.5t45.5 44.5t22 54v171q-11 28 -31.5 53.5t-46.5 44t-56 29.5t-58 11q-45 0 -82 -19.5t-63 -51t-40 -72t-14 -83.5q0 -45 16 -85t44.5 -71 t66 -49t81.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C7",
    unicode: "\u01C7",
    horizAdvX: 1060,
    d: "M613 74q25 -17 60 -27.5t78 -10.5q58 0 92 21t52 61t23.5 98.5t5.5 132.5v361h51v-361q0 -81 -7 -147.5t-30.5 -113.5t-67.5 -73t-119 -26q-90 0 -154 44zM93 0v710h51v-664h424v-46h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C8",
    unicode: "\u01C8",
    horizAdvX: 795,
    d: "M571 -177q-32 0 -59.5 8.5t-49.5 28.5l27 33q17 -14 37 -19t40 -5q19 0 37 7.5t32 21t23 32t9 40.5v550h50v-548q0 -33 -12.5 -60t-33.5 -47t-47 -31t-53 -11zM667 638v92h50v-92h-50zM93 0v710h51v-664h424v-46h-475z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01C9",
    unicode: "\u01C9",
    horizAdvX: 473,
    d: "M249 -177q-32 0 -59.5 8.5t-49.5 28.5l27 33q17 -14 37 -19t40 -5q19 0 37 7.5t32 21t23 32t9 40.5v550h50v-548q0 -33 -12.5 -60t-33.5 -47t-47 -31t-53 -11zM345 638v92h50v-92h-50zM82 730h51v-627q0 -29 16.5 -46t45.5 -17q11 0 26.5 2.5t28.5 7.5l10 -40 q-17 -7 -42 -11.5t-43 -4.5q-42 0 -67.5 25.5t-25.5 68.5v642z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CA",
    unicode: "\u01CA",
    horizAdvX: 1252,
    d: "M805 74q25 -17 60 -27.5t78 -10.5q58 0 92 21t52 61t23.5 98.5t5.5 132.5v361h51v-361q0 -81 -7 -147.5t-30.5 -113.5t-67.5 -73t-119 -26q-90 0 -154 44zM144 614v-614h-51v710h39l498 -625v625h51v-710h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CB",
    unicode: "\u01CB",
    horizAdvX: 987,
    d: "M763 -177q-32 0 -59.5 8.5t-49.5 28.5l27 33q17 -14 37 -19t40 -5q19 0 37 7.5t32 21t23 32t9 40.5v550h50v-548q0 -33 -12.5 -60t-33.5 -47t-47 -31t-53 -11zM859 638v92h50v-92h-50zM144 614v-614h-51v710h39l498 -625v625h51v-710h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01CC",
    unicode: "\u01CC",
    horizAdvX: 790,
    d: "M566 -177q-32 0 -59.5 8.5t-49.5 28.5l27 33q17 -14 37 -19t40 -5q19 0 37 7.5t32 21t23 32t9 40.5v550h50v-548q0 -33 -12.5 -60t-33.5 -47t-47 -31t-53 -11zM662 638v92h50v-92h-50zM503 0h-50v290q0 101 -28.5 147t-90.5 46q-33 0 -65.5 -12t-60.5 -34t-49 -51.5 t-31 -63.5v-322h-50v520h47v-124q16 30 39.5 54.5t53 42t62.5 27t68 9.5q85 0 120 -59.5t35 -170.5v-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oogonek",
    unicode: "\u01EA",
    horizAdvX: 753,
    d: "M347 -172q-32 7 -49.5 25t-17.5 43t17 49t55 51q-69 5 -126 37.5t-97.5 82t-62.5 111.5t-22 128q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -130.5q0 -69 -24 -132.5t-66 -112.5t-100 -79.5t-125 -34.5q-45 -29 -62.5 -49.5 t-17.5 -43.5q0 -38 49 -45zM95 355q0 -61 20.5 -117.5t58 -100t89.5 -69.5t114 -26q64 0 115.5 27t88 71.5t56.5 100.5t20 114q0 61 -21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oogonek",
    unicode: "\u01EB",
    horizAdvX: 592,
    d: "M280 -176q-32 7 -49.5 25t-17.5 43t16.5 48.5t52.5 50.5q-52 3 -96 25t-76 58.5t-50 84t-18 100.5q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5t100 -21.5t80.5 -58.5t54 -86t19.5 -104q0 -51 -16.5 -96.5t-46.5 -81.5t-71 -59.5t-89 -29.5q-45 -29 -62.5 -49.5 t-17.5 -43.5q0 -38 49 -45zM92 257q0 -46 16 -86.5t43.5 -70.5t64.5 -47.5t79 -17.5t79 17.5t65 48.5t44 71.5t16 87.5q0 46 -16 86.5t-44 71t-64.5 48.5t-78.5 18t-79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F1",
    unicode: "\u01F1",
    horizAdvX: 1325,
    d: "M727 42l505 622h-498v46h558v-42l-501 -622h499v-46h-563v42zM93 0v710h236q84 0 147.5 -28t105.5 -76t63 -112.5t21 -137.5q0 -81 -23.5 -146.5t-67.5 -112t-106.5 -72t-139.5 -25.5h-236zM615 356q0 67 -19 123.5t-55.5 97.5t-89.5 64t-122 23h-185v-618h185 q70 0 123.5 23.5t89.5 65.5t54.5 98.5t18.5 122.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F2",
    unicode: "\u01F2",
    horizAdvX: 1203,
    d: "M745 36l368 445h-362v39h418v-36l-367 -445h365v-39h-422v36zM93 0v710h236q84 0 147.5 -28t105.5 -76t63 -112.5t21 -137.5q0 -81 -23.5 -146.5t-67.5 -112t-106.5 -72t-139.5 -25.5h-236zM615 356q0 67 -19 123.5t-55.5 97.5t-89.5 64t-122 23h-185v-618h185 q70 0 123.5 23.5t89.5 65.5t54.5 98.5t18.5 122.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni01F3",
    unicode: "\u01F3",
    horizAdvX: 1105,
    d: "M647 36l368 445h-362v39h418v-36l-367 -445h365v-39h-422v36zM292 -10q-54 0 -100 22.5t-79.5 60t-52 86t-18.5 100.5q0 54 18 103t50 86t75.5 59t95.5 22q34 0 64 -10t56 -26.5t47 -38.5t36 -47v323h50v-660q0 -25 21 -25v-45q-6 -1 -10 -1.5t-8 -0.5q-20 0 -34 15.5 t-14 32.5v58q-32 -52 -85.5 -83t-111.5 -31zM301 35q27 0 58 11t57.5 30.5t45.5 44.5t22 54v171q-11 28 -31.5 53.5t-46.5 44t-56 29.5t-58 11q-45 0 -82 -19.5t-63 -51t-40 -72t-14 -83.5q0 -45 16 -85t44.5 -71t66 -49t81.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gacute",
    unicode: "\u01F4",
    horizAdvX: 717,
    d: "M371 816l-35 16l61 85h58zM616 111q-103 -116 -239 -116q-72 0 -133.5 31t-105.5 82t-69 116t-25 132q0 70 24.5 135t68 115t103.5 79.5t131 29.5q53 0 95.5 -11.5t76 -32t58 -49t41.5 -62.5l-42 -25q-36 70 -95.5 101.5t-134.5 31.5q-63 0 -114 -27t-87 -71t-55 -100 t-19 -115q0 -63 22 -119.5t60.5 -99.5t90.5 -68.5t112 -25.5q65 0 123.5 30t112.5 95v137h-161v41h205v-345h-44v111z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gacute",
    unicode: "\u01F5",
    d: "M300 629l-35 16l61 85h58zM288 -8q-54 0 -99 22.5t-77.5 60t-51 85.5t-18.5 99q0 53 17.5 102t49.5 86.5t76.5 59.5t98.5 22q68 0 118.5 -35.5t85.5 -86.5v113h46v-530q0 -53 -20 -93t-53.5 -66.5t-78 -40t-93.5 -13.5q-45 0 -81 8.5t-63.5 24t-49 38t-37.5 49.5l34 23 q31 -53 84 -77.5t113 -24.5q40 0 75.5 11t62 32.5t42 53.5t15.5 75v114q-32 -51 -85 -81.5t-111 -30.5zM300 35q33 0 64.5 12.5t57 32.5t42 45t20.5 50v171q-12 30 -32 55.5t-45.5 43.5t-55 28.5t-59.5 10.5q-47 0 -84 -20t-62.5 -52t-39 -72.5t-13.5 -81.5q0 -45 16 -85 t44 -71t66 -49t81 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 675,
    d: "M269 750q0 27 19.5 44.5t48.5 17.5t48.5 -17.5t19.5 -44.5q0 -20 -10.5 -35t-27.5 -22l293 -693h-54l-99 234h-339l-99 -234h-55l294 692q-18 7 -28.5 22.5t-10.5 35.5zM493 276l-155 372l-158 -372h313zM337 789q-17 0 -28.5 -10.5t-11.5 -28.5q0 -17 11.5 -28.5 t28.5 -11.5q16 0 28.5 11.5t12.5 28.5q0 18 -12 28.5t-29 10.5zM340 819l-35 16l61 83h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 537,
    d: "M206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68.5 32t88 11.5q42 0 84.5 -7.5t76.5 -20.5v51q0 74 -42 117.5t-114 43.5q-38 0 -80.5 -16t-86.5 -46l-19 34q100 68 190 68q94 0 148 -54.5t54 -150.5v-254q0 -25 22 -25v-45q-5 -1 -10.5 -1.5 t-9.5 -0.5q-20 0 -32 13.5t-14 32.5v43q-36 -47 -92 -72t-121 -25zM216 30q58 0 106.5 22t74.5 58q16 21 16 40v92q-36 14 -75 21t-81 7q-39 0 -71 -8.5t-55 -23.5t-35.5 -36.5t-12.5 -47.5t10 -49t28 -39.5t42.5 -26t52.5 -9.5zM260 773l-35 16l61 85h58zM192 668 q0 27 19.5 44.5t48.5 17.5t48.5 -17.5t19.5 -44.5q0 -28 -19.5 -45.5t-48.5 -17.5t-48.5 17.5t-19.5 45.5zM260 707q-17 0 -28.5 -10.5t-11.5 -28.5q0 -17 11.5 -28.5t28.5 -11.5q16 0 28.5 11.5t12.5 28.5q0 18 -12 28.5t-29 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 962,
    d: "M493 816l-35 16l61 85h58zM434 710h474v-46h-410v-278h356v-47h-356v-293h419v-46h-469v234h-267l-151 -234h-57zM445 280v366l-240 -366h240z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 930,
    d: "M439 629l-35 16l61 85h58zM206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68 32t87.5 11.5q35 0 71 -5.5t67 -14.5q2 21 6.5 42.5t12.5 41.5q-11 56 -50.5 88t-100.5 32q-38 0 -80.5 -16t-86.5 -46l-20 34q101 68 191 68q66 0 111.5 -29t67.5 -82 q32 50 85 80.5t117 30.5q55 0 102 -21t81.5 -58t54 -86t19.5 -104q0 -3 -0.5 -10.5t-0.5 -9.5h-461q3 -45 21 -83.5t46.5 -66.5t65.5 -44t78 -16q27 0 53.5 7.5t49 20.5t40 31.5t27.5 40.5l44 -12q-12 -28 -33.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5q-67 0 -122 32t-90 85 q-16 -31 -42 -53t-57 -36.5t-64.5 -21t-64.5 -6.5zM216 30q58 0 107 21.5t74 58.5q15 19 16 35q-11 23 -17 51t-7 54q-63 20 -132 20q-78 0 -126 -32t-48 -84q0 -26 10 -49t28 -39.5t42.5 -26t52.5 -9.5zM850 277q-3 46 -20 85t-45 67t-64.5 43.5t-78.5 15.5t-78.5 -16 t-64 -44t-44 -66.5t-18.5 -84.5h413z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 753,
    d: "M639 710l-52 -78q58 -53 90 -126.5t32 -150.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5q-49 0 -93 14t-80 39l-31 -48h-57l50 77q-57 52 -89 125t-32 153q0 71 25.5 136t70 115t105.5 79.5t132 29.5q49 0 92 -14t80 -39l32 48h58zM95 355q0 -69 25.5 -130.5 t71.5 -106.5l331 504q-32 22 -68.5 34t-77.5 12q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114zM657 355q0 68 -26 129.5t-71 106.5l-331 -504q32 -21 69 -33t79 -12q64 0 115.5 27t88 71.5t56.5 100.5t20 114zM376 816l-35 16l61 85h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 592,
    d: "M104 -1l34 48q-45 38 -70.5 93t-25.5 119q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5q36 0 69 -10.5t62 -28.5l22 31h40l-36 -50q45 -38 71 -93t26 -119q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5q-38 0 -70.5 10t-61.5 28l-22 -29h-38zM92 257 q0 -53 20 -97t54 -75l235 366q-23 16 -49.5 24.5t-55.5 8.5q-42 0 -79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5zM295 35q42 0 79 17.5t65 48.5t44 71.5t16 87.5q0 51 -20 95.5t-54 75.5l-236 -364q47 -32 106 -32zM295 629l-35 16l61 85h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adblgrave",
    unicode: "\u0200",
    horizAdvX: 675,
    d: "M316 710h44l300 -710h-54l-99 234h-339l-99 -234h-55zM493 276l-155 372l-158 -372h313zM304 918h52l60 -85l-29 -16zM188 918h53l59 -85l-29 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adblgrave",
    unicode: "\u0201",
    horizAdvX: 537,
    d: "M206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68.5 32t88 11.5q42 0 84.5 -7.5t76.5 -20.5v51q0 74 -42 117.5t-114 43.5q-38 0 -80.5 -16t-86.5 -46l-19 34q100 68 190 68q94 0 148 -54.5t54 -150.5v-254q0 -25 22 -25v-45q-5 -1 -10.5 -1.5 t-9.5 -0.5q-20 0 -32 13.5t-14 32.5v43q-36 -47 -92 -72t-121 -25zM216 30q58 0 106.5 22t74.5 58q16 21 16 40v92q-36 14 -75 21t-81 7q-39 0 -71 -8.5t-55 -23.5t-35.5 -36.5t-12.5 -47.5t10 -49t28 -39.5t42.5 -26t52.5 -9.5zM240 730h52l60 -85l-29 -16zM124 730h53 l59 -85l-29 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ainvertedbreve",
    unicode: "\u0202",
    horizAdvX: 675,
    d: "M316 710h44l300 -710h-54l-99 234h-339l-99 -234h-55zM493 276l-155 372l-158 -372h313zM338 889q-22 0 -39 -19.5t-17 -44.5h-33q0 19 7 36t19 29.5t28.5 19.5t34.5 7t34 -7t28.5 -19.5t19.5 -29.5t7 -36h-33q-3 27 -19.5 45.5t-36.5 18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ainvertedbreve",
    unicode: "\u0203",
    horizAdvX: 537,
    d: "M206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68.5 32t88 11.5q42 0 84.5 -7.5t76.5 -20.5v51q0 74 -42 117.5t-114 43.5q-38 0 -80.5 -16t-86.5 -46l-19 34q100 68 190 68q94 0 148 -54.5t54 -150.5v-254q0 -25 22 -25v-45q-5 -1 -10.5 -1.5 t-9.5 -0.5q-20 0 -32 13.5t-14 32.5v43q-36 -47 -92 -72t-121 -25zM216 30q58 0 106.5 22t74.5 58q16 21 16 40v92q-36 14 -75 21t-81 7q-39 0 -71 -8.5t-55 -23.5t-35.5 -36.5t-12.5 -47.5t10 -49t28 -39.5t42.5 -26t52.5 -9.5zM263 702q-22 0 -39 -19.5t-17 -44.5h-33 q0 19 7 36t19 29.5t28.5 19.5t34.5 7t34 -7t28.5 -19.5t19.5 -29.5t7 -36h-33q-3 27 -19.5 45.5t-36.5 18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edblgrave",
    unicode: "\u0204",
    d: "M305 918h52l60 -85l-29 -16zM189 918h53l59 -85l-29 -16zM566 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edblgrave",
    unicode: "\u0205",
    horizAdvX: 583,
    d: "M268 730h52l60 -85l-29 -16zM152 730h53l59 -85l-29 -16zM299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16 q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Einvertedbreve",
    unicode: "\u0206",
    d: "M331 889q-22 0 -39 -19.5t-17 -44.5h-33q0 19 7 36t19 29.5t28.5 19.5t34.5 7t34 -7t28.5 -19.5t19.5 -29.5t7 -36h-33q-3 27 -19.5 45.5t-36.5 18.5zM566 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "einvertedbreve",
    unicode: "\u0207",
    horizAdvX: 583,
    d: "M296 702q-22 0 -39 -19.5t-17 -44.5h-33q0 19 7 36t19 29.5t28.5 19.5t34.5 7t34 -7t28.5 -19.5t19.5 -29.5t7 -36h-33q-3 27 -19.5 45.5t-36.5 18.5zM299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5 t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43 t-44 -66t-19.5 -83.5h410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idblgrave",
    unicode: "\u0208",
    horizAdvX: 237,
    d: "M93 0v710h51v-710h-51zM95 918h52l60 -85l-29 -16zM-21 918h53l59 -85l-29 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idblgrave",
    unicode: "\u0209",
    horizAdvX: 207,
    d: "M81 730h52l60 -85l-29 -16zM-35 730h53l59 -85l-29 -16zM78 0v520h50v-520h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iinvertedbreve",
    unicode: "\u020A",
    horizAdvX: 237,
    d: "M93 0v710h51v-710h-51zM117 889q-22 0 -39 -19.5t-17 -44.5h-33q0 19 7 36t19 29.5t28.5 19.5t34.5 7t34 -7t28.5 -19.5t19.5 -29.5t7 -36h-33q-3 27 -19.5 45.5t-36.5 18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iinvertedbreve",
    unicode: "\u020B",
    horizAdvX: 207,
    d: "M104 702q-22 0 -39 -19.5t-17 -44.5h-33q0 19 7 36t19 29.5t28.5 19.5t34.5 7t34 -7t28.5 -19.5t19.5 -29.5t7 -36h-33q-3 27 -19.5 45.5t-36.5 18.5zM78 0v520h50v-520h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odblgrave",
    unicode: "\u020C",
    horizAdvX: 753,
    d: "M348 918h52l60 -85l-29 -16zM232 918h53l59 -85l-29 -16zM376 -5q-74 0 -135 31t-105 81t-68 115t-24 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -130.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5zM95 355 q0 -61 20.5 -117.5t58 -100t89.5 -69.5t114 -26q64 0 115.5 27t88 71.5t56.5 100.5t20 114q0 61 -21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odblgrave",
    unicode: "\u020D",
    horizAdvX: 592,
    d: "M270 730h52l60 -85l-29 -16zM154 730h53l59 -85l-29 -16zM296 -10q-55 0 -101.5 21.5t-80.5 58.5t-53 86t-19 103q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5t100 -21.5t80.5 -58.5t54 -86t19.5 -104q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5zM92 257 q0 -46 16 -86.5t43.5 -70.5t64.5 -47.5t79 -17.5t79 17.5t65 48.5t44 71.5t16 87.5q0 46 -16 86.5t-44 71t-64.5 48.5t-78.5 18t-79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oinvertedbreve",
    unicode: "\u020E",
    horizAdvX: 753,
    d: "M376 889q-22 0 -39 -19.5t-17 -44.5h-33q0 19 7 36t19 29.5t28.5 19.5t34.5 7t34 -7t28.5 -19.5t19.5 -29.5t7 -36h-33q-3 27 -19.5 45.5t-36.5 18.5zM376 -5q-74 0 -135 31t-105 81t-68 115t-24 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5 t105 -82.5t67.5 -115.5t24 -130.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5zM95 355q0 -61 20.5 -117.5t58 -100t89.5 -69.5t114 -26q64 0 115.5 27t88 71.5t56.5 100.5t20 114q0 61 -21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5 t-57 -100.5t-20 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oinvertedbreve",
    unicode: "\u020F",
    horizAdvX: 592,
    d: "M294 702q-22 0 -39 -19.5t-17 -44.5h-33q0 19 7 36t19 29.5t28.5 19.5t34.5 7t34 -7t28.5 -19.5t19.5 -29.5t7 -36h-33q-3 27 -19.5 45.5t-36.5 18.5zM296 -10q-55 0 -101.5 21.5t-80.5 58.5t-53 86t-19 103q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5t100 -21.5 t80.5 -58.5t54 -86t19.5 -104q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5zM92 257q0 -46 16 -86.5t43.5 -70.5t64.5 -47.5t79 -17.5t79 17.5t65 48.5t44 71.5t16 87.5q0 46 -16 86.5t-44 71t-64.5 48.5t-78.5 18t-79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdblgrave",
    unicode: "\u0210",
    horizAdvX: 649,
    d: "M296 918h52l60 -85l-29 -16zM180 918h53l59 -85l-29 -16zM93 0v710h295q45 0 83 -19t65.5 -50.5t43 -71t15.5 -79.5q0 -39 -12 -75.5t-34 -65.5t-53 -48t-68 -25l177 -276h-59l-172 268h-230v-268h-51zM144 315h249q34 0 62 15t48 39.5t30.5 56t10.5 64.5 q0 34 -12.5 65.5t-34 55.5t-50 38.5t-61.5 14.5h-242v-349z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdblgrave",
    unicode: "\u0211",
    horizAdvX: 341,
    d: "M173 730h52l60 -85l-29 -16zM57 730h53l59 -85l-29 -16zM324 475q-70 -2 -122.5 -41.5t-73.5 -108.5v-325h-50v520h48v-128q27 55 71.5 89.5t95.5 39.5q10 1 18 1h13v-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rinvertedbreve",
    unicode: "\u0212",
    horizAdvX: 649,
    d: "M322 889q-22 0 -39 -19.5t-17 -44.5h-33q0 19 7 36t19 29.5t28.5 19.5t34.5 7t34 -7t28.5 -19.5t19.5 -29.5t7 -36h-33q-3 27 -19.5 45.5t-36.5 18.5zM93 0v710h295q45 0 83 -19t65.5 -50.5t43 -71t15.5 -79.5q0 -39 -12 -75.5t-34 -65.5t-53 -48t-68 -25l177 -276h-59 l-172 268h-230v-268h-51zM144 315h249q34 0 62 15t48 39.5t30.5 56t10.5 64.5q0 34 -12.5 65.5t-34 55.5t-50 38.5t-61.5 14.5h-242v-349z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rinvertedbreve",
    unicode: "\u0213",
    horizAdvX: 341,
    d: "M196 702q-22 0 -39 -19.5t-17 -44.5h-33q0 19 7 36t19 29.5t28.5 19.5t34.5 7t34 -7t28.5 -19.5t19.5 -29.5t7 -36h-33q-3 27 -19.5 45.5t-36.5 18.5zM324 475q-70 -2 -122.5 -41.5t-73.5 -108.5v-325h-50v520h48v-128q27 55 71.5 89.5t95.5 39.5q10 1 18 1h13v-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udblgrave",
    unicode: "\u0214",
    horizAdvX: 756,
    d: "M355 918h52l60 -85l-29 -16zM239 918h53l59 -85l-29 -16zM378 42q72 0 119.5 27t75 71t39 100t11.5 113v357h51v-357q0 -71 -15.5 -136t-50.5 -114.5t-91 -78.5t-138 -29q-85 0 -142 30.5t-91.5 81t-49 114.5t-14.5 132v357h51v-357q0 -59 11.5 -115t40 -99.5t75.5 -70 t118 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udblgrave",
    unicode: "\u0215",
    horizAdvX: 587,
    d: "M260 730h52l60 -85l-29 -16zM144 730h53l59 -85l-29 -16zM239 -10q-166 0 -166 230v300h50v-293q0 -192 131 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-5 -1 -9 -1h-6q-20 0 -35.5 12.5t-15.5 33.5v78q-34 -63 -93.5 -98t-128.5 -35z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uinvertedbreve",
    unicode: "\u0216",
    horizAdvX: 756,
    d: "M378 889q-22 0 -39 -19.5t-17 -44.5h-33q0 19 7 36t19 29.5t28.5 19.5t34.5 7t34 -7t28.5 -19.5t19.5 -29.5t7 -36h-33q-3 27 -19.5 45.5t-36.5 18.5zM378 42q72 0 119.5 27t75 71t39 100t11.5 113v357h51v-357q0 -71 -15.5 -136t-50.5 -114.5t-91 -78.5t-138 -29 q-85 0 -142 30.5t-91.5 81t-49 114.5t-14.5 132v357h51v-357q0 -59 11.5 -115t40 -99.5t75.5 -70t118 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uinvertedbreve",
    unicode: "\u0217",
    horizAdvX: 587,
    d: "M286 702q-22 0 -39 -19.5t-17 -44.5h-33q0 19 7 36t19 29.5t28.5 19.5t34.5 7t34 -7t28.5 -19.5t19.5 -29.5t7 -36h-33q-3 27 -19.5 45.5t-36.5 18.5zM239 -10q-166 0 -166 230v300h50v-293q0 -192 131 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450 q0 -25 21 -25v-45q-5 -1 -9 -1h-6q-20 0 -35.5 12.5t-15.5 33.5v78q-34 -63 -93.5 -98t-128.5 -35z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0218",
    unicode: "\u0218",
    horizAdvX: 605,
    d: "M292 -187l15 68h-16v70h49v-70l-21 -68h-27zM506 592q-69 77 -195 77q-104 0 -151.5 -39.5t-47.5 -106.5q0 -34 12 -56.5t37.5 -38.5t64.5 -27t94 -23q57 -12 103.5 -26.5t79 -36.5t50 -54t17.5 -79t-18.5 -82t-52 -58.5t-80 -35.5t-103.5 -12q-166 0 -281 106l27 41 q45 -47 110 -74.5t146 -27.5q93 0 145.5 34t52.5 103q0 35 -14 59.5t-41.5 42.5t-69.5 31t-98 25q-57 12 -100.5 25.5t-73 34t-44.5 49.5t-15 73q0 48 18.5 85t51.5 62.5t79 38.5t102 13q69 0 123 -20.5t98 -62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0219",
    unicode: "\u0219",
    horizAdvX: 481,
    d: "M217 -187l15 68h-16v70h49v-70l-21 -68h-27zM243 -10q-60 0 -115 20t-96 60l25 34q42 -38 87 -56t99 -18q68 0 109.5 28.5t41.5 79.5q0 24 -10.5 40.5t-31.5 28t-52 20.5t-72 19q-44 10 -76.5 20t-53.5 24t-31.5 34t-10.5 51q0 39 15 68t41.5 48t61 28.5t73.5 9.5 q61 0 108 -20.5t73 -52.5l-28 -27q-26 30 -67.5 45t-88.5 15q-29 0 -54.5 -6t-44.5 -19t-30 -33.5t-11 -48.5q0 -23 7.5 -37t24 -24t42.5 -17.5t62 -16.5q49 -12 87 -23t63.5 -27t39 -38t13.5 -56q0 -70 -54.5 -111.5t-145.5 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021A",
    unicode: "\u021A",
    horizAdvX: 606,
    d: "M278 -187l15 68h-16v70h49v-70l-21 -68h-27zM589 664h-260v-664h-51v664h-260v46h571v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni021B",
    unicode: "\u021B",
    horizAdvX: 320,
    d: "M174 -187l15 68h-16v70h49v-70l-21 -68h-27zM310 25q-4 -2 -13.5 -7.5t-24 -10.5t-32.5 -9t-39 -4t-39.5 6t-32.5 18t-22 29t-8 40v392h-73v41h73v178h50v-178h121v-41h-121v-380q0 -29 20 -43.5t45 -14.5q31 0 53.5 10.5t27.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessj",
    unicode: "\u0237",
    horizAdvX: 207,
    d: "M-18 -177q-32 0 -59.5 8.5t-48.5 28.5l27 33q16 -14 36.5 -19t40.5 -5q18 0 36 7.5t32.5 21t23 32t8.5 40.5v550h50v-548q0 -33 -12.5 -60t-33 -47t-47 -31t-53.5 -11z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "schwa",
    unicode: "\u0259",
    horizAdvX: 583,
    d: "M288 -10q-55 0 -101.5 21t-81 58t-54.5 85.5t-20 104.5q0 2 0.5 9.5t0.5 9.5h457q-3 45 -21 83.5t-45.5 66.5t-64 44t-76.5 16q-27 0 -53.5 -7.5t-49 -20.5t-40 -31t-27.5 -40l-44 12q12 27 33.5 50.5t50 41t62.5 27t70 9.5q55 0 102 -21.5t81.5 -59t54 -87t19.5 -105.5 q0 -55 -19 -103.5t-53 -84.5t-80.5 -57t-100.5 -21zM288 30q41 0 77 16t63 44t43 67t19 84h-409q3 -46 20 -85t45 -67t64.5 -43.5t77.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "apostrophe",
    unicode: "\u02BC",
    horizAdvX: 546,
    d: "M257 629l-34 16l39 54v31h80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 320,
    d: "M45 649l96 81h37l97 -81l-30 -17l-85 63l-85 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 320,
    d: "M75 730l85 -63l85 63l30 -17l-97 -81h-37l-96 81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni02C9",
    unicode: "\u02C9",
    horizAdvX: 390,
    d: "M53 672v37h285v-37h-285z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 269,
    d: "M135 666q20 0 36.5 18.5t19.5 45.5h33q0 -19 -7 -36t-19.5 -29.5t-28.5 -19.5t-34 -7t-34.5 7t-28.5 19.5t-19 29.5t-7 36h33q0 -25 17 -44.5t39 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 146,
    d: "M50 640v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 244,
    d: "M54 668q0 27 19.5 44.5t48.5 17.5t48.5 -17.5t19.5 -44.5q0 -28 -19.5 -45.5t-48.5 -17.5t-48.5 17.5t-19.5 45.5zM122 707q-17 0 -28.5 -10.5t-11.5 -28.5q0 -17 11.5 -28.5t28.5 -11.5q16 0 28.5 11.5t12.5 28.5q0 18 -12 28.5t-29 10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 226,
    d: "M119 -169q-32 7 -49.5 25t-17.5 43q0 29 23 56.5t74 60.5l19 -16q-45 -29 -63.5 -50t-18.5 -44q0 -38 49 -45l-16 -30v0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 397,
    d: "M258 647q-22 0 -39 6t-31 13.5t-27.5 14t-28.5 6.5q-17 0 -27 -7t-15 -15.5t-7 -16t-2 -9.5h-34q0 4 3 17.5t12.5 28t26 26t43.5 11.5q20 0 35.5 -6.5t29.5 -14t28.5 -13.5t33.5 -6q20 0 31.5 7t17 15.5t7 16t1.5 9.5h34q0 -5 -3.5 -18.5t-13 -27.5t-27.5 -25.5 t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 316,
    d: "M75 629l-29 16l59 85h53zM191 629l-30 16l60 85h53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni030F",
    unicode: "\u030F",
    horizAdvX: 316,
    d: "M158 730h52l60 -85l-29 -16zM42 730h53l59 -85l-29 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0311",
    unicode: "\u0311",
    horizAdvX: 269,
    d: "M135 702q-22 0 -39 -19.5t-17 -44.5h-33q0 19 7 36t19 29.5t28.5 19.5t34.5 7t34 -7t28.5 -19.5t19.5 -29.5t7 -36h-33q-3 27 -19.5 45.5t-36.5 18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0394",
    unicode: "\u0394",
    horizAdvX: 647,
    d: "M623 41v-41h-600v41l280 669h42zM567 46l-243 602l-244 -602h487z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03A9",
    unicode: "\u03A9",
    horizAdvX: 766,
    d: "M47 47h201q-91 45 -142.5 130t-51.5 188q0 69 25 132.5t69 111.5t104 77t131 29t131 -29t104 -77t69 -111.5t25 -132.5q0 -51 -13.5 -99t-38.5 -89t-61.5 -74.5t-81.5 -55.5h202v-47h-289v47q55 13 98 45.5t72 76.5t44.5 95t15.5 101q0 56 -19 110.5t-55 97t-87.5 68.5 t-115.5 26t-115.5 -26t-87.5 -68.5t-55 -97t-19 -110.5q0 -50 15.5 -101t44.5 -95t72 -76.5t98 -45.5v-47h-289v47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni03BC",
    unicode: "\u03BC",
    horizAdvX: 593,
    d: "M79 520h50v-293q0 -192 132 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-5 -1 -8.5 -1h-6.5q-22 0 -36.5 13.5t-14.5 35.5v75q-15 -29 -37 -53.5t-49.5 -42t-58.5 -27.5t-64 -10q-51 0 -83.5 24.5t-48.5 67.5v-294h-48v732z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 571,
    d: "M154 474v-474h-49v474h-80v46h505v-46h-110v-371q0 -29 17 -46t46 -17q11 0 26 2.5t28 7.5l10 -40q-17 -7 -42 -11.5t-43 -4.5q-42 0 -66.5 25.5t-24.5 68.5v386h-217z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0400",
    unicode: "\u0400",
    d: "M567 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422zM256 918h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0401",
    unicode: "\u0401",
    d: "M250 828v88h44v-88h-44zM386 828v88h44v-88h-44zM567 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0402",
    unicode: "\u0402",
    horizAdvX: 692,
    d: "M205 664h-189v46h517v-46h-277v-287q69 66 182 66q108 0 166.5 -58t58.5 -170q0 -110 -55 -167.5t-161 -57.5q-29 0 -54 5t-52 17l16 46q28 -14 47.5 -18.5t42.5 -4.5q80 0 121 46t41 134q0 89 -44.5 135t-132.5 46q-51 0 -94.5 -17.5t-81.5 -55.5v-323h-51v664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0403",
    unicode: "\u0403",
    horizAdvX: 524,
    d: "M294 816l-35 16l61 85h58zM503 664h-358v-664h-51v710h409v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0404",
    unicode: "\u0404",
    horizAdvX: 699,
    d: "M666 159q-18 -40 -48 -71t-68 -52t-81.5 -31.5t-88.5 -10.5q-75 0 -137 32t-106.5 83.5t-68.5 117t-24 133.5q0 64 22.5 127.5t65.5 113.5t106.5 81.5t146.5 31.5q100 0 166.5 -43.5t99.5 -111.5l-42 -24q-19 37 -45 62t-56 40.5t-62.5 22.5t-64.5 7q-66 0 -117 -24 t-87 -64t-56 -90.5t-24 -103.5h371v-44h-372q3 -60 25.5 -114.5t60.5 -95.5t90 -65.5t112 -24.5q33 0 67 8t66 25t59.5 43.5t45.5 62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0405",
    unicode: "\u0405",
    horizAdvX: 605,
    d: "M506 592q-69 77 -195 77q-104 0 -151.5 -39.5t-47.5 -106.5q0 -34 12 -56.5t37.5 -38.5t64.5 -27t94 -23q57 -12 103.5 -26.5t79 -36.5t50 -54t17.5 -79t-18.5 -82t-52 -58.5t-80 -35.5t-103.5 -12q-166 0 -281 106l27 41q45 -47 110 -74.5t146 -27.5q93 0 145.5 34 t52.5 103q0 35 -14 59.5t-41.5 42.5t-69.5 31t-98 25q-57 12 -100.5 25.5t-73 34t-44.5 49.5t-15 73q0 48 18.5 85t51.5 62.5t79 38.5t102 13q69 0 123 -20.5t98 -62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0406",
    unicode: "\u0406",
    horizAdvX: 238,
    d: "M94 0v710h51v-710h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0407",
    unicode: "\u0407",
    horizAdvX: 238,
    d: "M94 0v710h51v-710h-51zM29 828v88h44v-88h-44zM165 828v88h44v-88h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0408",
    unicode: "\u0408",
    horizAdvX: 479,
    d: "M32 74q25 -17 60 -27.5t78 -10.5q58 0 92 21t52 61t23.5 98.5t5.5 132.5v361h51v-361q0 -81 -7 -147.5t-30.5 -113.5t-67.5 -73t-119 -26q-90 0 -154 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0409",
    unicode: "\u0409",
    horizAdvX: 994,
    d: "M6 46q29 1 55.5 19t50 70.5t42.5 149t32 253.5l14 172h349v-309h201q103 0 159 -53t56 -145q0 -45 -14.5 -82t-42.5 -64t-67.5 -42t-88.5 -15h-254v664h-251l-11 -133q-12 -144 -30.5 -245.5t-45 -165.5t-63 -93.5t-84.5 -29.5zM752 46q42 0 73 12.5t50.5 34t29 50 t9.5 60.5q0 31 -8.5 59t-28 49t-50.5 33t-77 12h-201v-310h203z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040A",
    unicode: "\u040A",
    horizAdvX: 1039,
    d: "M94 710h51v-309h386v309h51v-309h213q102 0 158.5 -53t56.5 -145q0 -45 -14.5 -82t-42.5 -64t-67.5 -42t-88.5 -15h-266v355h-386v-355h-51v710zM797 46q42 0 72.5 12.5t50 34t29 50t9.5 60.5q0 31 -8.5 59t-27.5 49t-50.5 33t-76.5 12h-213v-310h215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040B",
    unicode: "\u040B",
    horizAdvX: 699,
    d: "M609 206q0 98 -38.5 141t-125.5 43q-53 0 -103 -15t-86 -41v-334h-51v664h-189v46h517v-46h-277v-280q39 25 87.5 38.5t100.5 13.5q107 0 160.5 -52.5t53.5 -167.5v-216h-49v206z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040C",
    unicode: "\u040C",
    horizAdvX: 588,
    d: "M315 816l-35 16l61 85h58zM145 390h124l230 320h60l-246 -341l275 -369h-60l-256 343h-127v-343h-51v710h51v-320z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040D",
    unicode: "\u040D",
    horizAdvX: 737,
    d: "M293 918h57l62 -85l-34 -16zM145 76l466 634h43v-710h-51v624l-460 -624h-49v710h51v-634z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040E",
    unicode: "\u040E",
    horizAdvX: 620,
    d: "M164 -8q-20 0 -39 4t-35 14v47q15 -10 33.5 -14.5t36.5 -4.5q19 0 35 6t31 21t30 40t33 62l-267 543h55l237 -486l232 486h55l-264 -546q-24 -50 -44.5 -83t-40.5 -52.5t-41.5 -28t-46.5 -8.5zM315 821q-69 0 -105.5 26.5t-36.5 68.5h34q0 -25 30 -44.5t78 -19.5 q46 0 76 18t32 46h33q0 -42 -36.5 -68.5t-104.5 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni040F",
    unicode: "\u040F",
    horizAdvX: 691,
    d: "M94 710h51v-664h401v664h51v-710h-226v-186h-51v186h-226v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0410",
    unicode: "\u0410",
    horizAdvX: 675,
    d: "M316 710h44l300 -710h-54l-99 234h-339l-99 -234h-55zM493 276l-155 372l-158 -372h313z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0411",
    unicode: "\u0411",
    horizAdvX: 649,
    d: "M94 710h471v-46h-420v-263h253q102 0 158.5 -53t56.5 -145q0 -45 -14.5 -82t-42.5 -64t-67.5 -42t-89.5 -15h-305v710zM399 46q42 0 73 12.5t50.5 34t29 50t9.5 60.5q0 31 -8.5 59t-27.5 49t-50.5 33t-76.5 12h-253v-310h254z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0412",
    unicode: "\u0412",
    horizAdvX: 663,
    d: "M608 184q0 -39 -15 -72.5t-41 -58.5t-61 -39t-74 -14h-332v710h331q37 0 67 -16t51 -41.5t32.5 -58t11.5 -65.5q0 -54 -27 -99t-75 -66q61 -18 96.5 -67.5t35.5 -112.5zM557 191q0 28 -10 54.5t-28 47t-42.5 32.5t-52.5 12h-288v-291h281q30 0 55.5 12t44 32.5t29.5 46.5 t11 54zM136 664v-284h260q29 0 53 12t41.5 31.5t27.5 45.5t10 53q0 29 -9.5 54.5t-26 45t-39.5 31t-51 11.5h-266z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0413",
    unicode: "\u0413",
    horizAdvX: 524,
    d: "M503 664h-358v-664h-51v710h409v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0414",
    unicode: "\u0414",
    horizAdvX: 696,
    d: "M17 46h21q19 3 35.5 11.5t31 27.5t27 52.5t24 87t21.5 130.5t19 183l15 172h369v-664h93v-231h-46v185h-564v-185h-46v231zM529 46v618h-271l-11 -133q-9 -110 -20 -193.5t-25.5 -142.5t-33.5 -95.5t-44 -53.5h405z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0415",
    unicode: "\u0415",
    d: "M567 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0416",
    unicode: "\u0416",
    horizAdvX: 921,
    d: "M244 369l-211 341h60l194 -320h146v320h55v-320h146l194 320h60l-212 -341l240 -369h-60l-217 343h-151v-343h-55v343h-151l-218 -343h-60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0417",
    unicode: "\u0417",
    horizAdvX: 527,
    d: "M56 627q27 38 77.5 63t116.5 25q95 0 147.5 -43t52.5 -122q0 -62 -31 -103.5t-94 -56.5q75 -12 115.5 -63t40.5 -124q0 -46 -17 -84.5t-48 -66t-73.5 -42.5t-94.5 -15q-74 0 -132.5 31.5t-87.5 83.5l41 32q24 -45 73 -72.5t110 -27.5q40 0 72.5 11t56 32t36.5 50.5 t13 65.5q0 78 -56.5 122.5t-159.5 44.5h-43v46h43q90 0 138 35t48 99q0 60 -40.5 90.5t-108.5 30.5q-54 0 -96.5 -21t-63.5 -53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0418",
    unicode: "\u0418",
    horizAdvX: 748,
    d: "M145 76l466 634h43v-710h-51v624l-460 -624h-49v710h51v-634z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0419",
    unicode: "\u0419",
    horizAdvX: 748,
    d: "M518 916q-1 -42 -37 -68.5t-105 -26.5t-105 26.5t-37 68.5h34q0 -25 30.5 -44.5t77.5 -19.5q46 0 76.5 18t32.5 46h33zM145 76l466 634h43v-710h-51v624l-460 -624h-49v710h51v-634z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041A",
    unicode: "\u041A",
    horizAdvX: 588,
    d: "M145 390h124l230 320h60l-246 -341l275 -369h-60l-256 343h-127v-343h-51v710h51v-320z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041B",
    unicode: "\u041B",
    horizAdvX: 643,
    d: "M236 531q-12 -144 -30.5 -245.5t-45 -165.5t-63 -93.5t-84.5 -29.5l-7 49q29 1 55.5 19t50 70.5t42.5 149t32 253.5l14 172h349v-710h-51v664h-251z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041C",
    unicode: "\u041C",
    horizAdvX: 881,
    d: "M737 0v614l-280 -479h-32l-280 479v-614h-51v710h51l296 -508l296 508h51v-710h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041D",
    unicode: "\u041D",
    horizAdvX: 737,
    d: "M644 710v-710h-51v340h-448v-340h-51v710h51v-324h448v324h51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041E",
    unicode: "\u041E",
    horizAdvX: 753,
    d: "M376 -5q-74 0 -135 31t-105 81t-68 115t-24 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -130.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5zM95 355q0 -61 20.5 -117.5t58 -100t89.5 -69.5t114 -26 q64 0 115.5 27t88 71.5t56.5 100.5t20 114q0 61 -21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni041F",
    unicode: "\u041F",
    horizAdvX: 720,
    d: "M94 710h532v-710h-51v664h-430v-664h-51v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0420",
    unicode: "\u0420",
    horizAdvX: 622,
    d: "M94 0v710h292q45 0 83 -19t65.5 -50.5t43 -71t15.5 -79.5q0 -43 -14.5 -83t-41 -71t-63.5 -49.5t-82 -18.5h-247v-268h-51zM145 315h245q35 0 63 14.5t47.5 39t30 56t10.5 65.5q0 35 -12.5 66.5t-34 55.5t-50 38t-60.5 14h-239v-349z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0421",
    unicode: "\u0421",
    horizAdvX: 690,
    d: "M44 360q0 64 22.5 127.5t65.5 113.5t105.5 81.5t142.5 31.5q95 0 162 -43.5t100 -111.5l-42 -24q-19 37 -44.5 62t-55 40.5t-61.5 22.5t-63 7q-68 0 -120 -27.5t-88 -71.5t-54.5 -99.5t-18.5 -111.5q0 -63 22 -120t60 -100.5t90 -69.5t112 -26q32 0 66 8t65 25t58 43.5 t45 62.5l44 -21q-18 -40 -49 -71t-69 -52t-80.5 -31.5t-83.5 -10.5q-73 0 -133.5 32t-104.5 83.5t-68.5 117t-24.5 133.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0422",
    unicode: "\u0422",
    horizAdvX: 605,
    d: "M588 664h-260v-664h-51v664h-260v46h571v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0423",
    unicode: "\u0423",
    horizAdvX: 620,
    d: "M164 -8q-20 0 -39 4t-35 14v47q15 -10 33.5 -14.5t37.5 -4.5t34.5 6t30.5 21t30 39.5t33 62.5l-267 543h55l237 -486l232 486h55l-264 -546q-24 -50 -44.5 -83t-40.5 -52.5t-41.5 -28t-46.5 -8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0424",
    unicode: "\u0424",
    horizAdvX: 737,
    d: "M344 73q-70 3 -127 25t-98 61t-63.5 93.5t-22.5 122.5q0 66 21.5 120.5t62 94.5t98 63t129.5 27v102h51v-102q70 -3 127 -26.5t97.5 -63t62 -94.5t21.5 -121q0 -68 -22 -122.5t-62.5 -93t-97.5 -61t-126 -25.5v-107h-51v107zM395 120q58 3 105.5 22t81 52t51.5 79t18 104 q0 115 -68.5 181.5t-187.5 72.5v-511zM344 631q-60 -3 -108 -21.5t-81.5 -51.5t-51.5 -78.5t-18 -102.5q0 -58 18.5 -104t52.5 -79t81.5 -52t106.5 -22v511z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0425",
    unicode: "\u0425",
    horizAdvX: 628,
    d: "M66 710l249 -323l248 323h58l-279 -360l271 -350h-58l-240 313l-241 -313h-59l271 350l-279 360h59z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0426",
    unicode: "\u0426",
    horizAdvX: 714,
    d: "M644 0h-550v710h51v-664h401v664h51v-664h94v-231h-47v185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0427",
    unicode: "\u0427",
    horizAdvX: 608,
    d: "M463 710h51v-710h-51v317q-42 -19 -87 -28t-103 -9q-122 0 -174.5 63t-52.5 181v186h51v-178q0 -55 9.5 -94t31 -63.5t55.5 -36t83 -11.5q58 0 108.5 12t78.5 31v340z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0428",
    unicode: "\u0428",
    horizAdvX: 919,
    d: "M825 710v-710h-731v710h51v-664h289v664h51v-664h290v664h50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0429",
    unicode: "\u0429",
    horizAdvX: 942,
    d: "M873 0h-779v710h51v-664h290v664h50v-664h290v664h51v-664h93v-231h-46v185z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042A",
    unicode: "\u042A",
    horizAdvX: 724,
    d: "M16 710h268v-279h182q108 0 168 -57.5t60 -157.5q0 -48 -16 -87.5t-45.5 -68t-71.5 -44.5t-94 -16h-234v664h-217v46zM284 46h183q46 0 79 13.5t54.5 36.5t31.5 54t10 66t-9.5 66t-30.5 54t-54.5 36.5t-81.5 13.5h-182v-340z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042B",
    unicode: "\u042B",
    horizAdvX: 811,
    d: "M94 710h51v-279h181q109 0 168.5 -57.5t59.5 -157.5q0 -48 -16 -87.5t-45 -68t-71 -44.5t-94 -16h-234v710zM145 46h183q46 0 79 13.5t54.5 36.5t31.5 54t10 66t-9.5 66t-30.5 54t-55 36.5t-82 13.5h-181v-340zM666 0v709h51v-709h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042C",
    unicode: "\u042C",
    horizAdvX: 584,
    d: "M94 710h51v-279h181q109 0 168.5 -57.5t59.5 -157.5q0 -48 -16 -87.5t-45 -68t-71 -44.5t-94 -16h-234v710zM145 46h183q46 0 79 13.5t54.5 36.5t31.5 54t10 66t-9.5 66t-30.5 54t-55 36.5t-82 13.5h-181v-340z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042D",
    unicode: "\u042D",
    horizAdvX: 699,
    d: "M319 -6q-45 0 -88.5 10.5t-81.5 31.5t-68 52t-48 71l43 21q19 -36 46.5 -62.5t59.5 -43.5t66 -25t67 -8q60 0 111.5 24.5t89.5 65.5t60.5 95.5t25.5 114.5h-371v44h370q-4 53 -24 103.5t-56 90.5t-86.5 64t-116.5 24q-32 0 -64.5 -7t-62.5 -22.5t-56 -40.5t-45 -62 l-42 24q33 68 99.5 111.5t166.5 43.5q82 0 145.5 -31.5t107 -81.5t65.5 -113.5t22 -127.5q0 -68 -24 -133.5t-68 -117t-106 -83.5t-137 -32z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042E",
    unicode: "\u042E",
    horizAdvX: 971,
    d: "M603 -5q-68 0 -124 25t-97 69.5t-65 106.5t-27 137h-145v-333h-51v710h51v-330h146q4 77 29 139t67 105.5t97.5 67t119.5 23.5q72 0 131 -27t101 -75t65.5 -114t23.5 -144q0 -83 -24.5 -149.5t-68 -113.5t-102.5 -72t-127 -25zM342 355q0 -72 19.5 -130t54 -98.5 t82.5 -62.5t105 -22q61 0 111.5 23t85.5 64.5t54.5 99t19.5 126.5q0 72 -20.5 130t-56.5 98.5t-86 62.5t-108 22q-59 0 -107.5 -23t-82.5 -64t-52.5 -99t-18.5 -127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni042F",
    unicode: "\u042F",
    horizAdvX: 628,
    d: "M483 0v294h-213l-177 -294h-61l186 304q-67 21 -106 75.5t-39 125.5q0 40 16 77t45 65.5t70.5 45.5t92.5 17h237v-710h-51zM483 664h-184q-38 0 -70 -12t-55 -33.5t-36 -50.5t-13 -63q0 -33 11 -63t32 -52.5t52 -36t72 -13.5h191v324z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0430",
    unicode: "\u0430",
    horizAdvX: 538,
    d: "M206 -10q-36 0 -67 12.5t-54.5 34t-36.5 51t-13 63.5t16 62t44.5 48.5t68.5 32t88 11.5q42 0 84.5 -7.5t76.5 -20.5v51q0 74 -42 117.5t-114 43.5q-38 0 -80.5 -16t-86.5 -46l-19 34q100 68 190 68q94 0 148 -54.5t54 -150.5v-254q0 -25 22 -25v-45q-5 -1 -10.5 -1.5 t-9.5 -0.5q-20 0 -32 13.5t-14 32.5v43q-36 -47 -92 -72t-121 -25zM216 30q58 0 106.5 22t74.5 58q16 21 16 40v92q-36 14 -75 21t-81 7q-39 0 -71 -8.5t-55 -23.5t-35.5 -36.5t-12.5 -47.5t10 -49t28 -39.5t42.5 -26t52.5 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0431",
    unicode: "\u0431",
    horizAdvX: 572,
    d: "M335 662q-97 -22 -154.5 -89.5t-69.5 -192.5q28 53 75 83t115 30q52 0 93.5 -18t70.5 -51t45 -79.5t16 -103.5q0 -55 -16.5 -101t-47 -79.5t-75 -52t-101.5 -18.5q-56 0 -98 20.5t-71 58.5t-43.5 92.5t-14.5 122.5q0 100 19.5 173.5t55.5 124.5t86.5 81.5t113.5 44.5 l147 33l10 -43zM111 243q0 -45 12 -83t35.5 -66.5t57 -44.5t76.5 -16t77 16t58 44t36.5 66t12.5 82q0 97 -48.5 151t-136.5 54q-39 0 -72 -13.5t-57 -39.5t-37.5 -64t-13.5 -86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0432",
    unicode: "\u0432",
    horizAdvX: 519,
    d: "M329 520q28 0 51 -10.5t39.5 -28t25.5 -41t9 -48.5q0 -37 -18.5 -71.5t-55.5 -51.5q44 -12 69.5 -46.5t25.5 -82.5q0 -30 -11 -55.5t-30.5 -44.5t-46.5 -29.5t-58 -10.5h-249v520h249zM309 283q21 0 39 8t30.5 22t19.5 32.5t7 39.5q0 39 -23.5 67.5t-66.5 28.5h-186v-198 h180zM325 39q22 0 41 8.5t32.5 23t21 33.5t7.5 39t-7 38t-20 32t-31.5 22.5t-40.5 8.5h-199v-205h196z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0433",
    unicode: "\u0433",
    horizAdvX: 406,
    d: "M384 481h-256v-481h-49v520h305v-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0434",
    unicode: "\u0434",
    horizAdvX: 564,
    d: "M18 44h31q21 4 37 22.5t29.5 57.5t25 102t22.5 157l16 137h288v-476h65v-203h-45v159h-426v-159h-43v203zM418 44v435h-192l-15 -118q-18 -139 -40 -216t-51 -101h298z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0435",
    unicode: "\u0435",
    horizAdvX: 583,
    d: "M299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12 q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0436",
    unicode: "\u0436",
    horizAdvX: 745,
    d: "M91 521l142 -237h115v236h50v-236h115l141 237h57l-156 -251l176 -270h-57l-154 245h-122v-245h-50v245h-122l-155 -245h-57l176 270l-156 251h57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0437",
    unicode: "\u0437",
    horizAdvX: 409,
    d: "M49 465q27 32 65 48t81 16q68 0 106.5 -33.5t38.5 -88.5q0 -47 -24 -78t-66 -39q54 -8 86 -47t32 -94q0 -35 -13 -64t-36 -50t-56.5 -33t-73.5 -12q-55 0 -93 20t-64 55l29 36q24 -33 54.5 -49.5t75.5 -16.5q63 0 95.5 32.5t32.5 83.5q0 56 -38 86.5t-107 30.5h-35v40h35 q57 0 88 24.5t31 70.5q0 39 -26.5 61.5t-74.5 22.5q-33 0 -61.5 -12t-54.5 -39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0438",
    unicode: "\u0438",
    horizAdvX: 584,
    d: "M128 70l335 450h42v-520h-50v442l-329 -442h-47v520h49v-450z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0439",
    unicode: "\u0439",
    horizAdvX: 584,
    d: "M423 703q-2 -38 -33.5 -60.5t-93.5 -22.5q-63 0 -94.5 22.5t-33.5 60.5h33q1 -27 23.5 -41t71.5 -14q48 0 69 13t25 42h33zM128 70l335 450h42v-520h-50v442l-329 -442h-47v520h49v-450z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043A",
    unicode: "\u043A",
    horizAdvX: 469,
    d: "M383 520h58l-191 -250l210 -270h-57l-188 247h-87v-247h-49v520h49v-233h83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043B",
    unicode: "\u043B",
    horizAdvX: 526,
    d: "M8 43q25 1 45.5 15.5t37 52.5t29.5 103.5t24 168.5l14 137h289v-520h-50v479h-192l-14 -118q-13 -106 -28.5 -175.5t-36.5 -110.5t-48 -58.5t-63 -18.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043C",
    unicode: "\u043C",
    horizAdvX: 678,
    d: "M339 151l212 369h48v-520h-49v429l-195 -340h-31l-196 340v-429h-49v520h49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043D",
    unicode: "\u043D",
    horizAdvX: 574,
    d: "M128 288h318v232h49v-520h-49v245h-318v-245h-49v520h49v-232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043E",
    unicode: "\u043E",
    horizAdvX: 592,
    d: "M296 -10q-55 0 -101.5 21.5t-80.5 58.5t-53 86t-19 103q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5t100 -21.5t80.5 -58.5t54 -86t19.5 -104q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5zM92 257q0 -46 16 -86.5t43.5 -70.5t64.5 -47.5t79 -17.5t79 17.5 t65 48.5t44 71.5t16 87.5q0 46 -16 86.5t-44 71t-64.5 48.5t-78.5 18t-79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni043F",
    unicode: "\u043F",
    horizAdvX: 559,
    d: "M479 0h-49v476h-302v-476h-49v520h400v-520z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0440",
    unicode: "\u0440",
    horizAdvX: 613,
    d: "M333 -10q-67 0 -119.5 35.5t-84.5 86.5v-325h-50v733h46v-104q32 50 84.5 81.5t112.5 31.5q54 0 100 -23t79 -60.5t51.5 -86.5t18.5 -100q0 -54 -17 -103t-48.5 -86t-75.5 -58.5t-97 -21.5zM321 35q45 0 82 19t63 50.5t40 72t14 82.5q0 45 -16 85.5t-44.5 71.5 t-66.5 49.5t-81 18.5q-27 0 -57.5 -11.5t-57.5 -31t-46 -44.5t-22 -53v-171q13 -29 33 -54t45 -44t54 -29.5t60 -10.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0441",
    unicode: "\u0441",
    horizAdvX: 545,
    d: "M42 262q0 55 19 104t53 85t81 57t103 21q71 0 125 -32t81 -89l-49 -16q-23 43 -65.5 67.5t-93.5 24.5q-43 0 -80 -17t-64.5 -47t-43.5 -70.5t-16 -87.5t16.5 -88.5t44 -72t65 -48.5t79.5 -18q27 0 53.5 8t49 21t39 30.5t22.5 36.5l49 -14q-10 -27 -30.5 -50.5 t-48.5 -40.5t-62 -26.5t-70 -9.5q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0442",
    unicode: "\u0442",
    horizAdvX: 470,
    d: "M260 0h-49v476h-190v44h428v-44h-189v-476z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0443",
    unicode: "\u0443",
    horizAdvX: 540,
    d: "M79 -156q24 -21 56 -21q14 0 26 7.5t25 27.5t28 54t35 88l-232 520h52l207 -471l193 471h49l-257 -619q-14 -35 -28 -58t-28.5 -37.5t-31 -20.5t-35.5 -6q-40 0 -64 21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0444",
    unicode: "\u0444",
    horizAdvX: 678,
    d: "M364 527q63 -4 113 -25t85.5 -56.5t54.5 -83.5t19 -105q0 -59 -19.5 -106t-55.5 -81.5t-86 -54.5t-111 -24v-204h-50v204q-61 3 -111 23t-86 54.5t-55.5 82t-19.5 106.5q0 57 19 105t54.5 83.5t85.5 56.5t113 25v203h50v-203zM314 478q-51 -3 -91.5 -19t-69.5 -44 t-44.5 -67.5t-15.5 -87.5q0 -50 16 -89.5t45 -68t69.5 -45t90.5 -19.5v440zM364 38q50 3 90.5 19.5t69.5 45t45 68t16 89.5q0 97 -59.5 154.5t-161.5 63.5v-440z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0445",
    unicode: "\u0445",
    horizAdvX: 496,
    d: "M72 520l168 -215l8 -14l8 14l167 215h56l-202 -261l201 -259h-55l-167 214l-8 13l-8 -13l-167 -214h-55l201 259l-202 261h55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0446",
    unicode: "\u0446",
    horizAdvX: 561,
    d: "M79 520h49v-476h282v476h49v-476h80v-203h-44v159h-416v520z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0447",
    unicode: "\u0447",
    horizAdvX: 477,
    d: "M398 0h-50v225q-29 -12 -60 -18t-76 -6q-46 0 -78 12.5t-52 36.5t-29 57.5t-9 75.5v137h49v-129q0 -79 31 -112.5t94 -33.5q43 0 77 9t53 22v244h50v-520z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0448",
    unicode: "\u0448",
    horizAdvX: 749,
    d: "M79 0v520h49v-476h221v476h50v-476h222v476h49v-520h-591z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0449",
    unicode: "\u0449",
    horizAdvX: 772,
    d: "M79 520h49v-476h221v476h50v-476h222v476h49v-476h80v-203h-45v159h-626v520z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044A",
    unicode: "\u044A",
    horizAdvX: 568,
    d: "M240 330h125q77 0 124.5 -43t47.5 -121q0 -38 -12.5 -68.5t-35.5 -52.5t-54.5 -33.5t-68.5 -11.5h-175v476h-171v44h220v-190zM366 43q62 0 91.5 35.5t29.5 87.5t-29.5 86.5t-92.5 34.5h-125v-244h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044B",
    unicode: "\u044B",
    horizAdvX: 630,
    d: "M79 520h49v-190h126q76 0 123.5 -43t47.5 -121q0 -38 -12.5 -68.5t-35.5 -52.5t-54.5 -33.5t-68.5 -11.5h-175v520zM502 520h49v-520h-49v520zM254 43q62 0 91.5 35.5t29.5 87.5t-29 86.5t-92 34.5h-126v-244h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044C",
    unicode: "\u044C",
    horizAdvX: 456,
    d: "M79 520h49v-190h126q76 0 123.5 -43t47.5 -121q0 -38 -12.5 -68.5t-35.5 -52.5t-54.5 -33.5t-68.5 -11.5h-175v520zM254 43q62 0 91.5 35.5t29.5 87.5t-29 86.5t-92 34.5h-126v-244h126z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044D",
    unicode: "\u044D",
    horizAdvX: 540,
    d: "M245 -9q-34 0 -66.5 8t-61 24t-50.5 39t-35 53l39 18q13 -26 32.5 -45t43 -31.5t49 -18.5t49.5 -6q41 0 77 16.5t64 45.5t45 67.5t19 83.5h-274v41h273q-4 39 -19.5 75.5t-41.5 64.5t-62 45t-81 17q-46 0 -92 -21.5t-75 -73.5l-36 19q26 51 76 84t125 33q60 0 107.5 -23 t80.5 -60.5t50.5 -85.5t17.5 -98q0 -51 -18 -99.5t-51 -87t-80 -61.5t-105 -23z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044E",
    unicode: "\u044E",
    horizAdvX: 743,
    d: "M227 283q3 56 22 101.5t50 78t72 50t89 17.5q54 0 98 -20.5t75.5 -57t49 -86t17.5 -107.5q0 -62 -18.5 -111.5t-50.5 -84.5t-76.5 -54t-95.5 -19q-50 0 -91.5 18t-72 51t-48.5 78.5t-21 101.5h-98v-239h-49v520h49v-237h99zM275 259q0 -52 13.5 -93.5t38 -70.5 t58.5 -44.5t75 -15.5q43 0 78.5 16.5t60 46t38 70.5t13.5 91q0 52 -14 93.5t-39.5 71t-60.5 45t-76 15.5q-42 0 -76.5 -16.5t-58.5 -46t-37 -71t-13 -91.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni044F",
    unicode: "\u044F",
    horizAdvX: 492,
    d: "M185 211q-51 11 -84 49.5t-33 103.5q0 33 12 61.5t34.5 49.5t53 33t68.5 12h177v-520h-49v205h-127l-146 -205h-58zM364 249v227h-126q-26 0 -47.5 -8t-38 -23t-25.5 -35.5t-9 -45.5q0 -49 28.5 -82t79.5 -33h138z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0450",
    unicode: "\u0450",
    horizAdvX: 583,
    d: "M299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12 q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410zM211 730h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0451",
    unicode: "\u0451",
    horizAdvX: 583,
    d: "M205 640v88h44v-88h-44zM341 640v88h44v-88h-44zM299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16 q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0452",
    unicode: "\u0452",
    horizAdvX: 578,
    d: "M504 -28q0 -32 -12.5 -59.5t-32.5 -47.5t-47 -31t-55 -11q-32 0 -59.5 8.5t-47.5 28.5l27 33q15 -14 35 -19t40 -5q19 0 37.5 8t33 21.5t23 32t8.5 39.5v289q0 96 -31.5 144t-101.5 48q-35 0 -66 -14.5t-56 -39.5t-43 -59t-27 -74v-264h-50v596h-73v40h73v94h50v-94h237 v-40h-237v-254q26 72 80.5 113.5t124.5 41.5q89 0 129.5 -58t40.5 -171v-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0453",
    unicode: "\u0453",
    horizAdvX: 407,
    d: "M224 629l-35 16l61 85h58zM384 481h-256v-481h-49v520h305v-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0454",
    unicode: "\u0454",
    horizAdvX: 541,
    d: "M296 -9q-58 0 -105 23t-80 61.5t-51 87t-18 99.5q0 50 17 98t50 85.5t80.5 60.5t108.5 23q75 0 124.5 -33t75.5 -84l-36 -19q-29 52 -75 73.5t-91 21.5t-81.5 -17t-62.5 -45t-41.5 -64.5t-19.5 -75.5h273v-41h-274q3 -45 19.5 -84t44.5 -67.5t64 -45t78 -16.5q24 0 49 6 t48.5 18.5t43 31.5t32.5 45l40 -18q-13 -30 -35.5 -53t-51 -39t-61 -24t-65.5 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0455",
    unicode: "\u0455",
    horizAdvX: 481,
    d: "M242 -10q-60 0 -115 20t-96 60l25 34q42 -38 87 -56t99 -18q68 0 109.5 28.5t41.5 79.5q0 24 -10.5 40.5t-31.5 28t-52 20.5t-72 19q-44 10 -76.5 20t-53.5 24t-31.5 34t-10.5 51q0 39 15 68t41.5 48t61 28.5t73.5 9.5q61 0 108 -20.5t73 -52.5l-28 -27q-26 30 -67.5 45 t-88.5 15q-29 0 -54.5 -6t-44.5 -19t-30 -33.5t-11 -48.5q0 -23 7.5 -37t24 -24t42.5 -17.5t62 -16.5q49 -12 87 -23t63.5 -27t39 -38t13.5 -56q0 -70 -54.5 -111.5t-145.5 -41.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0456",
    unicode: "\u0456",
    horizAdvX: 208,
    d: "M79 0v520h50v-520h-50zM79 638v92h50v-92h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0457",
    unicode: "\u0457",
    horizAdvX: 208,
    d: "M14 640v88h44v-88h-44zM150 640v88h44v-88h-44zM79 0v520h50v-520h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0458",
    unicode: "\u0458",
    horizAdvX: 215,
    d: "M-10 -177q-32 0 -59.5 8.5t-49.5 28.5l27 33q17 -14 37 -19t40 -5q19 0 37 7.5t32 21t23 32t9 40.5v550h50v-548q0 -33 -12.5 -60t-33.5 -47t-47 -31t-53 -11zM86 638v92h50v-92h-50z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0459",
    unicode: "\u0459",
    horizAdvX: 790,
    d: "M8 43q25 1 45.5 15.5t37 52.5t29.5 103.5t24 168.5l14 137h289v-215h149q71 0 114.5 -40t43.5 -112q0 -70 -43.5 -111.5t-114.5 -41.5h-199v479h-192l-14 -118q-13 -106 -28.5 -175.5t-36.5 -110.5t-48 -58.5t-63 -18.5zM596 43q56 0 82 32t26 78q0 47 -25 77.5t-83 30.5 h-149v-218h149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045A",
    unicode: "\u045A",
    horizAdvX: 801,
    d: "M79 520h49v-215h275v215h49v-215h155q71 0 114.5 -40t43.5 -112q0 -70 -44 -111.5t-114 -41.5h-204v261h-275v-261h-49v520zM607 43q56 0 82 32t26 78q0 47 -25 77.5t-83 30.5h-155v-218h155z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045B",
    unicode: "\u045B",
    horizAdvX: 577,
    d: "M454 259q0 96 -31.5 144t-102.5 48q-35 0 -65.5 -14t-55 -38.5t-43 -59t-27.5 -74.5v-265h-50v596h-74v40h74v94h50v-94h237v-40h-237v-252q25 70 79.5 111.5t125.5 41.5q89 0 129.5 -57.5t40.5 -171.5v-268h-50v259z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045C",
    unicode: "\u045C",
    horizAdvX: 469,
    d: "M233 629l-35 16l61 85h58zM383 520h58l-191 -250l210 -270h-57l-188 247h-87v-247h-49v520h49v-233h83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045D",
    unicode: "\u045D",
    horizAdvX: 573,
    d: "M128 70l335 450h42v-520h-50v442l-329 -442h-47v520h49v-450zM198 730h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045E",
    unicode: "\u045E",
    horizAdvX: 540,
    d: "M113 -175q6 -1 11 -1.5t10 -0.5q17 0 26 3t17 14q10 13 26.5 49t45.5 111l-232 520h52l207 -471l193 471h49l-286 -684q-14 -35 -35.5 -46t-59.5 -12q-6 0 -12 0.5t-12 1.5v45zM403 703q-2 -38 -33.5 -60.5t-93.5 -22.5q-63 0 -94.5 22.5t-33.5 60.5h33q1 -27 23.5 -41 t71.5 -14q48 0 69 13t25 42h33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni045F",
    unicode: "\u045F",
    horizAdvX: 539,
    d: "M244 0h-165v521h49v-477h282v477h49v-521h-166v-159h-49v159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0490",
    unicode: "\u0490",
    horizAdvX: 524,
    d: "M94 710h364l6 176h39v-222h-358v-664h-51v710z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni0491",
    unicode: "\u0491",
    horizAdvX: 424,
    d: "M79 520h283l6 159h34v-200h-274v-479h-49v520z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B0",
    unicode: "\u04B0",
    horizAdvX: 626,
    d: "M480 242v-37h-142v-205h-51v205h-141v37h141v28l-278 440h57l247 -393l249 393h55l-279 -440v-28h142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni04B1",
    unicode: "\u04B1",
    horizAdvX: 553,
    d: "M250 0h-124v38h124v4l-238 478h57l207 -432l210 432h55l-240 -478v-4h125v-38h-125v-213h-51v213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ddotbelow",
    unicode: "\u1E0C",
    horizAdvX: 713,
    d: "M315 -151v90h46v-90h-46zM93 0v710h236q84 0 147.5 -28t105.5 -76t63 -112.5t21 -137.5q0 -81 -23.5 -146.5t-67.5 -112t-106.5 -72t-139.5 -25.5h-236zM615 356q0 67 -19 123.5t-55.5 97.5t-89.5 64t-122 23h-185v-618h185q70 0 123.5 23.5t89.5 65.5t54.5 98.5 t18.5 122.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ddotbelow",
    unicode: "\u1E0D",
    horizAdvX: 615,
    d: "M273 -151v90h46v-90h-46zM292 -10q-54 0 -100 22.5t-79.5 60t-52 86t-18.5 100.5q0 54 18 103t50 86t75.5 59t95.5 22q34 0 64 -10t56 -26.5t47 -38.5t36 -47v323h50v-660q0 -25 21 -25v-45q-6 -1 -10 -1.5t-8 -0.5q-20 0 -34 15.5t-14 32.5v58q-32 -52 -85.5 -83 t-111.5 -31zM301 35q27 0 58 11t57.5 30.5t45.5 44.5t22 54v171q-11 28 -31.5 53.5t-46.5 44t-56 29.5t-58 11q-45 0 -82 -19.5t-63 -51t-40 -72t-14 -83.5q0 -45 16 -85t44.5 -71t66 -49t81.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hdotbelow",
    unicode: "\u1E24",
    horizAdvX: 735,
    d: "M643 710v-710h-51v340h-448v-340h-51v710h51v-324h448v324h51zM348 -151v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hdotbelow",
    unicode: "\u1E25",
    horizAdvX: 576,
    d: "M503 0h-50v290q0 193 -129 193q-32 0 -62.5 -12t-57 -34t-46.5 -51.5t-30 -63.5v-322h-50v730h50v-334q32 61 88.5 97t121.5 36q43 0 74 -16t51.5 -46t30 -72.5t9.5 -95.5v-299zM270 -151v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ndotaccent",
    unicode: "\u1E44",
    horizAdvX: 773,
    d: "M367 827v90h46v-90h-46zM144 614v-614h-51v710h39l498 -625v625h51v-710h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ndotaccent",
    unicode: "\u1E45",
    horizAdvX: 576,
    d: "M267 640v90h46v-90h-46zM503 0h-50v290q0 101 -28.5 147t-90.5 46q-33 0 -65.5 -12t-60.5 -34t-49 -51.5t-31 -63.5v-322h-50v520h47v-124q16 30 39.5 54.5t53 42t62.5 27t68 9.5q85 0 120 -59.5t35 -170.5v-299z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rdotbelow",
    unicode: "\u1E5A",
    horizAdvX: 649,
    d: "M93 0v710h295q45 0 83 -19t65.5 -50.5t43 -71t15.5 -79.5q0 -39 -12 -75.5t-34 -65.5t-53 -48t-68 -25l177 -276h-59l-172 268h-230v-268h-51zM144 315h249q34 0 62 15t48 39.5t30.5 56t10.5 64.5q0 34 -12.5 65.5t-34 55.5t-50 38.5t-61.5 14.5h-242v-349zM303 -151v90 h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rdotbelow",
    unicode: "\u1E5B",
    horizAdvX: 341,
    d: "M324 475q-70 -2 -122.5 -41.5t-73.5 -108.5v-325h-50v520h48v-128q27 55 71.5 89.5t95.5 39.5q10 1 18 1h13v-47zM80 -151v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sdotbelow",
    unicode: "\u1E62",
    horizAdvX: 605,
    d: "M506 592q-69 77 -195 77q-104 0 -151.5 -39.5t-47.5 -106.5q0 -34 12 -56.5t37.5 -38.5t64.5 -27t94 -23q57 -12 103.5 -26.5t79 -36.5t50 -54t17.5 -79t-18.5 -82t-52 -58.5t-80 -35.5t-103.5 -12q-166 0 -281 106l27 41q45 -47 110 -74.5t146 -27.5q93 0 145.5 34 t52.5 103q0 35 -14 59.5t-41.5 42.5t-69.5 31t-98 25q-57 12 -100.5 25.5t-73 34t-44.5 49.5t-15 73q0 48 18.5 85t51.5 62.5t79 38.5t102 13q69 0 123 -20.5t98 -62.5zM286 -151v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sdotbelow",
    unicode: "\u1E63",
    horizAdvX: 481,
    d: "M243 -10q-60 0 -115 20t-96 60l25 34q42 -38 87 -56t99 -18q68 0 109.5 28.5t41.5 79.5q0 24 -10.5 40.5t-31.5 28t-52 20.5t-72 19q-44 10 -76.5 20t-53.5 24t-31.5 34t-10.5 51q0 39 15 68t41.5 48t61 28.5t73.5 9.5q61 0 108 -20.5t73 -52.5l-28 -27q-26 30 -67.5 45 t-88.5 15q-29 0 -54.5 -6t-44.5 -19t-30 -33.5t-11 -48.5q0 -23 7.5 -37t24 -24t42.5 -17.5t62 -16.5q49 -12 87 -23t63.5 -27t39 -38t13.5 -56q0 -70 -54.5 -111.5t-145.5 -41.5zM216 -151v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tdotbelow",
    unicode: "\u1E6C",
    horizAdvX: 606,
    d: "M279 -151v90h46v-90h-46zM589 664h-260v-664h-51v664h-260v46h571v-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tdotbelow",
    unicode: "\u1E6D",
    horizAdvX: 320,
    d: "M171 -151v90h46v-90h-46zM310 25q-4 -2 -13.5 -7.5t-24 -10.5t-32.5 -9t-39 -4t-39.5 6t-32.5 18t-22 29t-8 40v392h-73v41h73v178h50v-178h121v-41h-121v-380q0 -29 20 -43.5t45 -14.5q31 0 53.5 10.5t27.5 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1043,
    d: "M365 705h50l106 -258l106 258h50l-125 -299l149 -346l272 650h56l-304 -710h-47l-156 365l-157 -365h-47l-303 710h55l273 -650l147 346zM437 918h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 806,
    d: "M737 520h50l-225 -520h-42l-117 275l-117 -275h-42l-225 520h49l199 -465l109 256l-88 208h43l72 -172l71 172h44l-88 -208l109 -256zM319 730h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1043,
    d: "M520 816l-35 16l61 85h58zM365 705h50l106 -258l106 258h50l-125 -299l149 -346l272 650h56l-304 -710h-47l-156 365l-157 -365h-47l-303 710h55l273 -650l147 346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 806,
    d: "M402 629l-35 16l61 85h58zM737 520h50l-225 -520h-42l-117 275l-117 -275h-42l-225 520h49l199 -465l109 256l-88 208h43l72 -172l71 172h44l-88 -208l109 -256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1043,
    d: "M431 828v88h44v-88h-44zM567 828v88h44v-88h-44zM365 705h50l106 -258l106 258h50l-125 -299l149 -346l272 650h56l-304 -710h-47l-156 365l-157 -365h-47l-303 710h55l273 -650l147 346z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 806,
    d: "M313 640v88h44v-88h-44zM449 640v88h44v-88h-44zM737 520h50l-225 -520h-42l-117 275l-117 -275h-42l-225 520h49l199 -465l109 256l-88 208h43l72 -172l71 172h44l-88 -208l109 -256z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotbelow",
    unicode: "\u1E92",
    horizAdvX: 627,
    d: "M30 42l505 622h-498v46h558v-42l-501 -622h499v-46h-563v42zM298 -151v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotbelow",
    unicode: "\u1E93",
    horizAdvX: 490,
    d: "M32 36l368 445h-362v39h418v-36l-367 -445h365v-39h-422v36zM222 -151v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotbelow",
    unicode: "\u1EB8",
    d: "M566 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422zM308 -151v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotbelow",
    unicode: "\u1EB9",
    horizAdvX: 583,
    d: "M299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12 q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410zM276 -151v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Etilde",
    unicode: "\u1EBC",
    d: "M566 46v-46h-473v710h464v-46h-413v-279h361v-44h-361v-295h422zM401 834q-22 0 -39 6t-31 13.5t-27.5 14t-28.5 6.5q-17 0 -27 -7t-15 -15.5t-7 -16t-2 -9.5h-34q0 4 3 17.5t12.5 28t26 26t43.5 11.5q20 0 35.5 -6.5t29.5 -14t28.5 -13.5t33.5 -6q20 0 31.5 7t17 15.5 t7 16t1.5 9.5h34q0 -5 -3.5 -18.5t-13 -27.5t-27.5 -25.5t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "etilde",
    unicode: "\u1EBD",
    horizAdvX: 583,
    d: "M299 -10q-55 0 -102 21.5t-81.5 59t-54 86.5t-19.5 105q0 55 19.5 103.5t53.5 85t80.5 57.5t100.5 21q55 0 102 -21.5t81 -58t53 -85t19 -102.5v-12.5t-1 -9.5h-456q3 -45 21 -83.5t45.5 -66.5t63.5 -44t77 -16q27 0 53 7.5t48.5 20.5t40 31.5t27.5 40.5l44 -12 q-11 -28 -32.5 -51.5t-50 -40.5t-62.5 -26.5t-70 -9.5zM503 280q-3 46 -20.5 84t-45 65.5t-63.5 43t-77 15.5t-77 -15.5t-63.5 -43t-44 -66t-19.5 -83.5h410zM356 647q-22 0 -39 6t-31 13.5t-27.5 14t-28.5 6.5q-17 0 -27 -7t-15 -15.5t-7 -16t-2 -9.5h-34q0 4 3 17.5 t12.5 28t26 26t43.5 11.5q20 0 35.5 -6.5t29.5 -14t28.5 -13.5t33.5 -6q20 0 31.5 7t17 15.5t7 16t1.5 9.5h34q0 -5 -3.5 -18.5t-13 -27.5t-27.5 -25.5t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotbelow",
    unicode: "\u1ECA",
    horizAdvX: 237,
    d: "M93 0v710h51v-710h-51zM94 -151v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idotbelow",
    unicode: "\u1ECB",
    horizAdvX: 207,
    d: "M78 0v520h50v-520h-50zM78 638v92h50v-92h-50zM80 -151v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odotbelow",
    unicode: "\u1ECC",
    horizAdvX: 753,
    d: "M353 -151v90h46v-90h-46zM376 -5q-74 0 -135 31t-105 81t-68 115t-24 133q0 71 25.5 136t70 115t105.5 79.5t132 29.5q74 0 135.5 -31.5t105 -82.5t67.5 -115.5t24 -130.5q0 -72 -25.5 -137t-70 -114.5t-105.5 -79t-132 -29.5zM95 355q0 -61 20.5 -117.5t58 -100 t89.5 -69.5t114 -26q64 0 115.5 27t88 71.5t56.5 100.5t20 114q0 61 -21 117.5t-58.5 100t-88.5 69.5t-112 26q-64 0 -116 -27t-89 -71.5t-57 -100.5t-20 -114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odotbelow",
    unicode: "\u1ECD",
    horizAdvX: 592,
    d: "M270 -151v90h46v-90h-46zM296 -10q-55 0 -101.5 21.5t-80.5 58.5t-53 86t-19 103q0 55 19.5 104t53.5 86t80.5 58.5t100.5 21.5t100 -21.5t80.5 -58.5t54 -86t19.5 -104q0 -54 -19.5 -103t-53.5 -86t-80.5 -58.5t-100.5 -21.5zM92 257q0 -46 16 -86.5t43.5 -70.5 t64.5 -47.5t79 -17.5t79 17.5t65 48.5t44 71.5t16 87.5q0 46 -16 86.5t-44 71t-64.5 48.5t-78.5 18t-79 -18t-64.5 -49t-44 -72.5t-16.5 -87.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udotbelow",
    unicode: "\u1EE4",
    horizAdvX: 756,
    d: "M378 42q72 0 119.5 27t75 71t39 100t11.5 113v357h51v-357q0 -71 -15.5 -136t-50.5 -114.5t-91 -78.5t-138 -29q-85 0 -142 30.5t-91.5 81t-49 114.5t-14.5 132v357h51v-357q0 -59 11.5 -115t40 -99.5t75.5 -70t118 -26.5zM358 -151v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udotbelow",
    unicode: "\u1EE5",
    horizAdvX: 587,
    d: "M239 -10q-166 0 -166 230v300h50v-293q0 -192 131 -192q33 0 64 11.5t58 32t47.5 49.5t32.5 64v328h50v-450q0 -25 21 -25v-45q-5 -1 -9 -1h-6q-20 0 -35.5 12.5t-15.5 33.5v78q-34 -63 -93.5 -98t-128.5 -35zM260 -151v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 647,
    d: "M75 710l248 -393l249 393h57l-280 -442v-268h-51v270l-279 440h56zM239 918h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 540,
    d: "M113 -176q5 -1 15 -1t18.5 1t16.5 5q6 3 11 8.5t14 22.5t23 50t38 90l-232 520h52l207 -471l193 471h49l-285 -684q-11 -28 -35.5 -43.5t-66.5 -15.5h-8.5t-9.5 1v46zM192 730h57l62 -85l-34 -16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ytilde",
    unicode: "\u1EF8",
    horizAdvX: 647,
    d: "M75 710l248 -393l249 393h57l-280 -442v-268h-51v270l-279 440h56zM384 834q-22 0 -39 6t-31 13.5t-27.5 14t-28.5 6.5q-17 0 -27 -7t-15 -15.5t-7 -16t-2 -9.5h-34q0 4 3 17.5t12.5 28t26 26t43.5 11.5q20 0 35.5 -6.5t29.5 -14t28.5 -13.5t33.5 -6q20 0 31.5 7t17 15.5 t7 16t1.5 9.5h34q0 -5 -3.5 -18.5t-13 -27.5t-27.5 -25.5t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ytilde",
    unicode: "\u1EF9",
    horizAdvX: 540,
    d: "M113 -176q5 -1 15 -1t18.5 1t16.5 5q6 3 11 8.5t14 22.5t23 50t38 90l-232 520h52l207 -471l193 471h49l-285 -684q-11 -28 -35.5 -43.5t-66.5 -15.5h-8.5t-9.5 1v46zM337 647q-22 0 -39 6t-31 13.5t-27.5 14t-28.5 6.5q-17 0 -27 -7t-15 -15.5t-7 -16t-2 -9.5h-34 q0 4 3 17.5t12.5 28t26 26t43.5 11.5q20 0 35.5 -6.5t29.5 -14t28.5 -13.5t33.5 -6q20 0 31.5 7t17 15.5t7 16t1.5 9.5h34q0 -5 -3.5 -18.5t-13 -27.5t-27.5 -25.5t-48 -11.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "enspace",
    unicode: "\u2002",
    horizAdvX: 573
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emspace",
    unicode: "\u2003",
    horizAdvX: 912
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 559,
    d: "M67 249v46h425v-46h-425z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 892,
    d: "M67 249v46h758v-46h-758z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 185,
    d: "M114 730l-15 -99h19v-91h-52v91l21 99h27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 180,
    d: "M71 540l15 99h-19v91h52v-91l-21 -99h-27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 238,
    d: "M97 -93l15 93h-18v92h51v-92l-21 -93h-27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 291,
    d: "M114 730l-15 -99h19v-91h-52v91l21 99h27zM220 730l-15 -99h19v-91h-52v91l21 99h27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 286,
    d: "M71 540l15 99h-19v91h52v-91l-21 -99h-27zM176 540l15 99h-19v91h52v-91l-21 -99h-27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 338,
    d: "M97 -93l15 93h-18v92h51v-92l-21 -93h-27zM197 -93l15 93h-18v92h51v-92l-21 -93h-27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 393,
    d: "M173 -130v378h-132v46h132v481h48v-481h131v-46h-131v-378h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 398,
    d: "M176 -130v305h-132v46h132v111h-132v46h132v397h48v-397h131v-46h-131v-111h131v-46h-131v-305h-48z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 347,
    d: "M259 345q0 -36 -25 -61t-60 -25q-18 0 -33.5 6.5t-27 18.5t-18.5 27.5t-7 33.5q0 17 7 32.5t18.5 27t27 18.5t33.5 7t33.5 -7t27 -18.5t18 -27t6.5 -32.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 416,
    d: "M67 0v85h44v-85h-44zM187 0v85h43v-85h-43zM306 0v85h44v-85h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1039,
    d: "M194 437q-30 0 -56.5 11t-46 30t-31 45t-11.5 55q0 30 11.5 55.5t31 45t46 30.5t56.5 11t56.5 -11t46 -30.5t31 -45t11.5 -55.5q0 -29 -11.5 -55t-31 -45t-46 -30t-56.5 -11zM194 469q22 0 41.5 9t33.5 24t22.5 35t8.5 41q0 23 -8.5 43t-23.5 35t-34 23.5t-40 8.5 q-22 0 -41 -9t-33.5 -24t-22.5 -35t-8 -42q0 -23 8.5 -42.5t22.5 -34.5t33.5 -23.5t40.5 -8.5zM516 -10q-30 0 -56.5 11t-46 30.5t-31 45t-11.5 55.5q0 29 11.5 55t31 45t46 30t56.5 11t56.5 -11t46 -30t31 -45t11.5 -55q0 -30 -11.5 -55.5t-31 -45t-46 -30.5t-56.5 -11z M516 22q22 0 41.5 9t33.5 24t22.5 35t8.5 42t-8.5 42t-23.5 35t-34 23.5t-40 8.5q-22 0 -41 -9t-33.5 -24t-22.5 -35t-8 -41q0 -23 8 -43t22.5 -35t33.5 -23.5t41 -8.5zM860 -10q-30 0 -56.5 11t-46 30.5t-31 45t-11.5 55.5q0 29 11.5 55t31 45t46 30t56.5 11t56.5 -11 t46 -30t31 -45t11.5 -55q0 -30 -11.5 -55.5t-31 -45t-46 -30.5t-56.5 -11zM860 22q22 0 41.5 9t33.5 24t22.5 35t8.5 42t-8.5 42t-23.5 35t-34 23.5t-40 8.5q-22 0 -41 -9t-33.5 -24t-22.5 -35t-8 -41q0 -23 8 -43t22.5 -35t33.5 -23.5t41 -8.5zM65 21l279 344l274 348 l28 -23l-279 -345l-275 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 351,
    d: "M41 273l244 175v-45l-202 -144l202 -143v-45l-244 172v30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 351,
    d: "M310 243l-245 -172v45l203 143l-203 144v45l245 -175v-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 141,
    d: "M-220 21l279 344l274 348l28 -23l-279 -345l-275 -348z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 450,
    d: "M226 412q-47 0 -82 18.5t-58 47.5t-35 64.5t-12 68.5q0 35 13 70.5t37.5 64t59 46.5t77.5 18q46 0 80.5 -19t57.5 -48.5t35 -64.5t12 -67q0 -36 -13 -72t-37 -64t-58 -45.5t-77 -17.5zM76 611q0 -29 10 -58t29 -52.5t47 -38.5t64 -15q37 0 65 16t47 40t28 53t9 55 q0 29 -10 58t-29 52.5t-47 38.5t-63 15q-38 0 -66 -16t-47 -40t-28 -53t-9 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 377,
    d: "M255 417v105h-230v33l240 255h25v-253h57v-35h-57v-105h-35zM65 557h190v202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 369,
    d: "M186 666q31 0 58 -9t47.5 -25.5t32 -39.5t11.5 -50q0 -29 -12.5 -53t-34 -41t-50 -26.5t-60.5 -9.5q-48 0 -86.5 20.5t-58.5 55.5l25 18q18 -28 50 -44.5t72 -16.5q25 0 47 7t38 20t25 31t9 39q0 23 -10.5 40.5t-27 29.5t-37.5 18.5t-42 6.5q-32 0 -60.5 -13t-45.5 -35 h-34q3 16 11 49t16.5 68.5t15.5 65t9 38.5h218v-35h-191l-35 -142q19 17 45 25t55 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 398,
    d: "M364 544q0 -29 -12.5 -53.5t-34 -43t-51 -29t-62.5 -10.5q-36 0 -65.5 11.5t-51.5 32.5t-34 51.5t-12 69.5q0 120 46.5 178.5t120.5 58.5q45 0 80.5 -19t52.5 -54l-22 -22q-14 28 -44 45t-68 17q-59 0 -95 -45t-37 -127q15 32 52 51.5t80 19.5q33 0 61.5 -10t50 -28 t33.5 -42t12 -52zM205 441q26 0 48.5 8t39.5 22t27 32.5t10 39.5t-10 39.5t-27 33t-40 22.5t-49 8t-49 -8t-40 -22t-27 -32.5t-10 -39.5t10 -39.5t27.5 -33t40.5 -22.5t49 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 346,
    d: "M279 775h-252v35h309l-231 -393h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 392,
    d: "M352 525q0 -26 -12.5 -46.5t-34.5 -35.5t-50.5 -23t-60.5 -8q-34 0 -62.5 9t-49 25t-32 37t-11.5 44q0 19 8 35.5t21.5 29t30.5 21.5t35 15q-32 11 -55.5 31.5t-23.5 51.5q0 23 12.5 41.5t32.5 31t45 19.5t51 7q25 0 50.5 -6.5t45 -19t32 -31t12.5 -41.5q0 -31 -23.5 -52 t-56.5 -32q42 -12 69 -38.5t27 -64.5zM316 529q0 19 -11 34.5t-28.5 26.5t-39 16.5t-42.5 5.5q-22 0 -43.5 -6t-38.5 -17t-27.5 -26.5t-10.5 -34.5t11 -34t28.5 -25.5t39 -16t42.5 -5.5q22 0 43.5 6t38.5 16.5t27.5 25.5t10.5 34zM91 709q0 -16 9.5 -28.5t24.5 -21t33.5 -13 t36.5 -4.5t37 4.5t34 13t24.5 21t9.5 28.5t-9 28.5t-23.5 21.5t-33.5 13.5t-39 4.5t-39 -4.5t-33.5 -13.5t-23 -21.5t-8.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 398,
    d: "M34 675q0 28 12.5 52.5t34 43t50.5 29t63 10.5q35 0 65 -11.5t51.5 -32.5t33.5 -51.5t12 -68.5q0 -121 -45.5 -179.5t-120.5 -58.5q-45 0 -81 19.5t-53 54.5l23 21q14 -28 44 -45t68 -17q59 0 95 45t36 127q-14 -32 -51 -52t-81 -20q-33 0 -61.5 10.5t-49.5 28.5 t-33 42.5t-12 52.5zM193 777q-26 0 -48.5 -8t-39.5 -22t-27 -32t-10 -39t10 -39.5t27.5 -33t40 -22.5t48.5 -8q25 0 48 8t40 22t27 32.5t10 39.5t-10 39.5t-27.5 32.5t-40.5 22t-48 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 450,
    d: "M226 -85q-47 0 -82 19t-58 48t-35 64t-12 68q0 36 13 71.5t37.5 64t59 46t77.5 17.5q46 0 80.5 -19t57.5 -48.5t35 -64.5t12 -67q0 -36 -13 -71.5t-37 -64t-58 -46t-77 -17.5zM76 114q0 -29 10 -58t29 -52.5t47 -38.5t64 -15q37 0 65 16t47 40t28 53t9 55q0 29 -10 58 t-29 52.5t-47 38.5t-63 15q-38 0 -66 -16t-47 -40t-28 -53t-9 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 274,
    d: "M253 -46v-34h-204v34h87v323q-6 -7 -17.5 -15t-26 -15.5t-29.5 -12.5t-28 -5v35q16 0 34 8t32.5 18t24 19t10.5 10h35v-365h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 383,
    d: "M37 -80q0 76 32 116.5t94 63.5q22 9 46.5 17t44.5 19t33 27.5t13 40.5q0 32 -26 56t-80 24q-26 0 -46.5 -6t-36.5 -14.5t-27 -18.5t-18 -19l-24 25q3 4 14 15t30.5 22.5t47.5 20.5t65 9q71 0 105.5 -33.5t34.5 -81.5q0 -31 -14.5 -52t-35.5 -35t-46 -23t-46 -16 q-36 -11 -58 -26.5t-34 -32t-16 -33.5t-4 -31h255v-34h-303z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 387,
    d: "M190 -85q-63 0 -105 25t-48 67l23 20q1 -14 11.5 -28t27.5 -25t40.5 -17.5t50.5 -6.5q25 0 47 5.5t38 15.5t25.5 24t9.5 31q0 37 -40.5 58t-108.5 21h-23v32h23q64 0 99.5 18t35.5 53t-32.5 56.5t-79.5 21.5q-42 0 -72.5 -16t-44.5 -42l-25 26q17 29 56 46.5t86 17.5 q32 0 59.5 -8.5t47.5 -23t31.5 -34t11.5 -42.5q0 -68 -90 -88q47 -7 74.5 -35t27.5 -66q0 -24 -12.5 -44t-33.5 -33.5t-49.5 -21t-60.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 377,
    d: "M255 -80v106h-230v32l240 255h25v-253h57v-34h-57v-106h-35zM65 60h190v202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 369,
    d: "M186 169q31 0 58 -9t47.5 -25.5t32 -39.5t11.5 -51q0 -29 -12.5 -52.5t-34 -40.5t-50 -26.5t-60.5 -9.5q-48 0 -86.5 20.5t-58.5 54.5l25 19q18 -28 50 -44.5t72 -16.5q25 0 47 7t38 20t25 31t9 39q0 23 -10.5 40.5t-27 29.5t-37.5 18.5t-42 6.5q-32 0 -60.5 -13 t-45.5 -35h-34q3 16 11 49t16.5 68.5t15.5 65t9 38.5h218v-35h-191l-35 -142q19 17 45 25t55 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 398,
    d: "M364 50q0 -28 -12.5 -52.5t-34 -43t-50.5 -29t-63 -10.5q-35 0 -65 11.5t-51.5 32.5t-33.5 51.5t-12 68.5q0 120 46 178.5t121 58.5q45 0 80.5 -19t52.5 -54l-23 -22q-13 28 -43 45t-68 17q-60 0 -95.5 -44.5t-36.5 -127.5q7 16 20.5 29.5t31 23t38 14.5t41.5 5 q33 0 62 -10.5t50 -28.5t33 -42t12 -52zM205 -53q26 0 48.5 8t39.5 22t27 32.5t10 39.5t-10 39.5t-27 33t-40 22.5t-49 8t-48.5 -8t-39.5 -22t-27 -32.5t-10 -39.5t10 -39.5t27.5 -33t40 -22.5t48.5 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 345,
    d: "M280 278h-253v35h309l-231 -393h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 392,
    d: "M352 28q0 -25 -12.5 -45.5t-34.5 -35.5t-50.5 -23t-60.5 -8q-34 0 -62.5 9t-49 24.5t-32 36.5t-11.5 44q0 19 8 35.5t21.5 29t30.5 22t35 14.5q-32 11 -55.5 31.5t-23.5 51.5q0 24 12.5 42t32.5 31t45 19.5t51 6.5q25 0 50.5 -6.5t45 -19t32 -31t12.5 -41.5 q0 -31 -23.5 -52t-56.5 -32q42 -12 69 -38.5t27 -64.5zM316 32q0 19 -11 34.5t-28.5 26.5t-39 16.5t-42.5 5.5q-22 0 -43.5 -6t-38.5 -17t-27.5 -26.5t-10.5 -34.5t11 -34t28.5 -25.5t39 -16t42.5 -5.5q22 0 43.5 6t38.5 16.5t27.5 25.5t10.5 34zM91 212q0 -16 9.5 -28.5 t24.5 -21t33.5 -13t36.5 -4.5t37 4.5t34 13.5t24.5 21.5t9.5 28.5q0 15 -9 27.5t-23.5 21.5t-33.5 13.5t-39 4.5t-39 -4.5t-33.5 -13.5t-23 -21.5t-8.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 399,
    d: "M34 181q0 28 12.5 52.5t34 43t51 29t62.5 10.5q36 0 65.5 -11.5t51.5 -32.5t34 -51.5t12 -68.5q0 -121 -46 -179t-121 -58q-45 0 -81 19t-53 54l24 22q13 -29 43 -45.5t68 -16.5q59 0 95 45t37 126q-15 -32 -51.5 -51.5t-80.5 -19.5q-33 0 -61.5 10.5t-50 28.5t-33.5 42 t-12 52zM193 284q-26 0 -48.5 -8t-39 -22t-26.5 -32.5t-10 -39.5t10 -39.5t27 -33t39.5 -22.5t48.5 -8t48.5 8t39.5 22t27 32.5t10 39.5t-10 39.5t-27 32.5t-40 22.5t-49 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colonmonetary",
    unicode: "\u20A1",
    horizAdvX: 546,
    d: "M230 0q-42 12 -76.5 37t-59.5 59.5t-39 76.5t-14 89q0 46 13.5 88t38.5 76t60 58.5t77 35.5v125h31v-119q18 3 37 3q7 0 14 -0.5t14 -1.5v118h31v-123q50 -11 88 -40.5t59 -73.5l-49 -16q-23 43 -66 67.5t-94 24.5q-42 0 -79 -17t-64.5 -47t-43.5 -70.5t-16 -87.5 t16.5 -88.5t44 -72t64.5 -48.5t79 -18q27 0 54 8t49.5 21t39 30.5t22.5 36.5l49 -14q-17 -44 -58 -76t-95 -44v-117h-31v112q-7 -1 -13.5 -1.5t-13.5 -0.5q-20 0 -38 3v-113h-31v120z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "franc",
    unicode: "\u20A3",
    horizAdvX: 613,
    d: "M121 0v140h-93v42h93v528h462v-46h-411v-282h349v-44h-349v-156h147v-42h-147v-140h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lira",
    unicode: "\u20A4",
    horizAdvX: 478,
    d: "M47 383h93q-11 20 -22.5 39.5t-21 39t-15.5 40.5t-6 44q0 35 14 65.5t37.5 53.5t55 36.5t67.5 13.5q53 0 99 -28.5t75 -76.5l-31 -31q-24 43 -63 68t-82 25q-26 0 -48.5 -10t-39 -27.5t-26.5 -40.5t-10 -50q0 -21 6 -41t16 -39.5t22 -39.5t23 -41h182v-34h-166 q13 -32 17 -63h160v-34h-157q0 -26 -5.5 -50t-18.5 -49t-34 -52t-51 -60q37 8 72 8q22 0 40 -3t35 -6.5t34 -6.5t35 -3q21 0 42.5 4.5t50.5 14.5l13 -40q-53 -24 -108 -24q-22 0 -41.5 3.5t-38.5 7.5t-38.5 7.5t-42.5 3.5t-51.5 -4t-51.5 -10l-15 37q37 37 61.5 67 t39.5 55.5t21 49.5t6 50h-109v34h106q-6 31 -20 63h-110v34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A6",
    unicode: "\u20A6",
    horizAdvX: 833,
    d: "M795 376h-84v-65h84v-34h-84v-277h-47l-221 277h-269v-277h-51v277h-85v34h85v65h-85v34h85v300h39l239 -300h259v300h51v-300h84v-34zM174 410h163l-163 204v-204zM660 85v192h-153zM174 311h242l-52 65h-190v-65zM480 311h180v65h-232z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20A9",
    unicode: "\u20A9",
    horizAdvX: 1101,
    d: "M43 364h148l-29 69h-119v34h104l-103 243h55l102 -243h292l-99 238h50l106 -258l106 258h50l-100 -238h294l102 243h56l-104 -243h104v-34h-119l-29 -69h148v-34h-163l-141 -330h-47l-156 365l-157 -365h-47l-141 330h-163v34zM730 60l113 270h-230zM372 60l114 270h-227 zM581 406l18 -42h258l29 69h-294zM507 433h-292l29 -69h257l18 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 807,
    d: "M144 410q8 58 34 113t68.5 97.5t100.5 68t130 25.5q95 0 162 -43.5t100 -111.5l-42 -24q-19 37 -44.5 62t-55 40.5t-61.5 22.5t-63 7q-60 0 -107.5 -21.5t-83 -57.5t-57.5 -82.5t-29 -95.5h359l-15 -34h-348v-19q0 -24 3 -46h323l-16 -34h-301q12 -50 37.5 -93 t61.5 -74.5t81 -50t95 -18.5q32 0 66 8t65 25t58 43.5t45 62.5l44 -21q-18 -40 -49 -71t-69 -52t-80.5 -31.5t-83.5 -10.5q-62 0 -115 23t-95 62t-70.5 90.5t-41.5 107.5h-117l15 34h96q-3 24 -3 49v16h-75l15 34h63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni20B9",
    unicode: "\u20B9",
    horizAdvX: 450,
    d: "M411 572h-95q17 -42 17 -82q0 -39 -12 -75.5t-34 -65.5t-52.5 -48t-67.5 -25l176 -276h-58l-202 315h48q35 0 63 15t47.5 39.5t30 56t10.5 64.5q0 22 -5.5 42.5t-14.5 39.5h-218v34h196q-22 26 -51.5 42t-63.5 16h-81v46h367v-34h-176q20 -14 36 -32t29 -38h111v-34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2113",
    unicode: "\u2113",
    horizAdvX: 292,
    d: "M188 39q13 0 28.5 4.5t29.5 9.5l10 -40q-19 -8 -42.5 -13.5t-43.5 -5.5q-45 0 -69.5 25.5t-24.5 74.5v516q0 28 8 51.5t21.5 41t32 27.5t40.5 10q45 0 71.5 -36t26.5 -94q0 -39 -13 -84.5t-34.5 -91t-49.5 -87t-58 -71.5v-174q0 -29 18 -46t49 -17zM233 604 q0 45 -14 69.5t-40 24.5t-42 -24.5t-16 -63.5v-279q22 27 42.5 62.5t36 73t24.5 73.5t9 64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "afii61352",
    unicode: "\u2116",
    horizAdvX: 1124,
    d: "M144 614v-614h-51v710h39l498 -625v624h51v-709h-47zM926 351q-39 0 -71.5 14.5t-56.5 39.5t-37 57.5t-13 68.5q0 37 13.5 70t37 58t56 39.5t71.5 14.5t71.5 -14.5t56.5 -39.5t37.5 -58t13.5 -70q0 -36 -13.5 -68.5t-37 -57.5t-56.5 -39.5t-72 -14.5zM792 530 q0 -29 10.5 -55t28.5 -45.5t42.5 -30.5t52.5 -11t52.5 11.5t43 31t29 45.5t10.5 56t-10.5 56t-29 45t-43 30t-52.5 11q-27 0 -51.5 -11t-43 -30.5t-29 -46t-10.5 -56.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "servicemark",
    unicode: "\u2120",
    horizAdvX: 695,
    d: "M572 710h51v-283h-38v226l-89 -184h-31l-90 184v-226h-37v283h49l93 -195zM246 650q-25 31 -74 31q-36 0 -52 -11.5t-16 -32.5q0 -20 15 -30t57 -19q48 -10 77 -28t29 -60q0 -38 -30 -57t-78 -19q-69 0 -118 43l19 29q36 -38 100 -38q32 0 49.5 9.5t17.5 29.5 q0 24 -17 35t-61 21q-48 10 -73.5 26.5t-25.5 54.5q0 39 29.5 60t77.5 21q57 0 94 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 697,
    d: "M288 674h-95v-247h-37v247h-95v38h227v-38zM569 710h50v-283h-37v226l-90 -184h-31l-89 184v-226h-38v283h50l92 -195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omega",
    unicode: "\u2126",
    horizAdvX: 766,
    d: "M47 47h201q-91 45 -142.5 130t-51.5 188q0 69 25 132.5t69 111.5t104 77t131 29t131 -29t104 -77t69 -111.5t25 -132.5q0 -51 -13.5 -99t-38.5 -89t-61.5 -74.5t-81.5 -55.5h202v-47h-289v47q55 13 98 45.5t72 76.5t44.5 95t15.5 101q0 56 -19 110.5t-55 97t-87.5 68.5 t-115.5 26t-115.5 -26t-87.5 -68.5t-55 -97t-19 -110.5q0 -50 15.5 -101t44.5 -95t72 -76.5t98 -45.5v-47h-289v47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "estimated",
    unicode: "\u212E",
    horizAdvX: 606,
    d: "M308 18q69 0 118 22t78 54l19 -21q-35 -35 -87.5 -59t-127.5 -24q-59 0 -107.5 22t-83 59t-53.5 86t-19 103q0 55 19.5 104t54 86t83 59t106.5 22t107 -22t83.5 -59.5t54 -87.5t19.5 -107h-440v-150q32 -41 77 -64t99 -23zM308 503q-54 0 -99 -23.5t-77 -65.5v-130h353 v129q-32 42 -78.5 66t-98.5 24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onethird",
    unicode: "\u2153",
    horizAdvX: 833,
    d: "M93 21l279 344l274 348l28 -23l-279 -345l-275 -348zM256 367v-35h-194v35h82v322q-5 -6 -16.5 -14.5t-25 -16t-28 -12.5t-26.5 -5v35q16 0 32.5 8t30.5 18t23 19l10 10h36v-364h76zM641 -5q-63 0 -105 25t-48 67l23 20q1 -14 11.5 -28t27.5 -25t40.5 -17.5t50.5 -6.5 q25 0 47 5.5t38 15.5t25.5 24t9.5 31q0 37 -40.5 58t-108.5 21h-23v32h23q64 0 99.5 18t35.5 53t-32.5 56.5t-79.5 21.5q-42 0 -72.5 -16t-44.5 -42l-25 26q17 29 56 46.5t86 17.5q32 0 59.5 -8.5t47.5 -23t31.5 -34t11.5 -42.5q0 -68 -90 -88q47 -7 74.5 -35t27.5 -66 q0 -24 -12.5 -44t-33.5 -33.5t-49.5 -21t-60.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twothirds",
    unicode: "\u2154",
    horizAdvX: 846,
    d: "M44 333q0 38 8 66.5t24 49.5t38.5 36t52.5 27q23 9 47 17t44 19.5t32.5 28t12.5 40.5q0 32 -25 56t-79 24q-26 0 -46 -6t-35.5 -14.5t-26.5 -18.5t-18 -18l-24 24q3 4 13.5 15t30 22.5t47.5 20.5t64 9q34 0 60 -9t43.5 -25t26 -36.5t8.5 -44.5q0 -30 -14 -51t-35 -35.5 t-45.5 -23.5t-44.5 -15q-36 -11 -58 -26.5t-34 -32.5t-16.5 -34t-4.5 -31h250v-34h-296zM146 21l279 344l274 348l28 -23l-279 -345l-275 -348zM653 -5q-63 0 -105 25t-48 67l23 20q1 -14 11.5 -28t27.5 -25t40.5 -17.5t50.5 -6.5q25 0 47 5.5t38 15.5t25.5 24t9.5 31 q0 37 -40.5 58t-108.5 21h-23v32h23q64 0 99.5 18t35.5 53t-32.5 56.5t-79.5 21.5q-42 0 -72.5 -16t-44.5 -42l-25 26q17 29 56 46.5t86 17.5q32 0 59.5 -8.5t47.5 -23t31.5 -34t11.5 -42.5q0 -68 -90 -88q47 -7 74.5 -35t27.5 -66q0 -24 -12.5 -44t-33.5 -33.5t-49.5 -21 t-60.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneeighth",
    unicode: "\u215B",
    horizAdvX: 831,
    d: "M104 21l279 344l274 348l28 -23l-279 -345l-275 -348zM255 367v-35h-194v35h82v322q-5 -6 -16.5 -14.5t-25 -16t-28 -12.5t-26.5 -5v35q16 0 32.5 8t30.5 18t23 19l10 10h36v-364h76zM796 108q0 -25 -12.5 -45.5t-34.5 -35.5t-50.5 -23t-60.5 -8q-34 0 -62.5 9t-49 24.5 t-32 36.5t-11.5 44q0 19 8 35.5t21.5 29t30.5 22t35 14.5q-32 11 -55.5 31.5t-23.5 51.5q0 24 12.5 42t32.5 31t45 19.5t51 6.5q25 0 50.5 -6.5t45 -19t32 -31t12.5 -41.5q0 -31 -23.5 -52t-56.5 -32q42 -12 69 -38.5t27 -64.5zM760 112q0 19 -11 34.5t-28.5 26.5t-39 16.5 t-42.5 5.5q-22 0 -43.5 -6t-38.5 -17t-27.5 -26.5t-10.5 -34.5t11 -34t28.5 -25.5t39 -16t42.5 -5.5q22 0 43.5 6t38.5 16.5t27.5 25.5t10.5 34zM535 292q0 -16 9.5 -28.5t24.5 -21t33.5 -13t36.5 -4.5t37 4.5t34 13.5t24.5 21.5t9.5 28.5q0 15 -9 27.5t-23.5 21.5 t-33.5 13.5t-39 4.5t-39 -4.5t-33.5 -13.5t-23 -21.5t-8.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeeighths",
    unicode: "\u215C",
    horizAdvX: 837,
    d: "M197 327q-63 0 -105 25t-48 67l23 21q1 -14 11.5 -28t27.5 -25t40.5 -17.5t50.5 -6.5q25 0 47 5.5t38 15.5t25.5 24t9.5 31q0 37 -40.5 58t-108.5 21h-23v32h23q64 0 99.5 17.5t35.5 52.5q0 18 -9 32t-24 24.5t-35.5 16t-43.5 5.5q-42 0 -72.5 -15.5t-44.5 -41.5l-25 26 q17 29 56 46.5t86 17.5q32 0 59.5 -8.5t47.5 -23t31.5 -34.5t11.5 -43q0 -69 -90 -87q47 -8 74.5 -35.5t27.5 -65.5q0 -24 -12.5 -44t-33.5 -34t-49.5 -21.5t-60.5 -7.5zM128 21l279 344l274 348l28 -23l-279 -345l-275 -348zM801 108q0 -25 -12.5 -45.5t-34.5 -35.5 t-50.5 -23t-60.5 -8q-34 0 -62.5 9t-49 24.5t-32 36.5t-11.5 44q0 19 8 35.5t21.5 29t30.5 22t35 14.5q-32 11 -55.5 31.5t-23.5 51.5q0 24 12.5 42t32.5 31t45 19.5t51 6.5q25 0 50.5 -6.5t45 -19t32 -31t12.5 -41.5q0 -31 -23.5 -52t-56.5 -32q42 -12 69 -38.5t27 -64.5z M765 112q0 19 -11 34.5t-28.5 26.5t-39 16.5t-42.5 5.5q-22 0 -43.5 -6t-38.5 -17t-27.5 -26.5t-10.5 -34.5t11 -34t28.5 -25.5t39 -16t42.5 -5.5q22 0 43.5 6t38.5 16.5t27.5 25.5t10.5 34zM540 292q0 -16 9.5 -28.5t24.5 -21t33.5 -13t36.5 -4.5t37 4.5t34 13.5t24.5 21.5 t9.5 28.5q0 15 -9 27.5t-23.5 21.5t-33.5 13.5t-39 4.5t-39 -4.5t-33.5 -13.5t-23 -21.5t-8.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveeighths",
    unicode: "\u215D",
    horizAdvX: 837,
    d: "M190 586q31 0 58 -9t47.5 -25.5t32 -39.5t11.5 -50q0 -29 -12.5 -53t-34 -41t-50 -26.5t-60.5 -9.5q-48 0 -86.5 20.5t-58.5 55.5l25 18q18 -28 50 -44.5t72 -16.5q25 0 47 7t38 20t25 31t9 39q0 23 -10.5 40.5t-27 29.5t-37.5 18.5t-42 6.5q-32 0 -60.5 -13t-45.5 -35 h-34q3 16 11 49t16.5 68.5t15.5 65t9 38.5h218v-35h-191l-35 -142q19 17 45 25t55 8zM120 21l279 344l274 348l28 -23l-279 -345l-275 -348zM802 108q0 -25 -12.5 -45.5t-34.5 -35.5t-50.5 -23t-60.5 -8q-34 0 -62.5 9t-49 24.5t-32 36.5t-11.5 44q0 19 8 35.5t21.5 29 t30.5 22t35 14.5q-32 11 -55.5 31.5t-23.5 51.5q0 24 12.5 42t32.5 31t45 19.5t51 6.5q25 0 50.5 -6.5t45 -19t32 -31t12.5 -41.5q0 -31 -23.5 -52t-56.5 -32q42 -12 69 -38.5t27 -64.5zM766 112q0 19 -11 34.5t-28.5 26.5t-39 16.5t-42.5 5.5q-22 0 -43.5 -6t-38.5 -17 t-27.5 -26.5t-10.5 -34.5t11 -34t28.5 -25.5t39 -16t42.5 -5.5q22 0 43.5 6t38.5 16.5t27.5 25.5t10.5 34zM541 292q0 -16 9.5 -28.5t24.5 -21t33.5 -13t36.5 -4.5t37 4.5t34 13.5t24.5 21.5t9.5 28.5q0 15 -9 27.5t-23.5 21.5t-33.5 13.5t-39 4.5t-39 -4.5t-33.5 -13.5 t-23 -21.5t-8.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveneighths",
    unicode: "\u215E",
    horizAdvX: 827,
    d: "M61 21l279 344l274 348l28 -23l-279 -345l-275 -348zM792 108q0 -25 -12.5 -45.5t-34.5 -35.5t-50.5 -23t-60.5 -8q-34 0 -62.5 9t-49 24.5t-32 36.5t-11.5 44q0 19 8 35.5t21.5 29t30.5 22t35 14.5q-32 11 -55.5 31.5t-23.5 51.5q0 24 12.5 42t32.5 31t45 19.5t51 6.5 q25 0 50.5 -6.5t45 -19t32 -31t12.5 -41.5q0 -31 -23.5 -52t-56.5 -32q42 -12 69 -38.5t27 -64.5zM756 112q0 19 -11 34.5t-28.5 26.5t-39 16.5t-42.5 5.5q-22 0 -43.5 -6t-38.5 -17t-27.5 -26.5t-10.5 -34.5t11 -34t28.5 -25.5t39 -16t42.5 -5.5q22 0 43.5 6t38.5 16.5 t27.5 25.5t10.5 34zM531 292q0 -16 9.5 -28.5t24.5 -21t33.5 -13t36.5 -4.5t37 4.5t34 13.5t24.5 21.5t9.5 28.5q0 15 -9 27.5t-23.5 21.5t-33.5 13.5t-39 4.5t-39 -4.5t-33.5 -13.5t-23 -21.5t-8.5 -28.5zM296 695h-252v35h309l-231 -393h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "partialdiff",
    unicode: "\u2202",
    horizAdvX: 569,
    d: "M249 -10q-48 0 -88 16t-69.5 43.5t-45.5 65t-16 80.5q0 48 19.5 91t53.5 76t79 52.5t95 19.5q67 0 117.5 -36.5t66.5 -103.5q4 24 6 59.5t2 62.5q0 71 -12.5 119.5t-35.5 78.5t-55.5 43t-72.5 13q-51 0 -95 -17.5t-67 -45.5l-29 30q33 39 85 58.5t110 19.5 q109 0 164.5 -74t55.5 -242q0 -101 -19.5 -177.5t-55 -128t-84.5 -77.5t-109 -26zM249 35q45 0 81.5 18t62 46.5t39 63.5t13.5 68t-13 62t-36 50.5t-53.5 34.5t-66.5 13q-39 0 -75 -15.5t-63 -42t-43.5 -61.5t-16.5 -74q0 -34 12.5 -63.5t35.5 -51.5t54 -35t69 -13z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Delta",
    unicode: "\u2206",
    horizAdvX: 611,
    d: "M606 41v-41h-601v41l280 669h42zM550 46l-244 602l-244 -602h488z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "product",
    unicode: "\u220F",
    horizAdvX: 661,
    d: "M500 664h-337v-754h-48v754h-86v46h600v-46h-80v-754h-49v754z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "summation",
    unicode: "\u2211",
    horizAdvX: 513,
    d: "M463 667h-360v-4l213 -294l-222 -316v-4h384v-49h-446v41l229 323l-224 309v37h426v-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    horizAdvX: 541,
    d: "M69 265v42h403v-42h-403z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2215",
    unicode: "\u2215",
    horizAdvX: 578,
    d: "M-8 23l562 690l32 -26l-562 -690z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2219",
    unicode: "\u2219",
    horizAdvX: 177,
    d: "M67 248v101h44v-101h-44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "radical",
    unicode: "\u221A",
    horizAdvX: 432,
    d: "M12 365h124l79 -316l124 741h48l-143 -790h-58l-92 326h-82v39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "infinity",
    unicode: "\u221E",
    horizAdvX: 695,
    d: "M202 517q29 0 51 -9t39.5 -25t30.5 -36.5t24 -43.5q12 23 25 43.5t30 36.5t39 25t52 9q35 0 63.5 -13t48.5 -35.5t30.5 -53t10.5 -64.5t-11.5 -64t-32.5 -52.5t-49 -35.5t-61 -13q-28 0 -49.5 9t-38.5 24.5t-30.5 35.5t-24.5 42q-11 -22 -23.5 -42t-30 -35.5t-40.5 -24.5 t-53 -9q-31 0 -59 13t-49.5 35.5t-34 53t-12.5 64.5t12 64t32.5 52.5t49 35.5t61.5 13zM202 228q24 0 43 10t34.5 26.5t27.5 38.5t23 47q-11 25 -23 48t-27 39.5t-34 26.5t-44 10q-20 0 -40 -7.5t-36 -22.5t-26 -38t-10 -54t10 -54.5t26 -39t36 -23t40 -7.5zM493 228 q20 0 40 7.5t35.5 23t25.5 39t10 54.5t-10 54t-25.5 38t-35.5 22.5t-40 7.5q-26 0 -45 -10.5t-33.5 -28t-26 -40.5t-21.5 -49q10 -24 22 -45.5t27 -37.5t34 -25.5t43 -9.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "integral",
    unicode: "\u222B",
    horizAdvX: 285,
    d: "M98 710q-3 48 21 79t68 31q20 0 45 -6t45 -15l-14 -36q-14 6 -32.5 11t-29.5 5q-27 0 -43 -21t-14 -59l42 -756q3 -53 -21 -81.5t-68 -28.5q-20 0 -44 6t-44 15l13 36q14 -6 31.5 -11t30.5 -5q27 0 43 20.5t14 61.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    horizAdvX: 429,
    d: "M363 314q-13 -12 -31 -20.5t-43 -8.5t-45 6.5t-38 14.5t-34.5 14.5t-33.5 6.5t-28 -6t-19 -14l-25 28q11 13 28.5 22t42.5 9q22 0 41 -6.5t36 -14t35 -14t39 -6.5q35 0 51 15zM363 215q-13 -11 -31 -19t-43 -8t-45 6.5t-38 14.5t-34.5 14.5t-33.5 6.5t-28 -6t-19 -14 l-25 28q11 13 28.5 22.5t42.5 9.5q22 0 41 -6.5t36 -14.5t35 -14.5t39 -6.5q35 0 51 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    horizAdvX: 455,
    d: "M78 344h169l65 111l31 -10l-59 -101h92v-38h-115l-35 -60h150v-38h-173l-65 -111l-31 9l60 102h-89v38h111l35 60h-146v38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    horizAdvX: 450,
    d: "M68 70v43h314v-43h-314zM67 376l308 155v-49l-235 -120l235 -120v-51l-308 155v30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    horizAdvX: 450,
    d: "M68 70v43h314v-43h-314zM383 346l-308 -155v51l235 120l-235 120v49l308 -155v-30z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lozenge",
    unicode: "\u25CA",
    horizAdvX: 491,
    d: "M273 730l186 -364l-186 -366h-55l-186 366l186 364h55zM408 354l-166 335l-156 -314l165 -332z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccent",
    unicode: "\uF6C3",
    horizAdvX: 141,
    d: "M57 -187l15 68h-16v70h49v-70l-21 -68h-27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s_t",
    unicode: "\uFB06",
    horizAdvX: 795,
    d: "M785 25q-4 -2 -14 -7.5t-24.5 -10.5t-32 -9t-35.5 -4q-45 0 -75 24t-30 69v392h-73v41h73q0 62 -3.5 100.5t-14 60.5t-29.5 29.5t-51 7.5q-34 0 -56.5 -8t-36.5 -21.5t-20 -32.5t-6 -41q0 -30 8.5 -58t19 -49.5t19 -35t9.5 -15.5l-27 -28q-29 36 -68 48t-77 12 q-27 0 -53 -5t-46.5 -17.5t-33 -32.5t-12.5 -50q0 -34 15.5 -53.5t38.5 -30.5t49 -15t48 -6q33 -3 68 -9.5t64.5 -21t48.5 -40t19 -67.5q0 -41 -18 -70t-46.5 -47t-64 -26t-71.5 -8q-64 0 -118 23t-90 55l25 34q84 -72 184 -72q26 0 53 5.5t49 18.5t36 33t14 50 q0 34 -17 53.5t-42 29.5t-53.5 13.5t-51.5 5.5q-36 3 -70 10t-60 22t-41.5 40.5t-15.5 65.5q0 42 17 71t44 47t61 26t68 8q35 0 67 -7.5t56 -23.5q-7 15 -13 28t-11 26.5t-8 28t-3 33.5q0 27 8 51.5t26 43t48 29.5t74 11q51 0 79 -14.5t42 -43t17 -71.5t3 -100h121v-41h-121 v-380q0 -29 20 -43.5t47 -14.5q28 0 51 10.5t28 13.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "NULL",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.denominator",
    horizAdvX: 377,
    d: "M255 0v106h-230v32l240 255h25v-253h57v-34h-57v-106h-35zM65 140h190v202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 264,
    d: "M243 367v-35h-194v35h82v322q-5 -6 -16.5 -14.5t-25 -16t-28 -12.5t-26.5 -5v35q16 0 32.5 8t30.5 18t23 19l10 10h36v-364h76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.denominator",
    horizAdvX: 383,
    d: "M37 0q0 76 32 116.5t94 63.5q22 9 46.5 17t44 19t32.5 27.5t13 40.5q0 32 -25.5 54.5t-79.5 22.5q-26 0 -46 -6t-35.5 -14.5t-26.5 -18.5t-18 -19l-26 28q3 4 14 15t30.5 22.5t47.5 20.5t65 9q71 0 105.5 -33.5t34.5 -81.5q0 -31 -14 -52t-35.5 -35.5t-46 -24 t-45.5 -15.5q-36 -11 -57.5 -24.5t-33 -29.5t-14.5 -33t-3 -35h250v-34h-303z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 386,
    d: "M190 327q-63 0 -105 25t-48 67l23 21q1 -14 11.5 -28t27.5 -25t40.5 -17.5t50.5 -6.5q25 0 47 5.5t38 15.5t25.5 24t9.5 31q0 37 -40.5 58t-108.5 21h-23v32h23q64 0 99.5 17.5t35.5 52.5q0 18 -9 32t-24 24.5t-35.5 16t-43.5 5.5q-42 0 -72.5 -15.5t-44.5 -41.5l-25 26 q17 29 56 46.5t86 17.5q32 0 59.5 -8.5t47.5 -23t31.5 -34.5t11.5 -43q0 -69 -90 -87q47 -8 74.5 -35.5t27.5 -65.5q0 -24 -12.5 -44t-33.5 -34t-49.5 -21.5t-60.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron.alt",
    horizAdvX: 213,
    d: "M84 629l-35 16l61 85h58z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotbelow",
    horizAdvX: 146,
    d: "M50 -151v90h46v-90h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.denominator",
    horizAdvX: 387,
    d: "M190 -5q-63 0 -105 25t-48 67l23 20q1 -14 11.5 -28t27.5 -25t40.5 -17.5t50.5 -6.5q25 0 47 5.5t38 15.5t25.5 24t9.5 31q0 37 -40.5 58t-108.5 21h-23v32h23q64 0 99.5 18t35.5 53t-32.5 56.5t-79.5 21.5q-42 0 -72.5 -16t-44.5 -42l-25 26q17 29 56 46.5t86 17.5 q32 0 59.5 -8.5t47.5 -23t31.5 -34t11.5 -42.5q0 -68 -90 -88q47 -7 74.5 -35t27.5 -66q0 -24 -12.5 -44t-33.5 -33.5t-49.5 -21t-60.5 -7.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 381,
    d: "M37 333q0 38 8 66.5t24 49.5t39.5 36t53.5 27q23 9 47.5 17t44.5 19.5t33 28t13 40.5q0 32 -26 56t-80 24q-26 0 -46.5 -6t-36.5 -14.5t-27 -18.5t-18 -18l-24 24q3 4 14 15t30.5 22.5t47.5 20.5t65 9q35 0 61.5 -9t44 -25t26 -36.5t8.5 -44.5q0 -30 -14.5 -51 t-35.5 -35.5t-45.5 -23.5t-45.5 -15q-36 -11 -58.5 -26.5t-35 -32.5t-17 -34t-4.5 -31h254v-34h-300z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.denominator",
    horizAdvX: 392,
    d: "M352 108q0 -25 -12.5 -45.5t-34.5 -35.5t-50.5 -23t-60.5 -8q-34 0 -62.5 9t-49 24.5t-32 36.5t-11.5 44q0 19 8 35.5t21.5 29t30.5 22t35 14.5q-32 11 -55.5 31.5t-23.5 51.5q0 24 12.5 42t32.5 31t45 19.5t51 6.5q25 0 50.5 -6.5t45 -19t32 -31t12.5 -41.5 q0 -31 -23.5 -52t-56.5 -32q42 -12 69 -38.5t27 -64.5zM316 112q0 19 -11 34.5t-28.5 26.5t-39 16.5t-42.5 5.5q-22 0 -43.5 -6t-38.5 -17t-27.5 -26.5t-10.5 -34.5t11 -34t28.5 -25.5t39 -16t42.5 -5.5q22 0 43.5 6t38.5 16.5t27.5 25.5t10.5 34zM91 292q0 -16 9.5 -28.5 t24.5 -21t33.5 -13t36.5 -4.5t37 4.5t34 13.5t24.5 21.5t9.5 28.5q0 15 -9 27.5t-23.5 21.5t-33.5 13.5t-39 4.5t-39 -4.5t-33.5 -13.5t-23 -21.5t-8.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 369,
    d: "M186 586q31 0 58 -9t47.5 -25.5t32 -39.5t11.5 -50q0 -29 -12.5 -53t-34 -41t-50 -26.5t-60.5 -9.5q-48 0 -86.5 20.5t-58.5 55.5l25 18q18 -28 50 -44.5t72 -16.5q25 0 47 7t38 20t25 31t9 39q0 23 -10.5 40.5t-27 29.5t-37.5 18.5t-42 6.5q-32 0 -60.5 -13t-45.5 -35 h-34q3 16 11 49t16.5 68.5t15.5 65t9 38.5h218v-35h-191l-35 -142q19 17 45 25t55 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 346,
    d: "M279 695h-252v35h309l-231 -393h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R.sc",
    horizAdvX: 564,
    d: "M88 0v545h248q37 0 69 -15t55 -39t36 -55t13 -62q0 -30 -10 -57t-28 -49t-43.5 -37t-55.5 -20l146 -211h-54l-141 203h-189v-203h-46zM134 245h204q28 0 51 11t39 29t25 41t9 48t-10 48.5t-27.5 41t-41 28t-50.5 10.5h-199v-257z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.lnum",
    horizAdvX: 589,
    d: "M537 194q0 -46 -20 -83t-53.5 -63.5t-78.5 -40.5t-94 -14q-53 0 -97.5 16.5t-76 44t-49 64.5t-17.5 79q0 35 13 65t34.5 53.5t48.5 40t55 25.5q-26 9 -48.5 24t-40 34t-27.5 43t-10 51q0 43 19.5 76t50.5 55.5t70.5 34t78.5 11.5t78 -11.5t70 -34t50.5 -55t19.5 -75.5 q0 -28 -10.5 -51.5t-27.5 -43t-40.5 -34.5t-48.5 -24q31 -11 59 -28.5t48 -41.5t32 -53.5t12 -63.5zM487 198q0 38 -17.5 68t-45.5 50.5t-62.5 31.5t-68.5 11q-35 0 -69 -11.5t-61 -32.5t-44 -51t-17 -67q0 -38 17.5 -67.5t45.5 -50t62.5 -31.5t68.5 -11t68.5 11.5 t61.5 32.5t44 50.5t17 66.5zM127 531q0 -32 15.5 -56t39.5 -41t53.5 -25.5t58.5 -8.5t59 9t54 26t39.5 41.5t15.5 56.5q0 31 -14.5 55.5t-38 41t-54 25.5t-62.5 9t-62 -9t-53 -26.5t-37 -42t-14 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 392,
    d: "M352 445q0 -26 -12.5 -46.5t-34.5 -35.5t-50.5 -23t-60.5 -8q-34 0 -62.5 9t-49 25t-32 37t-11.5 44q0 19 8 35.5t21.5 29t30.5 21.5t35 15q-32 11 -55.5 31.5t-23.5 51.5q0 23 12.5 41.5t32.5 31t45 19.5t51 7q25 0 50.5 -6.5t45 -19t32 -31t12.5 -41.5q0 -31 -23.5 -52 t-56.5 -32q42 -12 69 -38.5t27 -64.5zM316 449q0 19 -11 34.5t-28.5 26.5t-39 16.5t-42.5 5.5q-22 0 -43.5 -6t-38.5 -17t-27.5 -26.5t-10.5 -34.5t11 -34t28.5 -25.5t39 -16t42.5 -5.5q22 0 43.5 6t38.5 16.5t27.5 25.5t10.5 34zM91 629q0 -16 9.5 -28.5t24.5 -21t33.5 -13 t36.5 -4.5t37 4.5t34 13t24.5 21t9.5 28.5t-9 28.5t-23.5 21.5t-33.5 13.5t-39 4.5t-39 -4.5t-33.5 -13.5t-23 -21.5t-8.5 -28.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S.sc",
    horizAdvX: 524,
    d: "M431 448q-59 59 -161 59q-85 0 -123 -28.5t-38 -78.5q0 -25 10 -41.5t31 -28.5t53 -20.5t76 -17.5q47 -9 85 -20t64.5 -28t41 -41.5t14.5 -61.5t-15 -64.5t-43 -45.5t-66.5 -27t-85.5 -9q-136 0 -234 80l25 38q37 -35 90 -56t120 -21q73 0 116.5 24.5t43.5 75.5 q0 26 -11.5 44t-34 31.5t-57 23t-80.5 18.5q-47 9 -82.5 20t-59.5 27t-36.5 39t-12.5 57q0 37 15.5 65.5t43 47.5t66 29t84.5 10q112 0 183 -63z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I.sc",
    horizAdvX: 222,
    d: "M88 0v544h46v-544h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w.alt",
    horizAdvX: 817,
    d: "M556 0l-147 446l-149 -446h-51l-184 520h53l158 -456l148 456h49l148 -456l159 456h52l-184 -520h-52z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y.alt",
    horizAdvX: 540,
    d: "M518 520l-302 -733h-54q0 1 5 13.5t13 32t17.5 43.5t19.5 47.5t18.5 44t13.5 32.5l-233 520h53l206 -471l194 471h49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E.sc",
    horizAdvX: 531,
    d: "M484 42v-42h-396v545h388v-43h-342v-204h299v-40h-299v-216h350z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.denominator",
    horizAdvX: 450,
    d: "M226 -5q-47 0 -82 19t-58 48t-35 64t-12 68q0 36 13 71.5t37.5 64t59 46t77.5 17.5q46 0 80.5 -19t57.5 -48.5t35 -64.5t12 -67q0 -36 -13 -71.5t-37 -64t-58 -46t-77 -17.5zM76 194q0 -29 10 -58t29 -52.5t47 -38.5t64 -15q37 0 65 16t47 40t28 53t9 55q0 29 -10 58 t-29 52.5t-47 38.5t-63 15q-38 0 -66 -16t-47 -40t-28 -53t-9 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.lnum",
    horizAdvX: 678,
    d: "M339 -10q-72 2 -126 36t-90 86t-54.5 115t-18.5 123q0 64 20 128.5t57.5 116t91 83.5t120.5 32q72 0 126 -34.5t90 -87.5t54.5 -116.5t18.5 -121.5q0 -65 -20 -129t-57.5 -115t-91 -83t-120.5 -33zM101 350q2 -55 18 -110.5t45.5 -100.5t73.5 -73.5t101 -28.5 q60 0 104.5 30t74 76.5t44.5 101.5t15 105q0 55 -16 110.5t-47 100.5t-75 73.5t-100 28.5q-60 0 -104.5 -30.5t-74.5 -76.5t-44.5 -101.5t-14.5 -104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 450,
    d: "M226 332q-47 0 -82 18.5t-58 47.5t-35 64.5t-12 68.5q0 35 13 70.5t37.5 64t59 46.5t77.5 18q46 0 80.5 -19t57.5 -48.5t35 -64.5t12 -67q0 -36 -13 -72t-37 -64t-58 -45.5t-77 -17.5zM76 531q0 -29 10 -58t29 -52.5t47 -38.5t64 -15q37 0 65 16t47 40t28 53t9 55 q0 29 -10 58t-29 52.5t-47 38.5t-63 15q-38 0 -66 -16t-47 -40t-28 -53t-9 -55z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T.sc",
    horizAdvX: 525,
    d: "M501 502h-215v-502h-46v502h-216v43h477v-43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.denominator",
    horizAdvX: 369,
    d: "M186 249q31 0 58 -9t47.5 -25.5t32 -39.5t11.5 -51q0 -29 -12.5 -52.5t-34 -40.5t-50 -26.5t-60.5 -9.5q-48 0 -86.5 20.5t-58.5 54.5l25 19q18 -28 50 -44.5t72 -16.5q25 0 47 7t38 20t25 31t9 39q0 23 -10.5 40.5t-27 29.5t-37.5 18.5t-42 6.5q-32 0 -60.5 -13 t-45.5 -35h-34q3 16 11 49t16.5 68.5t15.5 65t9 38.5h218v-35h-191l-35 -142q19 17 45 25t55 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.lnum",
    horizAdvX: 554,
    d: "M280 449q48 0 90 -16.5t73.5 -46.5t49.5 -71.5t18 -90.5q0 -53 -19.5 -96t-52.5 -73.5t-77 -47.5t-93 -17q-76 0 -136 38.5t-91 101.5l37 21q27 -52 78 -83.5t112 -31.5q40 0 75 13.5t60.5 38.5t40.5 59.5t15 75.5q0 40 -14.5 73t-39.5 57t-58.5 37.5t-72.5 13.5 q-51 0 -95.5 -22.5t-73.5 -64.5h-49q1 7 5.5 28t10 50t12.5 63.5t14 69.5q17 82 37 182h340v-47h-302l-55 -281q29 32 71 49.5t90 17.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U.sc",
    horizAdvX: 650,
    d: "M324 39q59 0 97.5 20t61.5 53t32.5 74.5t9.5 84.5v274h46v-274q0 -55 -13 -105t-42 -87.5t-76 -60t-115 -22.5q-70 0 -117 23.5t-75.5 62t-41 88t-12.5 101.5v274h46v-274q0 -44 9.5 -86t32.5 -74.5t61.5 -52t95.5 -19.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.lnum",
    horizAdvX: 562,
    d: "M388 0v198h-363v44l378 468h35v-466h88v-46h-88v-198h-50zM82 244h310v386z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B.sc",
    horizAdvX: 575,
    d: "M525 141q0 -30 -12.5 -56t-34.5 -45t-51 -29.5t-62 -10.5h-277v545h278q31 0 56 -12t42 -32t26.5 -45t9.5 -50q0 -42 -22.5 -76t-61.5 -50q51 -14 80 -52t29 -87zM478 148q0 21 -8 40.5t-22.5 34t-34 23.5t-42.5 9h-237v-214h231q24 0 44.5 9t35.5 24t24 34t9 40z M134 503v-208h214q23 0 42.5 8.5t33.5 23t22 33.5t8 39q0 43 -28 73.5t-73 30.5h-219z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 377,
    d: "M255 337v105h-230v33l240 255h25v-253h57v-35h-57v-105h-35zM65 477h190v202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V.sc",
    horizAdvX: 585,
    d: "M71 545l222 -481l221 481h50l-250 -545h-42l-250 545h49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.alt",
    horizAdvX: 1049,
    d: "M1025 710l-227 -710h-54l-223 627l-216 -627h-54l-227 710h56l202 -637l210 637h56l219 -637l201 637h57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J.sc",
    horizAdvX: 421,
    d: "M38 63q20 -12 49 -20.5t65 -8.5q48 0 76 15.5t42.5 45.5t19 73.5t4.5 99.5v276h46v-276q0 -62 -6 -113t-25.5 -87t-56.5 -56t-100 -20q-77 0 -129 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W.sc",
    horizAdvX: 892,
    d: "M314 541h44l87 -196l88 196h45l-105 -232l121 -252l225 488h51l-253 -545h-42l-129 274l-129 -274h-43l-252 545h51l226 -488l118 252z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j.alt",
    horizAdvX: 207,
    d: "M78 517h50v-730h-50v730zM78 719h50v-81h-50v81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K.sc",
    horizAdvX: 554,
    d: "M88 0v544h46v-323l340 324h54l-245 -239l257 -306h-52l-234 277l-120 -109v-168h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X.sc",
    horizAdvX: 546,
    d: "M69 545l204 -242l204 242h53l-231 -276l224 -269h-52l-198 234l-197 -234h-53l224 269l-231 276h53z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C.sc",
    horizAdvX: 596,
    d: "M47 277q0 49 18.5 97.5t54.5 87t88 62.5t119 24q79 0 135 -33.5t84 -85.5l-39 -23q-15 28 -36 47t-45 30.5t-50.5 16.5t-51.5 5q-56 0 -98.5 -20.5t-72 -53.5t-44.5 -74.5t-15 -83.5q0 -47 18 -89.5t49 -74.5t73.5 -51.5t91.5 -19.5q26 0 54 6t53.5 18.5t47.5 32.5t37 47 l40 -20q-15 -31 -41 -54.5t-57.5 -39.5t-67 -24.5t-69.5 -8.5q-61 0 -111.5 24.5t-87 64.5t-57 90.5t-20.5 102.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y.sc",
    horizAdvX: 558,
    d: "M75 545l204 -298l204 298h52l-233 -341v-204h-47v205l-231 340h51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l.alt",
    horizAdvX: 220,
    d: "M85 730h50v-730h-50v730z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L.sc",
    horizAdvX: 498,
    d: "M88 0v545h46v-503h343v-42h-389z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z.sc",
    horizAdvX: 548,
    d: "M37 38l416 464h-410v43h466v-38l-413 -465h411v-42h-470v38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.denominator",
    horizAdvX: 399,
    d: "M34 261q0 28 12.5 52.5t34 43t51 29t62.5 10.5q36 0 65.5 -11.5t51.5 -32.5t34 -51.5t12 -68.5q0 -121 -46 -179t-121 -58q-45 0 -81 19t-53 54l24 22q13 -29 43 -45.5t68 -16.5q59 0 95 45t37 126q-15 -32 -51.5 -51.5t-80.5 -19.5q-33 0 -61.5 10.5t-50 28.5t-33.5 42 t-12 52zM193 364q-26 0 -48.5 -8t-39 -22t-26.5 -32.5t-10 -39.5t10 -39.5t27 -33t39.5 -22.5t48.5 -8t48.5 8t39.5 22t27 32.5t10 39.5t-10 39.5t-27 32.5t-40 22.5t-49 8.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.lnum",
    horizAdvX: 600,
    d: "M43 472q0 51 19.5 95t53 77t79 52t98.5 19q55 0 101 -20t80 -57t53 -91t19 -121q0 -111 -19 -193t-53 -136t-81.5 -80.5t-104.5 -26.5q-72 0 -127.5 37t-82.5 101l35 27q20 -54 68 -86.5t107 -32.5q47 0 85.5 22.5t66 66t42.5 106t15 143.5q-11 -32 -32 -58.5 t-48.5 -45.5t-60.5 -29.5t-69 -10.5q-51 0 -95.5 19t-77.5 52t-52 77t-19 94zM291 671q-41 0 -77 -16t-63 -43t-43 -63t-16 -76q0 -41 16 -77.5t43.5 -63.5t63.5 -43t77 -16t77.5 16t64 43t43.5 63t16 77q0 40 -16 76.5t-43.5 63.5t-64.5 43t-78 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt",
    horizAdvX: 615,
    d: "M289 -10q-55 0 -100.5 22.5t-78 59.5t-50.5 85.5t-18 101.5q0 55 19 104t52 86t77.5 58.5t95.5 21.5q68 0 119.5 -34.5t81.5 -88.5v111h50v-517h-50v110q-30 -54 -81.5 -87t-116.5 -33zM487 342q-12 30 -31 56t-43.5 45t-54 30t-61.5 11q-46 0 -83.5 -20t-64.5 -52 t-41.5 -72.5t-14.5 -81.5q0 -44 15.5 -84.5t42.5 -71.5t64.5 -49t82.5 -18q34 0 63.5 11t53.5 29.5t42 44t30 54.5v168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 398,
    d: "M34 595q0 28 12.5 52.5t34 43t50.5 29t63 10.5q35 0 65 -11.5t51.5 -32.5t33.5 -51.5t12 -68.5q0 -121 -45.5 -179.5t-120.5 -58.5q-45 0 -81 19.5t-53 54.5l23 21q14 -28 44 -45t68 -17q59 0 95 45t36 127q-14 -32 -51 -52t-81 -20q-33 0 -61.5 10.5t-49.5 28.5 t-33 42.5t-12 52.5zM193 697q-26 0 -48.5 -8t-39.5 -22t-27 -32t-10 -39t10 -39.5t27.5 -33t40 -22.5t48.5 -8q25 0 48 8t40 22t27 32.5t10 39.5t-10 39.5t-27.5 32.5t-40.5 22t-48 8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a.alt2",
    horizAdvX: 536,
    d: "M415 0v84q-37 -49 -93 -71.5t-115 -22.5q-36 0 -67.5 12.5t-54.5 34t-36 51t-13 63.5q0 42 20 71t51.5 47.5t69.5 27t75 8.5q58 0 100 -10t62 -18v51q0 72 -42 116.5t-114 44.5q-39 0 -81.5 -16t-85.5 -46l-20 34q43 29 91 48.5t100 19.5q49 0 87 -15.5t63.5 -42.5 t38.5 -64.5t13 -82.5v-324h-49zM397 110q17 22 17 40v92q-38 14 -78 21t-78 7q-29 0 -60 -6t-56.5 -19.5t-41.5 -36t-16 -54.5q0 -28 11 -50.5t29.5 -39t42.5 -25.5t50 -9q25 0 51 5t50 14.5t44.5 24.5t34.5 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M.sc",
    horizAdvX: 756,
    d: "M621 0v459l-229 -357h-28l-230 357v-459h-46v545h47l243 -381l243 381h47v-545h-47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N.sc",
    horizAdvX: 667,
    d: "M134 457v-457h-46v545h36l409 -465v464h46v-544h-42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.denominator",
    horizAdvX: 274,
    d: "M253 34v-34h-204v34h87v323q-6 -7 -17.5 -15t-26 -15.5t-29.5 -12.5t-28 -5v35q16 0 34 8t32.5 18t24 19t10.5 10h35v-365h82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.lnum",
    horizAdvX: 394,
    d: "M375 46v-46h-311v46h134v614q-8 -12 -26 -26.5t-40.5 -28t-46.5 -22.5t-44 -9v47q26 0 53.5 14.5t50.5 32.5t37.5 33.5t15.5 17.5h50v-673h127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F.sc",
    horizAdvX: 515,
    d: "M88 0v545h386v-43h-340v-206h289v-41h-289v-255h-46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O.sc",
    horizAdvX: 648,
    d: "M324 -4q-62 0 -113 23.5t-87.5 62t-56.5 88.5t-20 103q0 54 21 103.5t58.5 88t88 61t110.5 22.5q62 0 113 -24t87 -63t56 -88.5t20 -100.5q0 -55 -21 -105t-58 -88t-88 -60.5t-110 -22.5zM94 272q0 -45 17 -87.5t47.5 -74.5t73 -51.5t93.5 -19.5q52 0 94.5 20.5 t72.5 53.5t46 75t16 85q0 45 -17 87t-48 74.5t-73 51.5t-92 19q-52 0 -94.5 -20t-72.5 -53t-46.5 -75t-16.5 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q.alt",
    d: "M280 -10q-54 0 -97.5 22.5t-75 60t-48.5 86t-17 100.5q0 54 19.5 103t53 86t79 59t97.5 22q61 0 114 -32.5t83 -81.5v105h46v-733h-50v325q-82 -122 -204 -122zM293 35q33 0 61.5 11t52.5 29t43.5 42.5t33.5 51.5v170q-4 29 -22 55t-44.5 46t-57.5 32t-61 12 q-45 0 -83 -19.5t-65.5 -51t-42.5 -72.5t-15 -83q0 -45 15 -85t41.5 -71t63 -49t80.5 -18z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.alt",
    horizAdvX: 733,
    d: "M379 -5q-73 0 -134.5 30.5t-106 81t-69.5 116t-25 134.5q0 70 25 135t70 114.5t106.5 79t133.5 29.5q89 0 158.5 -43t111.5 -112l-39 -33q-17 28 -41 54t-53.5 45t-64.5 30.5t-75 11.5q-63 0 -115 -27t-88.5 -71.5t-56.5 -101t-20 -115.5t20.5 -115t57.5 -99.5t88.5 -70 t114.5 -26.5q55 0 102 21t83 56.5t58.5 81t30.5 94.5h-222v46h277q0 -4 -0.5 -15.5t-0.5 -17.5q-7 -62 -34 -118.5t-69.5 -100t-99.5 -69t-123 -25.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c_t",
    horizAdvX: 860,
    d: "M850 25q-3 -2 -13 -7t-24 -10.5t-32.5 -9.5t-39.5 -4q-20 0 -38.5 6t-32.5 18t-22.5 29t-8.5 40v392h-73v41h73q0 58 -2.5 96.5t-13 61t-33.5 31.5t-64 9q-27 0 -46.5 -8.5t-32 -23.5t-19 -34.5t-6.5 -41.5q0 -26 10.5 -56t24.5 -58.5t27.5 -51.5t19.5 -36l-49 -16 q-26 48 -68.5 70t-95.5 22q-47 0 -84 -20t-62.5 -52t-39 -72t-13.5 -81q0 -45 16 -85.5t44 -71.5t65.5 -49t80.5 -18q22 0 48 6.5t49.5 19t41.5 30.5t24 40l49 -14q-11 -31 -33.5 -54.5t-51.5 -39.5t-62 -24.5t-65 -8.5q-57 0 -104 23t-81 61t-52.5 86t-18.5 99q0 52 18 101 t50.5 86.5t78.5 60t103 22.5q50 0 85 -12t63 -33q-16 26 -32 58t-16 70q0 58 37 97.5t107 39.5q58 0 89 -16.5t45 -47t16.5 -72.5t2.5 -93h121v-41h-121v-380q2 -29 21 -43.5t44 -14.5q16 0 29.5 3.5t24.5 7.5t18 8t9 5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G.sc",
    horizAdvX: 618,
    d: "M519 81q-84 -85 -196 -85q-60 0 -110.5 24t-87.5 63t-57.5 89t-20.5 102q0 54 20.5 103.5t56.5 87.5t86 60.5t109 22.5q88 0 142.5 -33t82.5 -85l-38 -24q-29 52 -78 76t-111 24q-51 0 -92.5 -20t-70.5 -53t-44.5 -75t-15.5 -86q0 -47 18 -89t49.5 -74t74 -51t91.5 -19 q52 0 99.5 22t92.5 70v98h-133v37h174v-266h-41v81z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.denominator",
    horizAdvX: 345,
    d: "M280 358h-253v35h309l-231 -393h-41z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.lnum",
    horizAdvX: 510,
    d: "M430 663h-400v47h480l-362 -710h-56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.denominator",
    horizAdvX: 398,
    d: "M364 130q0 -28 -12.5 -52.5t-34 -43t-50.5 -29t-63 -10.5q-35 0 -65 11.5t-51.5 32.5t-33.5 51.5t-12 68.5q0 120 46 178.5t121 58.5q45 0 80.5 -19t52.5 -54l-23 -22q-13 28 -43 45t-68 17q-60 0 -95.5 -44.5t-36.5 -127.5q7 16 20.5 29.5t31 23t38 14.5t41.5 5 q33 0 62 -10.5t50 -28.5t33 -42t12 -52zM205 27q26 0 48.5 8t39.5 22t27 32.5t10 39.5t-10 39.5t-27 33t-40 22.5t-49 8t-48.5 -8t-39.5 -22t-27 -32.5t-10 -39.5t10 -39.5t27.5 -33t40 -22.5t48.5 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.lnum",
    horizAdvX: 600,
    d: "M556 233q0 -51 -19 -95t-53 -77t-79.5 -52t-97.5 -19q-55 0 -101.5 20t-80 57t-52.5 90.5t-19 121.5q0 112 19 194t53 136t81.5 80t104.5 26q72 0 127.5 -37t82.5 -101l-35 -27q-20 54 -68 87t-107 33q-47 0 -85.5 -22.5t-65.5 -66t-42.5 -106.5t-15.5 -144 q11 32 32 58.5t48.5 45.5t60.5 29.5t69 10.5q51 0 95 -19t77 -52t52 -77t19 -94zM308 35q41 0 77.5 15.5t63.5 42.5t43 63t16 77t-16 77t-43 63t-63.5 43t-77.5 16t-77.5 -16t-63.5 -43t-43 -63t-16 -77t16 -77t43 -63t63.5 -42.5t77.5 -15.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 398,
    d: "M364 464q0 -29 -12.5 -53.5t-34 -43t-51 -29t-62.5 -10.5q-36 0 -65.5 11.5t-51.5 32.5t-34 51.5t-12 69.5q0 120 46.5 178.5t120.5 58.5q45 0 80.5 -19t52.5 -54l-22 -22q-14 28 -44 45t-68 17q-59 0 -95 -45t-37 -127q15 32 52 51.5t80 19.5q33 0 61.5 -10t50 -28 t33.5 -42t12 -52zM205 361q26 0 48.5 8t39.5 22t27 32.5t10 39.5t-10 39.5t-27 33t-40 22.5t-49 8t-49 -8t-40 -22t-27 -32.5t-10 -39.5t10 -39.5t27.5 -33t40.5 -22.5t49 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D.sc",
    horizAdvX: 618,
    d: "M88 0v545h198q70 0 123 -21.5t88.5 -58t53 -86t17.5 -105.5q0 -62 -20 -112.5t-56.5 -86.5t-89 -55.5t-116.5 -19.5h-198zM521 274q0 50 -15.5 92t-45.5 72t-73.5 47t-100.5 17h-152v-460h152q58 0 102 17.5t73.5 49t44.5 73.5t15 92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t.alt",
    horizAdvX: 299,
    d: "M103 0v474h-75v46h75v179h51v-179h124v-46h-124v-474h-51z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.lnum",
    horizAdvX: 584,
    d: "M289 -9q-49 0 -91 12.5t-73.5 35.5t-51 55t-23.5 70l34 23q2 -29 18 -56t43 -47.5t63.5 -33t80.5 -12.5q41 0 76 11t60.5 31t40 47t14.5 60q0 35 -16.5 63.5t-47 48t-74 30t-96.5 10.5h-35v45h35q103 0 159 34.5t56 101.5q0 34 -14 62t-38.5 48.5t-57.5 31.5t-71 11 q-67 0 -116 -29.5t-69 -76.5l-37 32q13 28 35.5 50t52 37.5t63.5 24t71 8.5q50 0 93 -15t74 -41.5t48.5 -62.5t17.5 -78q0 -62 -36 -102t-105 -57q36 -7 65.5 -23.5t50.5 -40.5t32.5 -54t11.5 -63q0 -43 -19.5 -78t-52.5 -60t-77 -39t-94 -14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d.alt",
    d: "M484 0v101q-31 -50 -82.5 -80.5t-109.5 -30.5q-54 0 -100 22.5t-79.5 60t-52 86t-18.5 100.5q0 54 18 103t50 86t75.5 59t95.5 22q34 0 63.5 -10t55 -26.5t46.5 -38.5t38 -47v323h50v-730h-50zM484 346q-10 29 -30.5 54t-47 44t-56.5 29.5t-58 10.5q-45 0 -82 -19.5 t-63 -51t-40 -72.5t-14 -83q0 -45 16 -85t44.5 -71t66 -49t81.5 -18q27 0 58.5 11t58.5 30.5t45.5 44.5t20.5 54v171z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.lnum",
    horizAdvX: 574,
    d: "M49 0v19q0 64 14 112t39.5 84t62 62t80.5 46q35 16 73.5 31t70.5 35.5t53 50.5t21 77q0 30 -10 58t-30.5 49.5t-52 34.5t-74.5 13q-42 0 -75 -11.5t-58.5 -28t-43 -35t-28.5 -33.5l-34 31q3 5 20 25t47.5 42t74.5 39.5t102 17.5q54 0 95 -17t68 -45t40.5 -64.5 t13.5 -75.5q0 -53 -22 -90t-56 -63t-73.5 -43.5t-75.5 -30.5q-60 -23 -96 -52t-55 -61.5t-25 -66t-6 -64.5h410v-46h-470z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A.sc",
    horizAdvX: 584,
    d: "M21 0l251 545h39l250 -545h-50l-80 175h-278l-81 -175h-51zM292 486l-127 -270h252z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P.sc",
    horizAdvX: 540,
    d: "M88 0v545h244q38 0 69.5 -15t54.5 -39t36 -55t13 -62q0 -33 -12 -63.5t-34 -54.5t-53 -38.5t-68 -14.5h-204v-203h-46zM134 245h201q28 0 51 10.5t39 28.5t24.5 41.5t8.5 48.5q0 26 -10 49t-27.5 40.5t-40.5 28t-50 10.5h-196v-257z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u.alt",
    horizAdvX: 584,
    d: "M457 0v121q-15 -30 -38 -54t-51 -41.5t-59.5 -26.5t-64.5 -9q-53 0 -86.5 19.5t-52 51.5t-25.5 73.5t-7 85.5v300h50v-293q0 -39 5.5 -74t20.5 -61.5t41 -41.5t67 -15q34 0 66 12.5t58 34.5t45.5 50t29.5 60v328h50v-520h-49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H.sc",
    horizAdvX: 637,
    d: "M549 545v-545h-47v257h-368v-257h-46v545h46v-245h368v245h47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q.sc",
    horizAdvX: 647,
    d: "M490 51q-34 -26 -76 -40.5t-90 -14.5q-62 0 -113 23.5t-87.5 62t-56.5 88.5t-20 103q0 54 21 103.5t58.5 88t88 61t110.5 22.5q62 0 113 -24t87 -63t56 -88.5t20 -100.5q0 -57 -22.5 -108t-61.5 -89l67 -75h-48zM325 39q40 0 74 12t62 33l-71 80h48l49 -56q32 34 49.5 77 t17.5 88t-17 87.5t-48 74.5t-73 51.5t-92 19.5q-52 0 -94.5 -20.5t-72.5 -53.5t-46.5 -75t-16.5 -85q0 -45 17 -87.5t47.5 -74.5t73 -51.5t93.5 -19.5z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "A.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "Y.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "J.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "V.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "T.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "y.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    g2: "w.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0394",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0142",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "v",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "#",
    u2: "4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "$",
    u2: "3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "Y.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "W.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "V.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "T.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "y.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "X",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "six.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "four.lnum",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "U.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "zero.lnum",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "y.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0447",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0431",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0424",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0259",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u018F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u012B",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\u0129",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "0",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "(",
    u2: "(",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ")",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "J.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u044F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0434",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0414",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0410",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0408",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0394",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0259",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u018F",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u012B",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0129",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xF0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "two.lnum",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "three.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "seven.lnum",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    g2: "one.lnum",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "7",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "+",
    u2: "1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "A.sc",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "six.lnum",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "J.sc",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "V.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "four.lnum",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "U.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "zero.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    g2: "S.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0455",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044F",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u044D",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0447",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0437",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0436",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0434",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0431",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0430",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u042F",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0424",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0414",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0410",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0408",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u03BC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0394",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0259",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u018F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u012B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\u0129",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "\xF0",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "5",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "4",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "3",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "0",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "/",
    u2: "/",
    k: 247
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\xB0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "\\\\\\\\",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "X",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "0",
    u2: ")",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xF7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\xB0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "\\\\\\\\",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "V",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "1",
    u2: "+",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    g2: "W.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xF7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\xB0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "\\\\\\\\",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "2",
    u2: "V",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    g2: "W.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\xB0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "\\\\\\\\",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "V",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "3",
    u2: "7",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    g2: "W.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\xB0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "7",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "4",
    u2: "+",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\u2212",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "\xF7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "5",
    u2: "+",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "6",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\u2212",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xF7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xD7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xB7",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "\xA2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "=",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "5",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "4",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "/",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "7",
    u2: "+",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "8",
    u2: "V",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    g2: "W.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\xB0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "\\\\\\\\",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "9",
    u2: "7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ":",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ";",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    g2: "seven.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "=",
    u2: "3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "W.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "V.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "T.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "@",
    u2: "V",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "A.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "J.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u02BC",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0166",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "x",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "X",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "V",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0142",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u0131",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\u012B",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "E",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "A.sc",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Z.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "Y.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "X.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "W.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "J.sc",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "V.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "U.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "T.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "w.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "S.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "f_f_l",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "f_f_i",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    g2: "f_f",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0259",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u018F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0131",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u012B",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0129",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xDF",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "@",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "7",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "5",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "4",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "3",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "2",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "/",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "&",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u012B",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0129",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "K",
    u2: "\u0104",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0166",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "A.sc",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    g2: "J.sc",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u02BC",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0259",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "X",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "4",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "/",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0165",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0159",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0131",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u012B",
    k: -57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\u0129",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "A.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "J.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "S.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u02BC",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0259",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u018F",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0131",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u012B",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0129",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xAE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xA9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "@",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "8",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "6",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "4",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "/",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0159",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0131",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u012B",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\u0129",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "Y.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "V.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "y.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "w.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0259",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u018F",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u012B",
    k: -63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0129",
    k: -36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xAE",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xA9",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: " ",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0159",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0131",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u012B",
    k: -52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0129",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0131",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u012B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Z",
    u2: "\u0129",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0141",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\u0110",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "[",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "Y.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "W.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "V.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "T.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "zero.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "y.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    g2: "w.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u04B1",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u04B0",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u044A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0447",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0442",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u042A",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0427",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0424",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0422",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0416",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "\u0166",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "v",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "V",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\\\\\\\\",
    u2: "7",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "a",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0135",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012D",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u012B",
    k: -106
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0129",
    k: -77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEF",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEE",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEC",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "\u0135",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "g",
    u2: "W",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "h",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "\u0135",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "j",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "m",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "j",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "q",
    u2: "W",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "s",
    u2: "\xD0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "t",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u02BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\u0259",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xF0",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: "/",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "v",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "w",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0259",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "V",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "y",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "z",
    u2: "\xD0",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "{",
    u2: "\xF0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "\u0135",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "|",
    u2: "j",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA1",
    u2: "V",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA3",
    g2: "four.lnum",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "\u0135",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xA6",
    u2: "j",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xAB",
    u2: "\u0166",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    g2: "four.lnum",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "9",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "3",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB0",
    u2: "0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "seven.lnum",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    g2: "one.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "4",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "3",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xB7",
    u2: "1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBB",
    u2: "\u0166",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "A.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "t.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Z.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "l.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "Y.sc",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "X.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "J.sc",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "W.alt",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "V.sc",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "U.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "T.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "y.alt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "w.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    g2: "S.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0259",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u018F",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0142",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0141",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0135",
    k: -94
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u012F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0126",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0110",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xF0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xD0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "x",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "j",
    k: -86
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC6",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC8",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC9",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCA",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xCB",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    g2: "seven.lnum",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "7",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD7",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "A.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    g2: "W.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u2122",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "\\\\\\\\",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "V",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "/",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: "*",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDE",
    u2: ")",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "W.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "y.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\xD0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "x",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "X",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDF",
    u2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "W.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "seven.lnum",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    g2: "one.lnum",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "7",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "3",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "2",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF7",
    u2: "1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "\xD0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "j",
    k: -89
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0105",
    u2: "j",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0108",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "\u0166",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2122",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u201D",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u2019",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0133",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xFE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xDF",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "}",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "]",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\\\\\\\\",
    k: -41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: ")",
    k: -37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0112",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0114",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0116",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\u01FC",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0118",
    u2: "\xC6",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011A",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011D",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011F",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0121",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0123",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "A.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "d.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "q.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    g2: "a.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0121",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xF0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "q",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "g",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0126",
    u2: "d",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2122",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u201D",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\u2019",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "}",
    k: -22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "]",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "\\\\\\\\",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: "*",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0129",
    u2: ")",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\u2122",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "\\\\\\\\",
    k: -47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: "*",
    k: -26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012B",
    u2: ")",
    k: -34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u012F",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0133",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0135",
    u2: "j",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u012B",
    k: -54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0136",
    u2: "\u0104",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0166",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0166",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013C",
    u2: "j",
    k: -76
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0166",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u2122",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\\\\\\\\",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\u0104",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014B",
    u2: "j",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\u01FC",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0152",
    u2: "\xC6",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "\xD0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015C",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0163",
    u2: "j",
    k: -126
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Q.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "H.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "u.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "P.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "A.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "d.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "D.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "G.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "q.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "O.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "F.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "N.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "M.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt2",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "a.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Z.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "L.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "Y.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "C.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "X.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "K.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "W.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "V.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "B.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "U.sc",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "E.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "y.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "w.alt",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "I.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "S.sc",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "R.sc",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\uFB06",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_l",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    g2: "f_i",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u203A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u2039",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u1ECC",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01FA",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u01F4",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u018F",
    k: 2
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0153",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0152",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0150",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014E",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u014C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0122",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0120",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011E",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u011C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u010A",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0108",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0106",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0104",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0102",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\u0100",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xF0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xE6",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD8",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD6",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD5",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD4",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD3",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xD2",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC7",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC5",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC3",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC2",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC1",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xC0",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xBB",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xAB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "\xA9",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "z",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "y",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "w",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "u",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "s",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "r",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "q",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "o",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "n",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "m",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "g",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "f",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "e",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "d",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "c",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "a",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "Q",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "O",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "G",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "C",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "A",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ";",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: ":",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "/",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0173",
    u2: "j",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u017D",
    u2: "\u012B",
    k: -46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u018F",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F4",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01F5",
    u2: "j",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u0166",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FC",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0218",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_l",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f_i",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_i",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    g2: "f_f",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021A",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u021B",
    u2: "j",
    k: -49
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "A.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "t.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Z.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "l.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "Y.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "X.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "W.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "J.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "V.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "U.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "y.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "w.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    g2: "S.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "x",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u02BC",
    u2: "v",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\u03C0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "\\\\\\\\",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "?",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0394",
    u2: "*",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03BC",
    u2: "\\\\\\\\",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u03C0",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u044A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0442",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u042A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0427",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0425",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0422",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0414",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\u0410",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "\\\\\\\\",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "?",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0402",
    u2: "*",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u042A",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0425",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0422",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0404",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0447",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0445",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0442",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0422",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0414",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0405",
    u2: "\u0410",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0455",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0437",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0436",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "\u0408",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0408",
    u2: "/",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u044A",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0442",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u042A",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\u0422",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "?",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u040B",
    u2: "*",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B1",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u04B0",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0455",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u044A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0447",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0442",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0431",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0430",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u042A",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0427",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0424",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0422",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\u0405",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "\\\\\\\\",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "?",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0410",
    u2: "*",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u04B1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u044A",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0445",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0442",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u042F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0425",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0414",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "\u0410",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0411",
    u2: "?",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04B1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u04B0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u044F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0436",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0434",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u042A",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0425",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0422",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0414",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0412",
    u2: "\u0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0414",
    u2: "\u0458",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u04B1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u044A",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0447",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0442",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0431",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0416",
    u2: "\u0424",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u04B0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u044F",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0436",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0434",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u042A",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0425",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0422",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0417",
    u2: "\u0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0434",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0425",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0417",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0416",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0414",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0410",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "\u0408",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0420",
    u2: "/",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0434",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0425",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0424",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0422",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0417",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0421",
    u2: "\u0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u04B1",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0455",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044F",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044D",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u044A",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0447",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0445",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0442",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0437",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0436",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0434",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0431",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0430",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042F",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u042D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0424",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0414",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0410",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "\u0408",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0422",
    u2: "/",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u04B0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0434",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042D",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u042A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0425",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0422",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0417",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0416",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0414",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0410",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\u0408",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "\\\\\\\\",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: "/",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0424",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u04B1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u044A",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0447",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0442",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0431",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u042D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0425",
    u2: "\u0424",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0426",
    u2: "\u0458",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0429",
    u2: "\u0458",
    k: -123
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u04B1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u044A",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\u0442",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "\\\\\\\\",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "?",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0430",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u04B1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u044A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0445",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0442",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0437",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0436",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\u0434",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "?",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0431",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0442",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "?",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0432",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0434",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\u0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0436",
    u2: "\\\\\\\\",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u04B1",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u044A",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0442",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\u0434",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "\\\\\\\\",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "?",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0437",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0441",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u044F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0434",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "\u0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0442",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0431",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0445",
    u2: "\u0430",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0446",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0449",
    u2: "\u0458",
    k: -119
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u0458",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\u0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "\\\\\\\\",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0452",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\u0434",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "\\\\\\\\",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "?",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0454",
    u2: "*",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\u0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "\\\\\\\\",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0455",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0458",
    u2: "\u0458",
    k: -18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\u044A",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\u0442",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "\\\\\\\\",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "?",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u045B",
    u2: "*",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u04B1",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044F",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044D",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u044A",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0447",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0445",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0442",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0437",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0436",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0434",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0431",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0430",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u042F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0424",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0414",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "\u0410",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B0",
    u2: "/",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u044F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u044D",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0434",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0431",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\u0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: "/",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u04B1",
    u2: ")",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E0C",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0141",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\u0110",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E5A",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E62",
    u2: "\u0166",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6C",
    u2: "\xDF",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E6D",
    u2: "j",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "\xDF",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EB8",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EBC",
    u2: "\xDF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECA",
    u2: "j",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECB",
    u2: "j",
    k: -48
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0166",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0141",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\u0110",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1ECC",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\u0141",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\u0110",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xDF",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF8",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2019",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201D",
    u2: "\u012B",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2039",
    u2: "\u0166",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u203A",
    u2: "\u0166",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "four.denominator",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    g2: "seven.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u20AC",
    u2: "3",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "A.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    g2: "J.sc",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2120",
    u2: "\xF0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "seven.lnum",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    g2: "one.lnum",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "7",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "3",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2212",
    u2: "1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0135",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012D",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u012B",
    k: -95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\u0129",
    k: -66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEF",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f_f",
    u2: "\xEE",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u2122",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\u02BC",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "\\\\\\\\",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "?",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "A.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "X.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "V.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\u02BC",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "\\\\\\\\",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "V",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    u2: "*",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\u0259",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xF0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\xD0",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "\\\\\\\\",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "X",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: "/",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u02BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\u0259",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xF0",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\xD0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "X",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "@",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: "/",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    u2: "\u02BC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "seven.lnum",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "one.lnum",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "\\\\\\\\",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: "/",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    u2: ")",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J.sc",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "@",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: "/",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    u2: " ",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "\\\\\\\\",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "X",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    u2: ")",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Z.sc",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "X.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "V.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\u02BC",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "\\\\\\\\",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "X",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    u2: "*",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "S.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "\u02BC",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "@",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "U.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u02BC",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0259",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u018F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0159",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0131",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u012B",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\u0129",
    k: -28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xF0",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xDF",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xAE",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "\xA9",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "@",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "9",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "6",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "4",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: "&",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    u2: " ",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "J.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\u02BC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "\\\\\\\\",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: "V",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J.sc",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "S.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "\u02BC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "@",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: "/",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: ")",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "j.alt",
    u2: "j",
    k: -65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    u2: "\u02BC",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    u2: "\u02BC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "A.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "V.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u2122",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\u02BC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "\\\\\\\\",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "V",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "?",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    u2: "*",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A.sc",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "S.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "\u02BC",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "X",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "@",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: "/",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: ")",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y.sc",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "V.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T.sc",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2122",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u2120",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\u02BC",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xBA",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xB7",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAE",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xAA",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\xA9",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "\\\\\\\\",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "V",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "?",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: "*",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    u2: " ",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "\u02BC",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    u2: "V",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    g2: "seven.lnum",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: "/",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    u2: ")",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\u02BC",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "v",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "\\\\\\\\",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "?",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    u2: "*",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "four.lnum",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "zero.lnum",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\xB0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "\\\\\\\\",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    u2: "+",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A.sc",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J.sc",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "S.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "\u02BC",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: "/",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    u2: " ",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "q.alt",
    u2: "j",
    k: -64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u2122",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u02BC",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\u0166",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "v",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "\\\\\\\\",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "X",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "V",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    u2: "/",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "V.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\u02BC",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\xD0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "\\\\\\\\",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "V",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "?",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    u2: "*",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "six.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "seven.lnum",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "four.lnum",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "zero.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\u2212",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xF7",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xD7",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xB7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\xA2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "\\\\\\\\",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "=",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "/",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "+",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    u2: "#",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.lnum",
    g2: "seven.lnum",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "X.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "V.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u2122",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\u02BC",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "\\\\\\\\",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "X",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "?",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: "*",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    u2: ")",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u02BC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\u0259",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "\xF0",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "X",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "V",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "@",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: "/",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    u2: " ",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d.alt",
    u2: "\u02BC",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "four.lnum",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    u2: "\xF7",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    u2: "+",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y.sc",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W.sc",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "V.sc",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T.sc",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "S.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2122",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u2120",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\u02BC",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xD0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xBA",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAE",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xAA",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\xA9",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "\\\\\\\\",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "V",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "?",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: "*",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    u2: " ",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "X.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J.sc",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "V.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\u02BC",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "\\\\\\\\",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "X",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "V",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: "/",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: ")",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.sc",
    u2: "\xD0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "J,Jcircumflex",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "AE,AEacute",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "quoteright,quotedblright",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quotedbl,quotesingle",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "AE,AEacute",
    k: -56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "quoteright,quotedblright",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J,Jcircumflex",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "space",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "slash",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "zero",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "three",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "five",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "nine",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "at",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "eth",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0394",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotleft,guilsinglleft",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "guillemotright,guilsinglright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "S.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "four.lnum",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0408",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0410",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0430",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0414",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0409,uni041B",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni043B,uni0459",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "uni0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,Jcircumflex",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0409,uni041B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni043B,uni0459",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quotedbl,quotesingle",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J,Jcircumflex",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "three",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "four",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0394",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "J.sc",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "A.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0408",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "two",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "v",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "x",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "w.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "y.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "T.sc",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "W.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "X.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Y.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "Z.sc",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "one.lnum",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "seven.lnum",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0416",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0422",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni040E,uni0423",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0425",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0427",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni042A",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0402,uni040B",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0436",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0437",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0442",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0443,uni045E",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0445",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni0447",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni044A",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni04B0",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,uni00AD,endash,emdash",
    g2: "uni04B1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quotedbl,quotesingle",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteright,quotedblright",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "seven",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "v",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "w.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "y.alt",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "T.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "V.sc",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.alt",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "W.sc",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Y.sc",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0422",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni040E,uni0423",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0427",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni042A",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0402,uni040B",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0442",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0443,uni045E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0447",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni044A",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni04B0",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni04B1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "Schwa",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "quoteleft,quotedblleft",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "zero.lnum",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0404,uni041E,uni0421",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase",
    g2: "uni0424",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,Jcircumflex",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0409,uni041B",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni043B,uni0459",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0443,uni045E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0404,uni041E,uni0421",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni03A9,Omega",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "quotedbl,quotesingle",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "AE,AEacute",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two",
    g2: "AE,AEacute",
    k: -12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "quotedbl,quotesingle",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "AE,AEacute",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "J,Jcircumflex",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "AE,AEacute",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "quotedbl,quotesingle",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni0422",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni042A",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni0402,uni040B",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "uni04B0",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quotedbl,quotesingle",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "at",
    g2: "quoteright,quotedblright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quotedbl,quotesingle",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "AE,AEacute",
    k: -40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "quoteright,quotedblright",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0409,uni041B",
    k: -6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0402,uni040B",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0443,uni045E",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "uni0404,uni041E,uni0421",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "exclamdown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "periodcentered",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "J,Jcircumflex",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "eth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0394",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "S.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0408",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0410",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0414",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0409,uni041B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0434",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni043B,uni0459",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni044D",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "Schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,Jcircumflex",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "slash",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "at",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "eth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotleft,guilsinglleft",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "guillemotright,guilsinglright",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "S.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A.sc",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0408",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0410",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0414",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0409,uni041B",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0434",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni043B,uni0459",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni044D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0455",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "Schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0404,uni041E,uni0421",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quotedbl,quotesingle",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0414",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni043B,uni0459",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T.sc",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0422",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni040E,uni0423",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni042A",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0402,uni040B",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0442",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni044A",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni04B0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quotedbl,quotesingle",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J,Jcircumflex",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "quoteright,quotedblright",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0394",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "J.sc",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A.sc",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0408",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0410",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0414",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0409,uni041B",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0434",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni043B,uni0459",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni044D",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y.sc",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0416",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0422",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni040E,uni0423",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0425",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0427",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni042A",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0402,uni040B",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0436",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0437",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0442",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0443,uni045E",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0445",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni044A",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni04B0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni04B1",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "pi",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni042F",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "J,Jcircumflex",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "servicemark",
    g2: "AE,AEacute",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.lnum",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.lnum",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "AE,AEacute",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0404,uni041E,uni0421",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "b,h,k,germandbls,thorn,hcircumflex,hbar,kcommaaccent,hdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "apostrophe",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "zero",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "at",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "seven",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "y.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "V.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y.sc",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Schwa",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "t.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "asterisk",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "six",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "question",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "backslash",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "copyright",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordfeminine",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "registered",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "ordmasculine",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "apostrophe",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "servicemark",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "trademark",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U.sc",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "J.sc",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "X",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J,Jcircumflex",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "slash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "four",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "J.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "V",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "X",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "x",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "W.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "backslash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "apostrophe",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Dcaron,Dcroat,Ddotbelow",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "eth",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "schwa",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "guillemotleft,guilsinglleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "seven",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "w.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "y.alt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "T.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Y.sc",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "Schwa",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "apostrophe",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,Edotbelow,Etilde",
    g2: "U.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,Jcircumflex",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotleft,guilsinglleft",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotright,guilsinglright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "colon,semicolon",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "v",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "y.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "V.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "W.sc",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Gacute",
    g2: "apostrophe",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "eth",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "H,I,M,N,Igrave,Iacute,Icircumflex,Idieresis,Ntilde,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,Nacute,Ncommaaccent,Ncaron,Eng,Hdotbelow,Ndotaccent,Idotbelow",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J,Jcircumflex",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "AE,AEacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "slash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "eth",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "schwa",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "J.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "A.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,IJ,Jcircumflex",
    g2: "apostrophe",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "space",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "zero",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "eth",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "schwa",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "y.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "T.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "W.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Y.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "Schwa",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "copyright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "registered",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "apostrophe",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "U.sc",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quotedbl,quotesingle",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 121
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "AE,AEacute",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteright,quotedblright",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "eth",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "schwa",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "guillemotleft,guilsinglleft",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "seven",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "v",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "w.alt",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "y.alt",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "T.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "V.sc",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.alt",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "W.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Y.sc",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "Schwa",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "asterisk",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "question",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "backslash",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "copyright",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordfeminine",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "registered",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "ordmasculine",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "apostrophe",
    k: 156
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "servicemark",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "trademark",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "U.sc",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Ldot,Lslash",
    g2: "periodcentered",
    k: 159
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J,Jcircumflex",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "AE,AEacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "slash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "four",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "J.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "A.sc",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "V",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "X",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "W.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "backslash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "apostrophe",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Schwa,Oslashacute,Odotbelow",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "J,Jcircumflex",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "AE,AEacute",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "eth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "schwa",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,j.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron,Rdotbelow",
    g2: "apostrophe",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "seven",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "x",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "w.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "T.sc",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "V.sc",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "Y.sc",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "t.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "ordfeminine",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    g2: "apostrophe",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J,Jcircumflex",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "AE,AEacute",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "space",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "slash",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "zero",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "three",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "four",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "five",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "nine",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "at",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eth",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "schwa",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "S.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "J.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "A.sc",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "one",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "two",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "seven",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "v",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "x",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "w.alt",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "y.alt",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "T.sc",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "V.sc",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "W.sc",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "X.sc",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Y.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Z.sc",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "Schwa",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "t.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "six",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "copyright",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "registered",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "apostrophe",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "U.sc",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "colon,semicolon",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "ampersand",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    g2: "eight",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J,Jcircumflex",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "AE,AEacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "slash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "four",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "schwa",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "J.sc",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "A.sc",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "l,lacute,lcommaaccent,lcaron,ldot,lslash",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    g2: "apostrophe",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "space",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "zero",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "three",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "four",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "five",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "nine",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "at",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eth",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S.sc",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J.sc",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A.sc",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "one",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "two",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Schwa",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "six",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "copyright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "registered",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "apostrophe",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "U.sc",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "eight",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J,Jcircumflex",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "AE,AEacute",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "space",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "slash",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "zero",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "three",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "four",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "five",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "nine",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "at",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eth",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "schwa",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "guillemotright,guilsinglright",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S.sc",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "J.sc",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "A.sc",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "one",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "two",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "v",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "x",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "w.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "y.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "V.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "W.sc",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "X.sc",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Y.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "Schwa",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "t.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "six",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "copyright",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "registered",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "apostrophe",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "U.sc",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "colon,semicolon",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "ampersand",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    g2: "eight",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "zero",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "eth",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "schwa",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "w.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "V.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "W.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Y.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "Schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "copyright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "registered",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "apostrophe",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni01C4,uni01F1,Zdotbelow",
    g2: "U.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quotedbl,quotesingle",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "J,Jcircumflex",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "AE,AEacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteright,quotedblright",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Thorn",
    g2: "quoteleft,quotedblleft",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "J,Jcircumflex",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "guillemotright,guilsinglright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "m,n,p,r,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,racute,rcommaaccent,rcaron,ndotaccent,rdotbelow",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow,u.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "R.sc,I.sc,E.sc,B.sc,K.sc,L.sc,M.sc,N.sc,F.sc,D.sc,P.sc,H.sc",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.alt",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "J,Jcircumflex",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "AE,AEacute",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "y.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "t.alt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "backslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "apostrophe",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quotedbl,quotesingle",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "J,Jcircumflex",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteright,quotedblright",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "V",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "v",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "W.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "quoteleft,quotedblleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "asterisk",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "question",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "backslash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "apostrophe",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "servicemark",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "trademark",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "parenright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "bracketright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "eth",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "y.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "W.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "asterisk",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "question",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "backslash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "apostrophe",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "d,dcaron,dcroat,ddotbelow",
    g2: "apostrophe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "J,Jcircumflex",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "V",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "x",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "w.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "W.alt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "backslash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "apostrophe",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,edotbelow,etilde",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "J,Jcircumflex",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: -44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "AE,AEacute",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "space",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "at",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "eth",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotleft,guilsinglleft",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotright,guilsinglright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "V",
    k: -42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "X",
    k: -50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "W.alt",
    k: -32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "backslash",
    k: -38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "apostrophe",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "trademark",
    k: -39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "V",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "v",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "w.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "y.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "asterisk",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "backslash",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "apostrophe",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,hcircumflex,hbar,hdotbelow",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "i,j,igrave,iacute,icircumflex,idieresis,itilde,imacron,ibreve,iogonek,dotlessi,ij,jcircumflex,dotlessj,idotbelow,f_i,f_f_i,j.alt",
    g2: "apostrophe",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "eth",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "schwa",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "V",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "apostrophe",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "AE,AEacute",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "space",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "V",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "y.alt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "asterisk",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "copyright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordfeminine",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "registered",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "ordmasculine",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "servicemark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "trademark",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "l,lacute,lcommaaccent,lcaron,lslash,f_l,f_f_l",
    g2: "periodcentered",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "V",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "v",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "y.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "W.alt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "t.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "asterisk",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "question",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "backslash",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "apostrophe",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "m,n,ntilde,nacute,ncommaaccent,ncaron,napostrophe,eng,ndotaccent",
    g2: "trademark",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "J,Jcircumflex",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteright,quotedblright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "V",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "X",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "v",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "w.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "y.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "W.alt",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "S,Sacute,Scircumflex,uni015E,Scaron,uni0218,Sdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "t.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "asterisk",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "backslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "apostrophe",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "servicemark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "trademark",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,odotbelow",
    g2: "parenright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "J,Jcircumflex",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "AE,AEacute",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "space",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "slash",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "at",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "eth",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "schwa",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "guillemotright,guilsinglright",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "X",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron,rdotbelow",
    g2: "apostrophe",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "V",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "v",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "w.alt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "y.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "backslash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "apostrophe",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow",
    g2: "trademark",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "eth",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "schwa",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "backslash",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,uni0163,tcaron,tbar,uni021B,tdotbelow,s_t,c_t",
    g2: "apostrophe",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "V",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "backslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "u,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek,udotbelow",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "at",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "eth",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "X",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "apostrophe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "space",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "slash",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "at",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "eth",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "schwa",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "V",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "X",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "apostrophe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "eth",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "schwa",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "V",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron,uni01C5,uni01C6,uni01F2,uni01F3,zdotbelow",
    g2: "apostrophe",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "B,D,E,F,H,I,K,L,M,N,P,R,Egrave,Eacute,Ecircumflex,Edieresis,Igrave,Iacute,Icircumflex,Idieresis,Eth,Ntilde,Thorn,Dcaron,Dcroat,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,Hcircumflex,Hbar,Itilde,Imacron,Ibreve,Iogonek,Idotaccent,IJ,Kcommaaccent,Lacute,Lcommaaccent,Lcaron,Lslash,Nacute,Ncommaaccent,Ncaron,Eng,Racute,Rcommaaccent,Rcaron,Ddotbelow,Hdotbelow,Ndotaccent,Rdotbelow,Edotbelow,Etilde,Idotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "J,Jcircumflex",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "AE,AEacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "z,zacute,zdotaccent,zcaron,zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eth",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "J,Jcircumflex",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "AE,AEacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "AE,AEacute",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "s,sacute,scircumflex,uni015F,scaron,uni0219,sdotbelow,s_t",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "V",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "X",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "W.alt",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "backslash",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,q,gcircumflex,gbreve,gdotaccent,gcommaaccent,gacute,a.alt,q.alt,u.alt",
    g2: "apostrophe",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quotedbl,quotesingle",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,ygrave,ytilde",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "quoteleft,quotedblleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "f,f_f,f_i,f_l,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a.alt2",
    g2: "t,uni0163,tcaron,tbar,uni021B,tdotbelow",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "J,Jcircumflex",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "AE,AEacute",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,a.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "d,g,q,dcaron,dcroat,gcircumflex,gbreve,gdotaccent,gcommaaccent,uni01C6,uni01F3,gacute,ddotbelow,a.alt,q.alt,d.alt",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,edotbelow,etilde,odotbelow,c_t",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "guillemotright,guilsinglright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "quotedbl,quotesingle",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "quoteright,quotedblright",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "guillemotleft,guilsinglleft",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "uni03A9,Omega",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A9,Omega",
    g2: "uni0394",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A9,Omega",
    g2: "backslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "pi",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "pi",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R.sc",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "V",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "I.sc,M.sc,N.sc,H.sc",
    g2: "apostrophe",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "J,Jcircumflex",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "AE,AEacute",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "guillemotright,guilsinglright",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "J,Jcircumflex",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "AE,AEacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B.sc",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "J,Jcircumflex",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "J,Jcircumflex",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "AE,AEacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "guillemotright,guilsinglright",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C.sc",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "J,Jcircumflex",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "AE,AEacute",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "guillemotright,guilsinglright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quotedbl,quotesingle",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "AE,AEacute",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteright,quotedblright",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "guillemotright,guilsinglright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L.sc",
    g2: "quoteleft,quotedblleft",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "J,Jcircumflex",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "AE,AEacute",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "guillemotright,guilsinglright",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quotedbl,quotesingle",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J,Jcircumflex",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteright,quotedblright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "J.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "A.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "T.sc",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "V.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "W.sc",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "X.sc",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Y.sc",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "Z.sc",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "quoteleft,quotedblleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "asterisk",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "question",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "backslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "apostrophe",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "trademark",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O.sc,Q.sc",
    g2: "parenright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quotedbl,quotesingle",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteright,quotedblright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G.sc",
    g2: "quoteleft,quotedblleft",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "J,Jcircumflex",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteright,quotedblright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D.sc",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quotedbl,quotesingle",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteright,quotedblright",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C.sc,O.sc,G.sc,Q.sc",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Gacute,Oslashacute,Odotbelow,G.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek,Udotbelow",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A.sc",
    g2: "quoteleft,quotedblleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "J,Jcircumflex",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "T,uni0162,Tcaron,Tbar,uni021A,Tdotbelow",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave,Ytilde",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "AE,AEacute",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P.sc",
    g2: "Z,Zacute,Zdotaccent,Zcaron,Zdotbelow",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni0409,uni041B",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni043B,uni0459",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0408",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quotedbl,quotesingle",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quoteright,quotedblright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni040E,uni0423",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0402,uni040B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0443,uni045E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quoteleft,quotedblleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quotedbl,quotesingle",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quoteright,quotedblright",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni040E,uni0423",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0402,uni040B",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0443,uni045E",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "quoteleft,quotedblleft",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0410",
    g2: "uni0404,uni041E,uni0421",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0409,uni041B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni040E,uni0423",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0443,uni045E",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0409,uni041B",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni043B,uni0459",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni040E,uni0423",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0402,uni040B",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0412",
    g2: "uni0443,uni045E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "guillemotleft,guilsinglleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0430",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni044D",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0455",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0442",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0443,uni045E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni044A",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni04B1",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0404,uni041E,uni0421",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0424",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0431",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni042D",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0405",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0401,uni0415",
    g2: "uni0417",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0443,uni045E",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0416",
    g2: "uni0404,uni041E,uni0421",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "slash",
    k: -9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "guillemotleft,guilsinglleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0442",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0443,uni045E",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0447",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni044A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni04B1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0404,uni041E,uni0421",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0424",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040C,uni041A",
    g2: "uni0431",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "slash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0408",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0410",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0414",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0409,uni041B",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0434",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni043B,uni0459",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0416",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0422",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni040E,uni0423",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0425",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042A",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0402,uni040B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0436",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0445",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni04B0",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "backslash",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "parenright",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni042D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni041E,uni042D,uni042E",
    g2: "uni0417",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni0409,uni041B",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni043B,uni0459",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0420",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0421",
    g2: "uni0409,uni041B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0421",
    g2: "uni0404,uni041E,uni0421",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "guillemotleft,guilsinglleft",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "guillemotright,guilsinglright",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0409,uni041B",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni043B,uni0459",
    k: 108
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0443,uni045E",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0404,uni041E,uni0421",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0422",
    g2: "colon,semicolon",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "slash",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "guillemotleft,guilsinglleft",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "guillemotright,guilsinglright",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0408",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0410",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0430",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0414",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0409,uni041B",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0434",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni043B,uni0459",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni044D",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni044F",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0455",
    k: 64
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0436",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0437",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0443,uni045E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0445",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0447",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni04B1",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0404,uni041E,uni0421",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0424",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0431",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni042F",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "colon,semicolon",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni042D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0405",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "uni0417",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423",
    g2: "exclam",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni0409,uni041B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni043B,uni0459",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni040E,uni0423",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0424",
    g2: "uni0402,uni040B",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "guillemotleft,guilsinglleft",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0443,uni045E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0404,uni041E,uni0421",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0425",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quotedbl,quotesingle",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quoteright,quotedblright",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0410",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0409,uni041B",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0422",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni040E,uni0423",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0425",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0427",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni042A",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0402,uni040B",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0442",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0443,uni045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni0445",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni044A",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni04B0",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "uni04B1",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "quoteleft,quotedblleft",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "asterisk",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "question",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C",
    g2: "backslash",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quotedbl,quotesingle",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quoteright,quotedblright",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0409,uni041B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni040E,uni0423",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0402,uni040B",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0443,uni045E",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quoteleft,quotedblleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0404",
    g2: "uni0409,uni041B",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0404",
    g2: "uni0404,uni041E,uni0421",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni0409,uni041B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0405",
    g2: "uni0443,uni045E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 79
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "slash",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "guillemotleft,guilsinglleft",
    k: 126
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "guillemotright,guilsinglright",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0408",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0410",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0430",
    k: 160
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0414",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0409,uni041B",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0434",
    k: 183
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni043B,uni0459",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 189
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044D",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044F",
    k: 174
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0455",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0436",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0437",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0442",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0443,uni045E",
    k: 101
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0445",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0447",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni044A",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni04B1",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0404,uni041E,uni0421",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0424",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni0431",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni042F",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "colon,semicolon",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0403,uni0413,uni0490",
    g2: "uni042D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0443,uni045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0447",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni04B1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0404,uni041E,uni0421",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0431",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414,uni0426,uni0429",
    g2: "uni0456,uni0457,uni0458",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0409,uni041B",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni043B,uni0459",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni040E,uni0423",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0402,uni040B",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0417",
    g2: "uni0443,uni045E",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0434",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni044F",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0406,uni0407,uni040D,uni040F,uni0418,uni0419,uni041B,uni041C,uni041D,uni041F,uni0427,uni0428,uni042B,uni042F",
    g2: "uni0455",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "guillemotleft,guilsinglleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "guillemotright,guilsinglright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0409,uni041B",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni043B,uni0459",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0443,uni045E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0404,uni041E,uni0421",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "colon,semicolon",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quotedbl,quotesingle",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quoteright,quotedblright",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0430",
    g2: "quoteleft,quotedblleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "quotedbl,quotesingle",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "uni043B,uni0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0431",
    g2: "uni0443,uni045E",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "uni043B,uni0459",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "slash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "guillemotleft,guilsinglleft",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "guillemotright,guilsinglright",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0430",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0434",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni043B,uni0459",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491",
    g2: "uni044F",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0443,uni045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0447",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "uni0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "asterisk",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "question",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434,uni0446,uni0449",
    g2: "backslash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quotedbl,quotesingle",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quoteright,quotedblright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0434",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni043B,uni0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0436",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0437",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0442",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0443,uni045E",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni0445",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni044A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "uni04B1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "quoteleft,quotedblleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "asterisk",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "question",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "backslash",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0435,uni0451",
    g2: "parenright",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0436",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quoteright,quotedblright",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "uni043B,uni0459",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "uni0443,uni045E",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0437",
    g2: "quoteleft,quotedblleft",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0438,uni0439,uni043B,uni043C,uni043D,uni043F,uni0447,uni0448,uni044B,uni044F,uni045D,uni045F",
    g2: "backslash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "guillemotleft,guilsinglleft",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0430",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "uni0431",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043A,uni045C",
    g2: "backslash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quoteright,quotedblright",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0434",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni043B,uni0459",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044D",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0436",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0437",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0442",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0443,uni045E",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni0445",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni044A",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "uni04B1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "quoteleft,quotedblleft",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "asterisk",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "question",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "backslash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043E,uni0440,uni0444,uni044D,uni044E",
    g2: "parenright",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "guillemotleft,guilsinglleft",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "uni0443,uni045E",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0441",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "guillemotleft,guilsinglleft",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "guillemotright,guilsinglright",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni043B,uni0459",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "slash",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0430",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0434",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni043B,uni0459",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni044D",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni044F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0455",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0437",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "uni0431",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "backslash",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0443,uni045E",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "guillemotleft,guilsinglleft",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0445",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quotedbl,quotesingle",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quoteright,quotedblright",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0442",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0443,uni045E",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0445",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni0447",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni044A",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "uni04B1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "quoteleft,quotedblleft",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "asterisk",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "question",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A",
    g2: "backslash",
    k: 78
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "uni0443,uni045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0452",
    g2: "quoteleft,quotedblleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "quotedbl,quotesingle",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "quoteright,quotedblright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "uni0443,uni045E",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0454",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "quotedbl,quotesingle",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "quoteright,quotedblright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "uni0443,uni045E",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0455",
    g2: "quoteleft,quotedblleft",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quotedbl,quotesingle",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quoteright,quotedblright",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "uni0443,uni045E",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni045B",
    g2: "quoteleft,quotedblleft",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "hyphen,uni00AD,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "guillemotleft,guilsinglleft",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "uni043B,uni0459",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B1",
    g2: "uni0435,uni043E,uni0441,uni0444,uni0451,uni0454",
    k: 19
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRalewayLight);
export default __webpack_public_path__ + "static/media/Raleway-Light.0076c25508fa520a83195ff411293d41.svg";
export { ForwardRef as ReactComponent };